const allStores = [
  {
    id: "2001",
    name: "Pittodrie Esso Express",
    region: "Scotland",
    country: "GB",
    uuid: "d7985d5f-d2c6-4414-adca-4300025eca5a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "2003",
    name: "Twickenham King Street Express",
    region: "England",
    country: "GB",
    uuid: "6890b271-577c-4242-963a-920b49d669a5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2004",
    name: "Croydon Addiscombe Esso Express",
    region: "England",
    country: "GB",
    uuid: "1841e03c-b2af-47e1-9e6c-e162e0efdc17",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2005",
    name: "Northampton Abington Esso Express",
    region: "England",
    country: "GB",
    uuid: "05cb7cae-c6d3-4da5-9087-a660935bc330",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2007",
    name: "Aberdeen Extra",
    region: "Scotland",
    country: "GB",
    uuid: "a69adeb6-e29a-4f4f-a88f-b644813d32cb",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2008",
    name: "Abingdon Extra",
    region: "England",
    country: "GB",
    uuid: "3d8e7c1b-3478-4fcd-8087-baac42549bce",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2011",
    name: "Abergavenny Frogmore Street Express",
    region: "Wales",
    country: "GB",
    uuid: "9fabd8cd-f0b6-4c27-adc6-d0e07f8e46f7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "2012",
    name: "Acton Esso Express",
    region: "England",
    country: "GB",
    uuid: "270ff788-081b-49dc-94c6-9b33b15a6127",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2013",
    name: "Swindon Abbey Meads Express",
    region: "England",
    country: "GB",
    uuid: "3d0adf37-deaa-40d0-b833-87506f2a4da7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2015",
    name: "Aberdare Superstore",
    region: "England",
    country: "GB",
    uuid: "098a7bdb-b2f4-4b16-b3b1-3c853297628c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2018",
    name: "Dundee Station Express",
    region: "Scotland",
    country: "GB",
    uuid: "9208c2df-1748-499b-8f0b-e84a341277a8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "2019",
    name: "Altrincham Extra",
    region: "England",
    country: "GB",
    uuid: "23e0eaaa-7d4a-448d-9c09-d585987bef16",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2020",
    name: "Amersham Superstore",
    region: "England",
    country: "GB",
    uuid: "accbabe3-8032-483f-a84a-35c4e9e2c88a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2022",
    name: "Liverpool Allerton Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "aa130154-bf5e-4d65-b4a4-7f4a850bcf47",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2025",
    name: "Aldershot Superstore",
    region: "England",
    country: "GB",
    uuid: "cb337a53-d1ee-4b86-9798-d1c1af0f0df5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2026",
    name: "Strutton Ground Express",
    region: "England",
    country: "GB",
    uuid: "356fabcc-c542-4122-8bf4-2e2ac67fa425",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2028",
    name: "Armthorpe Express",
    region: "England",
    country: "GB",
    uuid: "8ab4989d-101e-449a-9d0b-5fabacaa1e75",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2030",
    name: "Andover Extra",
    region: "England",
    country: "GB",
    uuid: "d4d0ff17-3232-4571-90db-aded4a12986f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2031",
    name: "Ashford Crooksfoot Extra",
    region: "England",
    country: "GB",
    uuid: "1d1363a9-27b9-40f5-baae-0e1763f3c85c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2032",
    name: "Andover Cricketers Express",
    region: "England",
    country: "GB",
    uuid: "2fde8ec9-1a90-4736-989a-88ecef61b424",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2034",
    name: "Keldholme Lane Express",
    region: "England",
    country: "GB",
    uuid: "9d27e60c-236b-40d6-b3ba-9a090a724013",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2036",
    name: "Lambs Farm Road Express",
    region: "England",
    country: "GB",
    uuid: "ae0ad265-3f61-40e6-97a2-5d0a55e3e71f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2038",
    name: "Aylesbury Extra",
    region: "England",
    country: "GB",
    uuid: "6873b4d9-0059-40c0-83ca-e460808277e1",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2039",
    name: "Ashford Park Farm Extra",
    region: "England",
    country: "GB",
    uuid: "24553953-db91-4a57-804d-fb82a9a07a65",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2040",
    name: "Alloa Extra",
    region: "Scotland",
    country: "GB",
    uuid: "7c6986d2-f972-4c70-860c-a3c1b87dc9d3",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2041",
    name: "Aylesbury Tring Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "162c33a3-472b-4b35-a014-5f47276ff93d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2042",
    name: "Ayr Extra",
    region: "Scotland",
    country: "GB",
    uuid: "776078ca-c2a2-4dd6-9f4e-c35f54b1afb7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2044",
    name: "Ashby De La Zouch Extra",
    region: "England",
    country: "GB",
    uuid: "f2d6b5bd-aee9-414f-8c70-7332231a6afc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2045",
    name: "Auchinleck Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "0772295e-8253-486a-8dc9-0e3c29ffe07b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2047",
    name: "Ashford Middlesex Extra",
    region: "England",
    country: "GB",
    uuid: "3e2d3ef6-b320-496e-9f20-58547762e541",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2049",
    name: "Alfreton Superstore",
    region: "England",
    country: "GB",
    uuid: "a7ac8b88-5c0e-4658-87ce-8631f2277699",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2050",
    name: "Baguley Extra",
    region: "England",
    country: "GB",
    uuid: "a4f0f7fe-4183-4cc3-8ff1-929016da2dea",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2053",
    name: "Yate Wellington Express",
    region: "England",
    country: "GB",
    uuid: "86ad72d4-78b6-4c80-9548-702047ba187d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2054",
    name: "Swindon Pinehurst",
    region: "England",
    country: "GB",
    uuid: "5970f5ce-c34d-458b-94e3-195b7341e31d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2055",
    name: "Baldock Extra",
    region: "England",
    country: "GB",
    uuid: "55614ad1-b689-47e4-8945-b8bdcd5b287b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2058",
    name: "Barking Esso Express",
    region: "England",
    country: "GB",
    uuid: "e9cade3e-8fd2-4c14-8c9e-81c8a30f520f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2059",
    name: "Bear Cross Express",
    region: "England",
    country: "GB",
    uuid: "545b8cdc-c08d-4e10-b76f-544b10a88ede",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2061",
    name: "Glasgow Barrhead Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "3c927ed8-6ad2-483b-96bc-9ea61cfbc8b7",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2062",
    name: "Osidge Hampden Square Express",
    region: "England",
    country: "GB",
    uuid: "c1de1607-2813-42b4-85af-f206e2399f5c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2064",
    name: "Banbury Extra",
    region: "England",
    country: "GB",
    uuid: "1935dca8-1b1b-4fd8-befb-4b403890eedc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2065",
    name: "Cambridge Bar Hill Extra",
    region: "England",
    country: "GB",
    uuid: "a9f90aa3-2ae3-4b04-9899-2c194360b12a",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2067",
    name: "Bathgate Blackburn Rd Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "f49a26d8-22e5-4e92-9591-2871d679a7a7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2068",
    name: "Sinfin Express",
    region: "England",
    country: "GB",
    uuid: "d28385ad-c147-40de-b21c-5ef7165ac3e0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2069",
    name: "Quartz Way",
    region: "England",
    country: "GB",
    uuid: "351b8b6f-31d2-46ae-8ca1-6864a7c563cb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2071",
    name: "Barnsley Extra",
    region: "England",
    country: "GB",
    uuid: "a084bcc9-c444-4dd7-bd1d-9293401611be",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2072",
    name: "Barking Superstore",
    region: "England",
    country: "GB",
    uuid: "01e0134b-6140-4c0a-8b5f-e5ddf70710ec",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2073",
    name: "Mayflower Retail Park Extra",
    region: "England",
    country: "GB",
    uuid: "e5606aca-0fea-4047-8578-9773705579f8",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2074",
    name: "Aylestone Lane Express",
    region: "England",
    country: "GB",
    uuid: "d65f4c36-30f8-45e1-bfb1-41eef11f1767",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2075",
    name: "Fulmar Drive Express",
    region: "England",
    country: "GB",
    uuid: "3a1419c6-371b-422a-af80-9835186a1be9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2076",
    name: "Pontefract Express",
    region: "England",
    country: "GB",
    uuid: "b670a301-7a15-483d-8814-ac22d69a7f1d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2078",
    name: "Ilford Superstore (Barkingside)",
    region: "England",
    country: "GB",
    uuid: "123d0930-6ee9-4d67-ba50-18b916a3c459",
    services: {
      collect: false,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2080",
    name: "Basingstoke Superstore",
    region: "England",
    country: "GB",
    uuid: "ae7246de-7ecc-4aa6-b57c-e5844f5ebc97",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2083",
    name: "Barnstaple Superstore",
    region: "England",
    country: "GB",
    uuid: "d0f3f1b5-fc69-4303-95c5-7409f38f315e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2084",
    name: "Huyton Hillside Express",
    region: "England",
    country: "GB",
    uuid: "c8515187-9365-412b-b6a1-1d0002041733",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2085",
    name: "Mowmacre Express",
    region: "England",
    country: "GB",
    uuid: "e21f06db-428c-4c70-b7d9-ba428f8492e1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2086",
    name: "Reeds Lane Express",
    region: "England",
    country: "GB",
    uuid: "3b2fc3c1-03a7-46a1-badb-df64993938bd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2087",
    name: "Bedford Riverfield Dr Superstore",
    region: "England",
    country: "GB",
    uuid: "53150924-6d6b-4c3c-8c1a-26628d0314ef",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2090",
    name: "Stretford Road Express",
    region: "England",
    country: "GB",
    uuid: "afd4c9b1-6462-4fd9-9c82-c8f74ac8cc7e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2091",
    name: "Cottingham Express",
    region: "England",
    country: "GB",
    uuid: "8e729627-bf0a-4ece-bf5b-3765d30edfb5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2093",
    name: "Monks Way Express",
    region: "England",
    country: "GB",
    uuid: "0c89fe9b-2ca4-48ab-ab22-956b674c1064",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2094",
    name: "Bexhill-on-sea Superstore",
    region: "England",
    country: "GB",
    uuid: "c164f3a0-01cc-45d9-837d-c4e70db7c37c",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2096",
    name: "Barrow-in-furness Extra",
    region: "England",
    country: "GB",
    uuid: "d351e17c-ee38-44af-8c2e-369f27b62be6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2098",
    name: "Birkenhead Bidston Moss Extra",
    region: "England",
    country: "GB",
    uuid: "f34dcdf3-b90f-4261-897c-cf66072d0070",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2101",
    name: "Bishop's Stortford Superstore",
    region: "England",
    country: "GB",
    uuid: "23a6ac36-4dce-4be1-9f24-449a4bbfa4f3",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2102",
    name: "Bognor Regis Superstore",
    region: "England",
    country: "GB",
    uuid: "8485b3e9-5448-4a43-9739-800598177eb9",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2103",
    name: "Blackpool Clifton Extra",
    region: "England",
    country: "GB",
    uuid: "f59cf873-6524-4232-8e59-585d4d0b98b6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2104",
    name: "Blackburn Superstore",
    region: "England",
    country: "GB",
    uuid: "e67d4f68-6678-47f1-902f-a928f8782b39",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2105",
    name: "Bedford Extra",
    region: "England",
    country: "GB",
    uuid: "22697501-9c18-478b-b91e-c7f6a014b09d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2106",
    name: "Whiteleas Way Express",
    region: "England",
    country: "GB",
    uuid: "6222b79f-d385-4e61-9648-a75ad14e0e84",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2108",
    name: "Boston Superstore",
    region: "England",
    country: "GB",
    uuid: "95cba27c-12f6-42e1-8b9d-6d65a8c8a1e5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2111",
    name: "Broadstone Express",
    region: "England",
    country: "GB",
    uuid: "1808041c-c096-40de-bf66-28edbd15a21e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2112",
    name: "Oldmixon Broadway Express",
    region: "England",
    country: "GB",
    uuid: "e4e3566a-f3e6-454e-a1a5-fc60875c7073",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2115",
    name: "Bracknell North Superstore",
    region: "England",
    country: "GB",
    uuid: "4f1a68fe-33bf-48f4-966c-361bb7481dc4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2117",
    name: "Blandford Forum Superstore",
    region: "England",
    country: "GB",
    uuid: "99741864-2ae9-449a-849c-b586a682d9d0",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2118",
    name: "Colchester Express",
    region: "England",
    country: "GB",
    uuid: "edbcbdac-bf00-4b69-9220-f5b34a67a3f3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2121",
    name: "Blackwood Newport Express",
    region: "Wales",
    country: "GB",
    uuid: "f13bfc92-2781-48c1-909a-7abd3ed1ebd1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "2122",
    name: "Wembley Extra",
    region: "England",
    country: "GB",
    uuid: "8d2878fc-3449-423e-be68-27a631ff7d69",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2123",
    name: "Bower Manor Express",
    region: "England",
    country: "GB",
    uuid: "94f8c613-ced9-4b2f-ac30-82598633872a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2126",
    name: "Borehamwood Extra",
    region: "England",
    country: "GB",
    uuid: "08b30974-ebf2-476e-8d36-6f9982eb02aa",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2128",
    name: "Osterley Extra",
    region: "England",
    country: "GB",
    uuid: "35e6d54a-ee56-4fb8-8cff-d5050b79e92e",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2129",
    name: "Bristol Broadmead Express",
    region: "England",
    country: "GB",
    uuid: "d42f4846-21bf-481d-b2e2-27599a006eb4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2132",
    name: "Bracknell Superstore",
    region: "England",
    country: "GB",
    uuid: "769769cb-07d8-49c0-b307-54f083878497",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2133",
    name: "Moor Lane Express",
    region: "England",
    country: "GB",
    uuid: "c2cd9fc9-3b01-42d0-8d60-0d866a4a0d4b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2136",
    name: "Bristol E Extra",
    region: "England",
    country: "GB",
    uuid: "5a5370bf-0660-4242-949d-7c5be444c128",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2137",
    name: "Howard Gardens Express",
    region: "Wales",
    country: "GB",
    uuid: "4e9a36d9-ab4d-4e65-aba1-f1d4b476a264",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "2139",
    name: "Bradford Buttershaw Superstore",
    region: "England",
    country: "GB",
    uuid: "ea5c24aa-556a-4590-afd2-dfa18d1f7845",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2141",
    name: "Bristol Brislington Extra",
    region: "England",
    country: "GB",
    uuid: "8ed679e8-eb87-43e2-9db3-0aa46da08f54",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2142",
    name: "Bury Superstore",
    region: "England",
    country: "GB",
    uuid: "a2edf2a8-daf9-4534-b795-106fd787d0dc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2145",
    name: "Wembley Watford Road Express",
    region: "England",
    country: "GB",
    uuid: "bb878357-d1a8-42ef-9e01-a8c18dd6d24e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2151",
    name: "Lime Trees Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "568f0b9b-1abc-46ba-88c7-bcaf4500a2e1",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2152",
    name: "Bromley By Bow Superstore",
    region: "England",
    country: "GB",
    uuid: "74bab65e-f489-4ff2-acbf-ded374500847",
    services: {
      collect: false,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2154",
    name: "Bridgend Extra",
    region: "Wales",
    country: "GB",
    uuid: "94115150-14c7-4306-9aa4-8e2faf1c7419",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2156",
    name: "Southampton Extra",
    region: "England",
    country: "GB",
    uuid: "37774749-e092-4129-93f4-759f05c7b885",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2158",
    name: "Burnham-on-sea Superstore",
    region: "England",
    country: "GB",
    uuid: "55c68613-4f7e-4a28-9d93-c434c91ad08b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2160",
    name: "Brooklands Extra",
    region: "England",
    country: "GB",
    uuid: "2e9e719b-7195-4a68-9dce-8f87ac0df991",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2161",
    name: "Stockwell Esso Express",
    region: "England",
    country: "GB",
    uuid: "e1bef378-1397-4c83-91d6-610cbc5b5119",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2162",
    name: "Buckingham Superstore",
    region: "England",
    country: "GB",
    uuid: "85feabb2-bf89-4c23-b6ee-5a70ee687c9f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2163",
    name: "Burgess Hill Superstore",
    region: "England",
    country: "GB",
    uuid: "2e9fd589-f493-4c86-85e4-575b1dcb4e1b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2164",
    name: "Bournemouth Extra",
    region: "England",
    country: "GB",
    uuid: "3d615871-4063-448f-87af-480b330f6ea7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2165",
    name: "Bo Ness Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "a7b3b738-a0c8-4e7f-b2a8-a5460c1de135",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2166",
    name: "Bury St Edmunds Superstore",
    region: "England",
    country: "GB",
    uuid: "c9d6f3ab-5f94-4f8c-9ae3-39162a06be5c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2168",
    name: "Bradford Peel Centre Superstore",
    region: "England",
    country: "GB",
    uuid: "88304fd8-2b04-4008-9615-8cddbfd3d6c7",
    services: {
      collect: true,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2169",
    name: "Brandon Superstore",
    region: "England",
    country: "GB",
    uuid: "5f74b6e0-ccc8-410e-85c3-67378e00481d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2171",
    name: "Beverley Superstore",
    region: "England",
    country: "GB",
    uuid: "46058bba-b4ee-4e5c-b76c-d77d1c3a71ed",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2172",
    name: "Braintree Great Notley Superstore",
    region: "England",
    country: "GB",
    uuid: "8b99983c-7e80-409f-93bb-344c9dee524a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2174",
    name: "Braintree Marks Farm Superstore",
    region: "England",
    country: "GB",
    uuid: "5fafb0d3-8a58-4a31-a408-f2d19083f791",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2175",
    name: "Bitterne Esso Express",
    region: "England",
    country: "GB",
    uuid: "2b075d6f-5f58-4b22-af80-2b770a602cf3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2178",
    name: "Rochdale Bamford Express",
    region: "England",
    country: "GB",
    uuid: "25fdedc8-0a8c-4b75-a248-a4551530c37e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2179",
    name: "Beckton Extra Gallions Reach",
    region: "England",
    country: "GB",
    uuid: "40ea62af-b66a-45c7-9612-bc48eb76fdb5",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2181",
    name: "Bushey Heath Esso Express",
    region: "England",
    country: "GB",
    uuid: "3464e3ea-043a-4f7d-a834-5284518560d8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2183",
    name: "Basford Esso Express",
    region: "England",
    country: "GB",
    uuid: "4d23dc5c-9644-4fa6-989e-d578ff1ff184",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2184",
    name: "Fir Tree Road Express",
    region: "England",
    country: "GB",
    uuid: "21c4632c-d695-4b61-a740-b15ef8b2d5f2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2185",
    name: "Bushbury Esso Express",
    region: "England",
    country: "GB",
    uuid: "0319a642-9d16-4102-abce-472dc321154c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2186",
    name: "Burnley Extra",
    region: "England",
    country: "GB",
    uuid: "ce39af9e-7314-45cc-a389-9fb19e6b2382",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2187",
    name: "Batley Extra",
    region: "England",
    country: "GB",
    uuid: "be9d331b-ed8d-4593-a4e2-193d0996a558",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2189",
    name: "Bury Esso Express",
    region: "England",
    country: "GB",
    uuid: "22f5f908-c9c3-491a-b323-d51d5b8e3615",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2191",
    name: "Banstead Express",
    region: "England",
    country: "GB",
    uuid: "b74d635d-3cc1-4d9f-8143-e4ef5418d004",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2192",
    name: "Bourne Esso Express",
    region: "England",
    country: "GB",
    uuid: "09692577-f8a8-40df-89e3-36459a7950d5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2193",
    name: "Bordon Superstore",
    region: "England",
    country: "GB",
    uuid: "c8b6c571-90fb-46a0-8a06-e5d56afa53a2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2194",
    name: "Bognor Regis Station Rd Express",
    region: "England",
    country: "GB",
    uuid: "0b909e6d-1ec3-4154-b99e-dd8772943f40",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2195",
    name: "Antrim Massereene Extra",
    region: "Northern Ireland",
    country: "GB",
    uuid: "8c3114f2-bae8-4b2a-8272-2208d8f54d7e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2197",
    name: "Alkrington Express",
    region: "England",
    country: "GB",
    uuid: "8a6acd4f-b19f-43f3-892e-aef03e9552a7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2200",
    name: "Broadstairs Extra",
    region: "England",
    country: "GB",
    uuid: "abc0a45b-f9bd-467a-b335-02d6bfe2c07f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2202",
    name: "Stevenage Broadwater Superstore",
    region: "England",
    country: "GB",
    uuid: "c87187ac-9a53-44dc-ab87-45173b32a1bc",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2203",
    name: "Bromley Esso Express",
    region: "England",
    country: "GB",
    uuid: "b9c6bc0b-e7ac-4415-81d8-160d03bcadc2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2205",
    name: "Clifton Express",
    region: "England",
    country: "GB",
    uuid: "6ecfc897-2a02-43c5-895b-554ddfd06d0c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2206",
    name: "Brandlesholme Express",
    region: "England",
    country: "GB",
    uuid: "bc5bfcc8-38fe-45ca-9de7-743667593345",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2207",
    name: "Durham Claypath Express",
    region: "England",
    country: "GB",
    uuid: "799e4357-f6cf-4ec3-8dd1-0fc1cda41b4e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2210",
    name: "Bushfield Centre Express",
    region: "England",
    country: "GB",
    uuid: "d47da276-67f3-4d7a-831e-b2ba2a5e7089",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2211",
    name: "Tooting Balham High Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "68e54a83-b835-427a-bf11-53126c6a297f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2213",
    name: "Camden Esso Express",
    region: "England",
    country: "GB",
    uuid: "32055dfe-42dd-4665-943d-4db905a35355",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2214",
    name: "Cannock Superstore",
    region: "England",
    country: "GB",
    uuid: "ae52198e-1083-43ee-bc79-860829e44f6c",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2215",
    name: "Cardigan Superstore",
    region: "Wales",
    country: "GB",
    uuid: "6a5bb8b9-3070-4091-bc9f-8896340d0104",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2216",
    name: "Petty Cury Express",
    region: "Northern Ireland",
    country: "GB",
    uuid: "681ded6c-408e-4fb5-907b-1468c6c719a3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "NIR",
  },
  {
    id: "2217",
    name: "Caernarfon South Rd Superstore",
    region: "Wales",
    country: "GB",
    uuid: "8a251a26-7de1-48f7-936c-958f1fcf5e28",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2218",
    name: "Caister Superstore",
    region: "England",
    country: "GB",
    uuid: "6acbdc35-d1aa-478f-a3bc-227dd1016e07",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2219",
    name: "Castle Bromwich Green Ln Express",
    region: "England",
    country: "GB",
    uuid: "c89e3242-f583-4d30-b8f1-b14d3fd9482e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2222",
    name: "Carlisle Warwick Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "1b33385f-4404-43e4-a483-6b5c2de8bc37",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2223",
    name: "Petersfield Charles St Express",
    region: "England",
    country: "GB",
    uuid: "0550c167-99f5-4b7e-87e4-ba0ee27c6441",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2225",
    name: "Cambridge Campkin Rd Express",
    region: "England",
    country: "GB",
    uuid: "78972e0f-7be9-4eda-a12f-2fde95cbd7ab",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2228",
    name: "Cambridge Newmarket Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "937a985e-7684-4fb1-8b92-b012e5ab6690",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2229",
    name: "Cherry Hinton Express",
    region: "England",
    country: "GB",
    uuid: "4a56fb22-01cc-4865-b49d-98a4ae0edbff",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2230",
    name: "Cardiff Extra",
    region: "Wales",
    country: "GB",
    uuid: "69941996-243e-46a5-a280-2948229fcdea",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2233",
    name: "Cardiff Pengam Extra",
    region: "Wales",
    country: "GB",
    uuid: "3d4f3d6b-81b9-460a-920a-a5e96ea72e94",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2236",
    name: "Camborne Superstore",
    region: "England",
    country: "GB",
    uuid: "c1ed2f06-416c-45fa-a6b6-73fb0a4e205a",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2242",
    name: "Canton Cardiff City Express",
    region: "Wales",
    country: "GB",
    uuid: "a9d729ec-23b5-43da-b343-d2a5bc393d0c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "2247",
    name: "Caversham Esso Express",
    region: "England",
    country: "GB",
    uuid: "670f2b55-5d9f-40f7-aff0-6c0e2cc65830",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2248",
    name: "Catterick Garrison Superstore",
    region: "England",
    country: "GB",
    uuid: "cabd2a29-75c6-4b85-8014-e57980460b4c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2249",
    name: "St Katharines Way Express",
    region: "England",
    country: "GB",
    uuid: "ce57acf7-dc84-4c4c-a487-44cf1616b121",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2256",
    name: "Chelsea Esso Express",
    region: "England",
    country: "GB",
    uuid: "a0a0b20b-5173-4067-bd46-f5ebee98a1c9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2257",
    name: "Chaddesden Esso Express",
    region: "England",
    country: "GB",
    uuid: "97023ca6-3580-454b-bc3e-60d70985e455",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2259",
    name: "Sutton Malden Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "c48f8880-c2a8-400b-a325-ea02e8ad4f11",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2263",
    name: "Chesterfield Esso Express",
    region: "England",
    country: "GB",
    uuid: "6407ec0d-9f7d-408a-8ebc-7213931dc092",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2265",
    name: "Bank Express Express",
    region: "England",
    country: "GB",
    uuid: "2edc0871-3ec9-479e-83e0-1ffca691b4e4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2266",
    name: "Chichester Extra",
    region: "England",
    country: "GB",
    uuid: "da50cf5f-5d31-4948-9217-3de89f7b61b1",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2269",
    name: "Chepstow Superstore",
    region: "Wales",
    country: "GB",
    uuid: "e840891d-b18a-45b2-85e1-cc4b0c7c0c0f",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2272",
    name: "Broughton Chester Extra",
    region: "England",
    country: "GB",
    uuid: "8233078a-8e7a-43b6-88bf-e8317ac3a1da",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2275",
    name: "Chorley Extra",
    region: "England",
    country: "GB",
    uuid: "ba4d2f21-2f03-4c4b-b877-e110f3a93629",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2277",
    name: "Churchtown Esso Express",
    region: "England",
    country: "GB",
    uuid: "e90dd04d-5838-4e82-a15c-7880e9eefa41",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2279",
    name: "Cirencester Extra",
    region: "England",
    country: "GB",
    uuid: "efadad34-b3e8-4232-931e-ac8124f1ac05",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2280",
    name: "Cheltenham Superstore",
    region: "England",
    country: "GB",
    uuid: "7e225c82-f253-45c2-9992-813a91922a97",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2281",
    name: "Ballymoney Castle St Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "3fd2085b-eebd-4eca-b3a7-1a1b76e57782",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2282",
    name: "Christchurch Esso Express",
    region: "England",
    country: "GB",
    uuid: "8e9a809f-4310-4aa2-b41c-e904db21bd5f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2286",
    name: "Cleethorpes Extra",
    region: "England",
    country: "GB",
    uuid: "a2af0aed-7378-4100-a430-67430beb83df",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2288",
    name: "Clevedon Superstore",
    region: "England",
    country: "GB",
    uuid: "1b18fe76-6270-4c3e-852c-fcfd5efa77ba",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2290",
    name: "Cleckheaton Superstore",
    region: "England",
    country: "GB",
    uuid: "2ca23c04-1cef-4901-83f9-8189ff69dff3",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2294",
    name: "Coleraine Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "e5b38ef7-6ed8-4fde-b9da-4caf49884ea5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2296",
    name: "Colney Hatch Extra",
    country: "GB",
    uuid: "b4c909d0-2b94-4cd2-8fea-8298e757d530",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
  },
  {
    id: "2302",
    name: "Coventry Jubilee Crescent Express",
    region: "England",
    country: "GB",
    uuid: "c4ac6168-66b9-4469-9396-1391a20c05b1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2308",
    name: "Clitheroe Superstore",
    region: "England",
    country: "GB",
    uuid: "19d1b20b-0f25-4825-92a0-83910de1be57",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2310",
    name: "Colchester Hythe Superstore",
    region: "England",
    country: "GB",
    uuid: "232f3cf5-6106-4a6b-b2cb-b0d90e034e1d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2313",
    name: "Crawley Extra",
    region: "England",
    country: "GB",
    uuid: "8d5e4be1-62c1-42e5-b433-3c1dde41f3e4",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2317",
    name: "Cheadle Hulme Express",
    region: "England",
    country: "GB",
    uuid: "2495d2f4-583a-49ee-853c-a0bf11631950",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2323",
    name: "Coventry Walsgrave Superstore",
    region: "England",
    country: "GB",
    uuid: "913637f9-022a-4802-89cd-0e48ebeb0034",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2326",
    name: "Colchester Extra",
    region: "England",
    country: "GB",
    uuid: "3a222982-9a59-497a-83ec-41ed9c765148",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2327",
    name: "Springfield Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "7cd03b4d-7440-4741-99d8-b360189ed778",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2328",
    name: "Coventry Arena Extra",
    region: "England",
    country: "GB",
    uuid: "4f5e9f15-b13d-4dea-bc3a-eec1431fa0f9",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2329",
    name: "Cheshunt Extra",
    region: "England",
    country: "GB",
    uuid: "4884550d-ef19-4718-975e-3834f96fbe29",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2330",
    name: "Chelmsford Princes Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "95cf66fc-d6de-4817-a730-95e2308a676e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2331",
    name: "High Street Sandyford Express",
    region: "England",
    country: "GB",
    uuid: "301074a9-b873-4f16-a561-66a49927ffb7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2332",
    name: "Blackpool Ansdell Rd Express",
    region: "England",
    country: "GB",
    uuid: "cc0825ef-587e-48c7-8f0e-72da25e2831b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2333",
    name: "Yeovil Abbey Manor Express",
    region: "England",
    country: "GB",
    uuid: "633959b7-bc70-4582-8070-fc6c79b52d15",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2334",
    name: "Frimley Balmoral Dr Express",
    region: "England",
    country: "GB",
    uuid: "00c8a384-2794-4cf0-b37e-f7ef024c3036",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2335",
    name: "West Bromwich Extra",
    region: "England",
    country: "GB",
    uuid: "86946be1-731e-420c-bdb2-c2278576e36d",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2337",
    name: "Wistaston Express",
    region: "England",
    country: "GB",
    uuid: "64ed0913-b300-4d7f-ba31-f21e3b21a16b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2338",
    name: "Combe Down Esso Express",
    region: "England",
    country: "GB",
    uuid: "a73fae32-f0e1-4b98-ab87-17613f6b1e27",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2339",
    name: "Copnor Esso Express",
    region: "England",
    country: "GB",
    uuid: "e1a3cb17-f8c7-451e-a5f1-1eef06e5b874",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2340",
    name: "Corstorphine Extra",
    region: "Scotland",
    country: "GB",
    uuid: "ad1cfdd2-fbce-4ff3-a209-4da69cac5996",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2341",
    name: "Cowley Esso Express",
    region: "England",
    country: "GB",
    uuid: "d193242e-a397-475e-8cc4-f23e82af2db6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2342",
    name: "Colliers Wood Esso Express",
    region: "England",
    country: "GB",
    uuid: "ac86d0a5-efbd-4f80-adcb-269716fba263",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2344",
    name: "Hall Green Stratford Express",
    region: "England",
    country: "GB",
    uuid: "7b502efe-afd1-41ab-9326-493c45ca4583",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2345",
    name: "Catford Express",
    region: "England",
    country: "GB",
    uuid: "9ffef72f-0cf6-4de7-9336-103f5e21b273",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2346",
    name: "Abbeymead Mead Rd Express",
    region: "England",
    country: "GB",
    uuid: "7fcc5b98-d2a8-4ecc-922d-c197b4ea6f79",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2347",
    name: "Blackfield Express",
    region: "England",
    country: "GB",
    uuid: "88e3df85-9d5f-47e3-80f7-39dd5cce6da3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2351",
    name: "Bletchley Melrose Ave Express",
    region: "England",
    country: "GB",
    uuid: "75480c6b-69fc-4125-bf59-b09e8a2d410f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2353",
    name: "Bentley Express",
    region: "England",
    country: "GB",
    uuid: "4a2beec7-38e1-4ac8-a91b-079bbaebd744",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2356",
    name: "Chesterton Cirencester Express",
    region: "England",
    country: "GB",
    uuid: "e90f0504-7959-4284-912d-2c67c71bfa05",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2358",
    name: "Glasgow Craigmarloch Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "817e5e49-fed4-4b41-a306-1a96010c2cff",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2361",
    name: "Cumbernauld Tryst Rd Extra",
    region: "Scotland",
    country: "GB",
    uuid: "8e0b8458-b6f9-439b-a397-28ce533f28a9",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2362",
    name: "Cupar Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "2232f811-392b-4271-8bda-a96aa137afbf",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2364",
    name: "Poundhill Express",
    region: "England",
    country: "GB",
    uuid: "64bc72ac-daf4-485a-90e6-75de4b3d9f79",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2366",
    name: "Chilwell Express",
    region: "England",
    country: "GB",
    uuid: "800200fe-aa99-480b-9f20-0a93260b34c4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2367",
    name: "Church Gresley Express",
    region: "England",
    country: "GB",
    uuid: "9e8abc49-c982-406a-9140-246801123f51",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2369",
    name: "Daventry Ashby Fields Express",
    region: "England",
    country: "GB",
    uuid: "b4032527-91b8-4ff6-a9ae-6c85cbac3cec",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2371",
    name: "Durham Extra",
    region: "England",
    country: "GB",
    uuid: "c02ce9ea-0f15-4b42-8d6a-edd7c85b1b1a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2372",
    name: "Daventry Superstore",
    region: "England",
    country: "GB",
    uuid: "99f22629-89d5-45e2-ad33-e67580a03396",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2373",
    name: "Dartford Esso Express",
    region: "England",
    country: "GB",
    uuid: "c4485ce0-9f23-49f4-81ce-c156b97c4331",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2374",
    name: "Hythe Esso Express",
    region: "England",
    country: "GB",
    uuid: "2a6f0407-0661-454b-a9ce-2643ac4e4d70",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2375",
    name: "Dingwall Mart Rd Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "16b77739-3e57-4aed-a740-2977a10da862",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2376",
    name: "Didsbury Express",
    region: "England",
    country: "GB",
    uuid: "86ed12da-bf07-4961-8012-6b9505a2652e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2379",
    name: "Crawley Downland Dr Express",
    region: "England",
    country: "GB",
    uuid: "4b7cb83d-0f6e-4d0a-a6be-cbc915bc8827",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2380",
    name: "Alvaston Express",
    region: "England",
    country: "GB",
    uuid: "fbee0de3-cdcb-4b55-8da8-6af016e1928f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2383",
    name: "Crouch End Express",
    region: "England",
    country: "GB",
    uuid: "8253115f-578a-4ef9-ad9e-a3b6d7977090",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2386",
    name: "Dudley Highland Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "8753e0f7-0486-4a5c-a656-f068bd4c2c05",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2387",
    name: "Dalkeith Hardengreen Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "8fb4bfb5-1123-4810-b2fc-cf6ce38944cf",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2388",
    name: "Dumfries Extra",
    region: "Scotland",
    country: "GB",
    uuid: "13aaaf79-ba29-4b6d-a46a-872d4cfea8d0",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2389",
    name: "Dundee Extra",
    region: "Scotland",
    country: "GB",
    uuid: "8def33b5-e419-4df6-9c14-888658eec580",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2392",
    name: "Doncaster Extra",
    region: "England",
    country: "GB",
    uuid: "6eb36b7c-bf52-4368-8e69-bfa6cf40f7da",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2394",
    name: "Lakeside Extra",
    region: "England",
    country: "GB",
    uuid: "af379b13-9b97-4b1c-b345-c1214a3e2f42",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2396",
    name: "Douglas Isle Of Man Superstore",
    region: "England",
    country: "GB",
    uuid: "548ba870-b2e3-4c06-9ff3-051d8e2c0270",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2397",
    name: "Dunfermline Extra",
    region: "Scotland",
    country: "GB",
    uuid: "5bb123b4-6c32-4fb5-9141-d2944a903897",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2404",
    name: "Derby Mickleover Superstore",
    region: "England",
    country: "GB",
    uuid: "ffb4a160-6258-4e36-84ed-b200f2b02051",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2406",
    name: "Dungannon Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "1cacb60d-775c-4864-a4df-88a5a259a46e",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2413",
    name: "Didcot Superstore",
    region: "England",
    country: "GB",
    uuid: "637b3e4a-8998-4ba7-96f9-ea06ec56fe01",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2414",
    name: "Preston Superstore",
    region: "England",
    country: "GB",
    uuid: "eba6b4e7-29c5-4df8-9acc-21428e99acbd",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2422",
    name: "Dover Extra",
    region: "England",
    country: "GB",
    uuid: "94355acb-aff6-42be-afb0-6e3bbf004463",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2423",
    name: "Dorchester Superstore",
    region: "England",
    country: "GB",
    uuid: "77458243-8fb1-4079-bc8d-4e56a2322de5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2425",
    name: "Dunstable Extra",
    region: "England",
    country: "GB",
    uuid: "34ac050a-038d-4324-a3e7-a408cfa3a9f6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2429",
    name: "Dundee Riverside Extra",
    region: "Scotland",
    country: "GB",
    uuid: "e1233c43-b1e7-4c8f-be42-705cf82280df",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2431",
    name: "Dunmurry Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "7a132d6f-3b0d-4c8a-b23e-216975f66500",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2436",
    name: "Dereham Extra",
    region: "England",
    country: "GB",
    uuid: "f1b5986b-dd75-41ed-9787-b5329e82fc23",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2440",
    name: "East Didsbury Superstore",
    region: "England",
    country: "GB",
    uuid: "85a073c9-ecbb-4a0d-829c-4fdc360b11a5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2443",
    name: "Ealing Northfields Ave Express",
    region: "England",
    country: "GB",
    uuid: "0a486e31-2983-4282-8b63-a3cd300395e3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2444",
    name: "Ebbw Vale Superstore",
    region: "Wales",
    country: "GB",
    uuid: "5041611e-af30-48e8-b423-a254b2aaa925",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2445",
    name: "Beckenham Elmers End Superstore",
    region: "England",
    country: "GB",
    uuid: "f495e489-ced9-4f7b-b451-5dbf1f4675da",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2446",
    name: "East Hunsbury Express",
    region: "England",
    country: "GB",
    uuid: "2a668fba-805a-456f-933e-62bf70003c59",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2450",
    name: "Eastbourne Extra",
    region: "England",
    country: "GB",
    uuid: "2519903c-9b1d-4cca-822e-dca86da3447f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2452",
    name: "Eastleigh The Swan Centre Express",
    region: "England",
    country: "GB",
    uuid: "8e9ba741-b901-4e60-a7ef-af42067f2b06",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2453",
    name: "Broughton Rd Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "60333d6d-47dc-4d30-8b36-9e3648288f3d",
    services: {
      collect: false,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2455",
    name: "Eccles Esso Express",
    region: "England",
    country: "GB",
    uuid: "602b15b5-bf1c-490c-bd22-1f47e6ba7315",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2456",
    name: "Edgware Canons Corner Esso Express",
    region: "England",
    country: "GB",
    uuid: "04f80e31-8d84-4325-8925-72dfc6b526e0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2459",
    name: "Willowbrae Rd Esso Express",
    region: "Scotland",
    country: "GB",
    uuid: "415c508c-877e-40fe-81fc-588558d6562f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "2461",
    name: "Colinton Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "5e35c6c9-cf73-4658-9edb-d53add13c6ca",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2470",
    name: "Ely Superstore",
    region: "England",
    country: "GB",
    uuid: "297caa57-2b71-4868-87c1-fe408e0b49f7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2471",
    name: "Little Switzerland Douglas",
    region: "England",
    country: "GB",
    uuid: "ce8180b1-d262-488e-9ea1-6b32246893f8",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2472",
    name: "Onchan Superstore",
    region: "England",
    country: "GB",
    uuid: "5df64713-78d5-46bb-bb8c-98065206162c",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2473",
    name: "Enfield Esso Express",
    region: "England",
    country: "GB",
    uuid: "0b9aeeb3-a76f-4027-b710-546d3b4ab181",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2475",
    name: "Emmer Green Esso Express",
    region: "England",
    country: "GB",
    uuid: "022c56b1-dbd2-4d18-a4a6-c7efff3bbd3a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2476",
    name: "Port Erin IOM",
    region: "England",
    country: "GB",
    uuid: "4e1f42c6-c6e7-4747-ab63-77d78708bb4b",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2477",
    name: "Trowbridge Eastbourne Rd Express",
    region: "England",
    country: "GB",
    uuid: "8e209c21-fc6a-46a0-a65a-7dedf726b03a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2484",
    name: "Erdington Esso Express",
    region: "England",
    country: "GB",
    uuid: "33c1bc74-bd98-40a4-a25f-7d60cc033fb1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2487",
    name: "Exeter Vale Extra",
    region: "England",
    country: "GB",
    uuid: "eb98ce79-3165-4d62-a1b2-6787133f5588",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2490",
    name: "Exmouth Superstore",
    region: "England",
    country: "GB",
    uuid: "ebc2dbc6-068a-4e81-a80c-8d0ed5c9529b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2491",
    name: "Eaton Socon Express",
    region: "England",
    country: "GB",
    uuid: "88b26bc9-ff28-47b0-9cfe-8befdd132bda",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2492",
    name: "Bristol Filton Esso Express",
    region: "England",
    country: "GB",
    uuid: "8ae738df-591f-41c3-9f49-0d74cdba6617",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2493",
    name: "Shenley Brook End Express",
    region: "England",
    country: "GB",
    uuid: "1db853a5-c3f1-40bd-ad90-9d0e349a87da",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2494",
    name: "Southsea Elm Grove Express",
    region: "England",
    country: "GB",
    uuid: "d9acc967-76e6-4cdf-978a-d111f27d6e24",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2496",
    name: "Farlington Express",
    region: "England",
    country: "GB",
    uuid: "684a5084-4408-4e81-8f2e-87c8a1221aeb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2498",
    name: "Market Parade Express",
    region: "England",
    country: "GB",
    uuid: "48aa962f-0ae4-47ae-962e-57e58464fc86",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2500",
    name: "Southport Birkdale Express",
    region: "England",
    country: "GB",
    uuid: "ca611120-77a0-42ed-8df8-a012bc8f6fc4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2503",
    name: "Birmingham New Street Express",
    region: "England",
    country: "GB",
    uuid: "3936cfe1-26a1-4e6b-b715-233250e0c24a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2504",
    name: "Barnt Green Express",
    region: "England",
    country: "GB",
    uuid: "fb95286a-8cc7-4770-966e-d595ab4d7642",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2513",
    name: "Bradley Stoke Baileys Court Express",
    region: "England",
    country: "GB",
    uuid: "1bdded5c-6ade-454f-9d91-191087ce0325",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2514",
    name: "Calmore Express",
    region: "England",
    country: "GB",
    uuid: "3798847a-2b49-4ecf-8ab5-583891e1e1e1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2515",
    name: "Dorridge Express",
    region: "England",
    country: "GB",
    uuid: "c68d74c3-fb59-471f-805f-a454297a739d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2518",
    name: "Swindon Freshbrook Express",
    region: "England",
    country: "GB",
    uuid: "4d04bc8d-11ef-4dbc-8352-1e918560e028",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2519",
    name: "Flint Express",
    region: "Wales",
    country: "GB",
    uuid: "b7789bb9-2dfa-47ed-af09-d7f9a07a210d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "2521",
    name: "Chippenham Foundry Ln Express",
    region: "England",
    country: "GB",
    uuid: "aa632f11-d9b8-4dd7-9508-ffe57fb43027",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2522",
    name: "Falmouth Killigrew Express",
    region: "England",
    country: "GB",
    uuid: "e3722a35-c0f6-4d8c-918d-1a11d58df181",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2523",
    name: "Fishponds Express",
    region: "England",
    country: "GB",
    uuid: "013ebd15-fab8-4813-bce7-de1bfe460060",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2527",
    name: "Felixstowe Hamilton Road Express",
    region: "England",
    country: "GB",
    uuid: "238741ad-e32f-447f-a422-c1a917faffa4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2530",
    name: "Ferndown Superstore",
    region: "England",
    country: "GB",
    uuid: "281ad191-a099-4d44-b879-7e9d400cb24e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2531",
    name: "St Leonards-on-sea Fernside Express",
    region: "England",
    country: "GB",
    uuid: "829dbfb0-cd32-4e0e-b028-e4d97cc94291",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2532",
    name: "Feltham Superstore",
    region: "England",
    country: "GB",
    uuid: "0b23fa29-3fcf-4aac-a4e8-3063b632afc9",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2535",
    name: "Folkestone Superstore",
    region: "England",
    country: "GB",
    uuid: "2e1dca76-c177-410c-885b-add18f3a91df",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2538",
    name: "Feltham Dukes Green Superstore",
    region: "England",
    country: "GB",
    uuid: "0b781548-bf1f-43f8-bd0b-4a1c4898d4c5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2549",
    name: "Fraserburgh Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "2ab72380-43f6-4d96-8bc4-5ba33de6b3c0",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2550",
    name: "Falkirk Grahams Rd Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "985c90b4-f27a-4043-8ba7-7f0dfb759996",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2551",
    name: "Gainsborough Superstore",
    region: "England",
    country: "GB",
    uuid: "ae1c0fc6-a893-44f6-9239-0eef49461d57",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2552",
    name: "Fleet Esso Express",
    region: "England",
    country: "GB",
    uuid: "dfa5a0d9-1fcc-41af-ae5b-0d97e92796a9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2553",
    name: "Fulham Kings Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "feea2886-208f-4441-a112-0a1cf5bcc375",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2554",
    name: "Forestgate Esso Express",
    region: "England",
    country: "GB",
    uuid: "a2977054-3de6-4e83-8634-91b2c2dde5aa",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2555",
    name: "Fulbourn Cherry Hinton Superstore",
    region: "England",
    country: "GB",
    uuid: "7bb15aa3-a229-46f0-ad2c-ba6f420541f5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2556",
    name: "Forest Hill Esso Express",
    region: "England",
    country: "GB",
    uuid: "ba09d893-8847-4dd9-b1c8-cc2bb10cdd23",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2557",
    name: "Forres Nairn Rd Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "fb54df2d-d9cc-4114-9d7d-f0c709e3ac0f",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2560",
    name: "Gatwick Extra",
    region: "England",
    country: "GB",
    uuid: "f273d7c0-bfc9-4e4e-841f-327738bdb7bd",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2562",
    name: "Rowlands Gill Express",
    region: "England",
    country: "GB",
    uuid: "e149bdd4-7075-48da-b7c4-134d58d9da73",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2564",
    name: "Gerrards Cross Superstore",
    region: "England",
    country: "GB",
    uuid: "14227fe2-2423-4ff3-8cba-b72fc28e8c52",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2568",
    name: "Goodge Street Express",
    region: "England",
    country: "GB",
    uuid: "724ebe77-8330-49e8-9853-1b1f29267b79",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2569",
    name: "Goodmayes Extra",
    region: "England",
    country: "GB",
    uuid: "6b2fbfec-4854-4293-a3c7-5fc5414fc84b",
    services: {
      collect: false,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2572",
    name: "Gillingham Kent Extra",
    region: "England",
    country: "GB",
    uuid: "646769b2-d4b5-4c21-ae73-8965b8eff6e1",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2574",
    name: "Dunmow Superstore",
    region: "England",
    country: "GB",
    uuid: "683b7085-cad9-4484-8a24-4d54f99d6b86",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2576",
    name: "Glasgow Milngavie Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "5045dd3c-e3b6-4d84-9826-563dcbf3f1b8",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2579",
    name: "Greenford Express",
    region: "England",
    country: "GB",
    uuid: "1f044fb4-3e0a-4ce1-8cb9-d40702b711bf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2587",
    name: "St Rollox Extra",
    region: "Scotland",
    country: "GB",
    uuid: "79aa210d-475e-4ade-9bda-6e97e312efe0",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2589",
    name: "Shettleston Extra",
    region: "Scotland",
    country: "GB",
    uuid: "e01b1d96-f72e-40e3-8af5-db8d62104789",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2590",
    name: "Guildford Superstore",
    region: "England",
    country: "GB",
    uuid: "872221ff-1457-4d5d-9b27-3c9668d4ee3c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2594",
    name: "Great Wyrley Esso Express",
    region: "England",
    country: "GB",
    uuid: "96bf67c0-58f1-42ef-826e-c8edec1b958e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2596",
    name: "Grove Park Esso Express",
    region: "England",
    country: "GB",
    uuid: "c74d6c45-c35a-46fc-ae63-fe804272526c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2600",
    name: "Grays Express",
    region: "England",
    country: "GB",
    uuid: "a45d1c8f-1096-4c46-b79a-16fea704b57c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2603",
    name: "Gants Hill Express",
    region: "England",
    country: "GB",
    uuid: "52e2c9a6-3ac1-44e9-a147-6e8ab2f03fd3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2604",
    name: "Bridgend Gentle Way Express",
    region: "Wales",
    country: "GB",
    uuid: "2693a480-60a0-4f2c-bada-984df5ed42e2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "2605",
    name: "Greenleys Express",
    region: "England",
    country: "GB",
    uuid: "8d6d7922-76bb-4191-995d-fc3d63ab86c9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2606",
    name: "Claregate Express",
    region: "England",
    country: "GB",
    uuid: "4050311e-ed57-4efd-84fb-9e2c58f58992",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2607",
    name: "Haddington Superstore",
    region: "England",
    country: "GB",
    uuid: "99f1404b-a591-4101-b832-de2c873ba43f",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2608",
    name: "Dudley Rd Express",
    region: "England",
    country: "GB",
    uuid: "25687ae2-e5fd-4951-803a-8c7d05e69435",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2612",
    name: "Cinderford Superstore",
    region: "England",
    country: "GB",
    uuid: "e60af8c7-b8d5-4acd-896d-df5613eab529",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2614",
    name: "Horsforth Express",
    region: "England",
    country: "GB",
    uuid: "3d5b79fe-4a5c-4bf4-9ce7-62df7080b362",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2615",
    name: "Milton Keynes Heelands Express",
    region: "England",
    country: "GB",
    uuid: "4aff78db-c913-4123-bdf8-cbf6f21837b6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2617",
    name: "Halifax Aachen Way Superstore",
    region: "England",
    country: "GB",
    uuid: "35799442-3440-4e0b-9204-a2e0df4c81ee",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2620",
    name: "Heavitree Esso Express",
    region: "England",
    country: "GB",
    uuid: "4a301841-ec85-468f-8854-d0c41f625ea1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2626",
    name: "Hartshill Esso Express",
    region: "England",
    country: "GB",
    uuid: "ba8b54a9-9d44-4962-9a4c-10bd951459f6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2627",
    name: "Harrow Esso Express",
    region: "England",
    country: "GB",
    uuid: "1c27aa62-7dfa-46a6-a22a-1fd9db3206b8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2628",
    name: "Harrow Station Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "cce5343a-825f-4724-874f-ceae285b7627",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2629",
    name: "Wilmslow Handforth Extra",
    region: "England",
    country: "GB",
    uuid: "7c736ddb-7d60-4727-adb1-e4edb6fb52b0",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2632",
    name: "Greenford Oldfield Express",
    region: "England",
    country: "GB",
    uuid: "a06e0ec1-03a3-45d1-bd62-96b12aef8188",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2634",
    name: "Harlow Church Langley Superstore",
    region: "England",
    country: "GB",
    uuid: "2cd6e7f0-cc7b-4c22-a1aa-72521a40f3f2",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2636",
    name: "Haslemere Superstore",
    region: "England",
    country: "GB",
    uuid: "efe25134-b6f5-4668-bd8f-656b00057d36",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2637",
    name: "Harrow Kenton Ln Express",
    region: "England",
    country: "GB",
    uuid: "8fe22d38-74f4-4970-819c-a5574878a0af",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2638",
    name: "Hartlepool Extra",
    region: "England",
    country: "GB",
    uuid: "87d54d95-3c4e-4c58-8c7f-ab510184ccfa",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2639",
    name: "Harlow E Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "6ee870b3-97c7-4b93-b414-b02a31d81472",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2647",
    name: "Haverfordwest Extra",
    region: "Wales",
    country: "GB",
    uuid: "997a0fa8-c8b6-4101-8b8d-674e24a00dab",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2648",
    name: "Henleaze Esso Express",
    region: "England",
    country: "GB",
    uuid: "80fed708-2c48-4faf-ae45-75ffb1fcb349",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2650",
    name: "Swadlincote Hearthcote Rd Express",
    region: "England",
    country: "GB",
    uuid: "c36d5421-f2ae-4652-a70c-bf3e28891d47",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2653",
    name: "Henley-on-thames Superstore",
    region: "England",
    country: "GB",
    uuid: "e8853cfa-7697-4a1c-b197-32ddf7fdb91e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2654",
    name: "Hatfield Extra",
    region: "England",
    country: "GB",
    uuid: "8c925f12-1918-4375-b0a3-6d537650b671",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2655",
    name: "Hendon Express",
    region: "England",
    country: "GB",
    uuid: "56ad2928-257a-402d-b010-3c6d59c67236",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2657",
    name: "Bicester Hart Place Express",
    region: "England",
    country: "GB",
    uuid: "6da177c1-1038-4910-a401-c48807074911",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2661",
    name: "Hertford Superstore",
    region: "England",
    country: "GB",
    uuid: "3766d317-653a-4a00-8736-0a8785cecb9f",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2663",
    name: "Hemel Hempstead Extra",
    region: "England",
    country: "GB",
    uuid: "23ea84ab-c095-4883-b4b4-cb3168861d66",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2665",
    name: "Norwich Grove Rd Express",
    region: "England",
    country: "GB",
    uuid: "e54707a7-3d7d-4920-84bc-b36dbd888944",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2667",
    name: "Hereford Abbotsmead Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "363cff6b-ce11-4133-aac1-d62990f5afa1",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2668",
    name: "High Wycombe Loudwater Superstore",
    region: "England",
    country: "GB",
    uuid: "5379cdf0-1454-4d6f-9d19-23fd65016870",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2670",
    name: "Hook Superstore",
    region: "England",
    country: "GB",
    uuid: "9808f7f6-3fb9-44cf-af2f-6f2cedb4d0f4",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2673",
    name: "Grantham Express",
    region: "England",
    country: "GB",
    uuid: "22fb21a2-aa50-4545-b0b6-b7e808ac164b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2675",
    name: "Horsham Extra",
    region: "England",
    country: "GB",
    uuid: "ed46c7b6-2bde-460c-af17-7f903d6d3522",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2676",
    name: "Holyhead Extra",
    region: "Wales",
    country: "GB",
    uuid: "ce84aec3-bcad-4e21-8962-bc9eaede131d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2679",
    name: "Honiton Superstore",
    region: "England",
    country: "GB",
    uuid: "a50beaef-4858-4c49-b494-c4d970ca0826",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2684",
    name: "Great Baddow Express",
    region: "England",
    country: "GB",
    uuid: "bbb437d4-4b9f-4849-8294-9fd0e600f759",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2688",
    name: "Horsham Esso Express",
    region: "England",
    country: "GB",
    uuid: "e3af6f6e-4b2a-46e9-a15d-8033e94d1925",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2693",
    name: "Hull Superstore",
    region: "England",
    country: "GB",
    uuid: "6b1e6f9b-87fe-491c-af56-5ce3b53f254f",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2694",
    name: "Huntingdon Extra",
    region: "England",
    country: "GB",
    uuid: "45f11bd4-234a-4df3-9efc-82d0dd5bbdd6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2696",
    name: "Hove Dyke Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "cd3f4943-dee5-480c-9125-e3a28805d697",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2697",
    name: "Hunstanton Superstore",
    region: "England",
    country: "GB",
    uuid: "6e9affa9-0042-496f-96d8-924e31e9204c",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2699",
    name: "Bolton Horwich Extra",
    region: "England",
    country: "GB",
    uuid: "da22057e-cf47-4135-828f-4462c866ba26",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2702",
    name: "Nottingham Hucknall Extra",
    region: "England",
    country: "GB",
    uuid: "7782de23-9453-4498-b326-0e7e05ac5f70",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2703",
    name: "Horncastle Superstore",
    region: "England",
    country: "GB",
    uuid: "35c72fad-3e70-469b-a4f4-a9004ffd6641",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2705",
    name: "Histon Express",
    region: "England",
    country: "GB",
    uuid: "65adaa7c-037b-4510-9bfe-a96dfe37f10e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2708",
    name: "Ealing Haven Green Express",
    region: "England",
    country: "GB",
    uuid: "99b7fb84-5333-4ef5-bb7d-89e0f896a130",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2710",
    name: "Heaton Moor Express",
    region: "England",
    country: "GB",
    uuid: "b3e6540e-3815-40eb-a683-99e7b5b08661",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2712",
    name: "Gee Cross Stockport Rd Express",
    region: "England",
    country: "GB",
    uuid: "5a089c85-6ca2-4b8a-96af-acb3cd2dc9b2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2713",
    name: "Hampton Hill Express",
    region: "England",
    country: "GB",
    uuid: "de97d1fe-2c0c-4e49-87c5-1303eaed1b49",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2714",
    name: "Wirral Hoylake Rd Express",
    region: "England",
    country: "GB",
    uuid: "005ae551-d209-4fcb-a6f7-be49f68b59ad",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2715",
    name: "Newtownabbey Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "c527643b-7469-41f1-bcc1-887c8c68e9f6",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2716",
    name: "Heysham Express",
    region: "England",
    country: "GB",
    uuid: "dc1fce36-e55e-46e8-a4a3-b77ff82ec1ab",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2722",
    name: "Euston Express",
    region: "England",
    country: "GB",
    uuid: "f142e07f-a67e-47c0-ac88-eca6756d578a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2723",
    name: "Dulwich Express",
    region: "England",
    country: "GB",
    uuid: "2b35b4e7-1f64-4e0a-8c0e-c8c9b0e4b503",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2724",
    name: "Hove Droveway Express",
    region: "England",
    country: "GB",
    uuid: "fb69d6ae-67de-45f1-92c8-2ea95bdc61ec",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2725",
    name: "Chiswick Express",
    region: "England",
    country: "GB",
    uuid: "7370a255-d621-4e82-a8de-6c216df57c3c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2726",
    name: "Marylebone Baker St Express",
    region: "England",
    country: "GB",
    uuid: "3fdd7f62-e6ac-4ba9-b7bb-1abd0c3f6da0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2727",
    name: "Highgate Express",
    region: "England",
    country: "GB",
    uuid: "4b680bf4-f0db-40cd-ad77-00da59e06f2a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2729",
    name: "Golders Green Express",
    region: "England",
    country: "GB",
    uuid: "8c45f9b3-2c86-4992-9cd3-d6a84cc9e354",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2730",
    name: "Ilford Esso Express",
    region: "England",
    country: "GB",
    uuid: "efac2082-3524-4525-ba1a-93daf3eed2c5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2731",
    name: "Ilkley Superstore",
    region: "England",
    country: "GB",
    uuid: "83b3b1a2-027e-4f72-ab0f-5ef6e7d614b1",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2733",
    name: "Ilkeston Chalons Way Extra",
    region: "England",
    country: "GB",
    uuid: "eebc60b9-9bd9-44bc-9cfa-604b4f8b7669",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2734",
    name: "Inverness Inshes Extra",
    region: "Scotland",
    country: "GB",
    uuid: "14328b66-3505-446b-9777-bbe08b335e6e",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2736",
    name: "Inverurie Harlaw Rd Extra",
    region: "Scotland",
    country: "GB",
    uuid: "a3f02b42-d050-442b-8637-f6bee5e7a058",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2737",
    name: "Inverness Extra",
    region: "Scotland",
    country: "GB",
    uuid: "17a8c9b1-2fc6-4937-95e0-c6687ad7d5e3",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2742",
    name: "Irvine Riverway Extra",
    region: "Scotland",
    country: "GB",
    uuid: "7e313446-f601-4d79-b1ce-1129a91df1a0",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2744",
    name: "Irlam Extra",
    region: "England",
    country: "GB",
    uuid: "d4023fad-d7f5-4a62-b2fa-ce060fcb8a23",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2745",
    name: "South Kensington Express",
    region: "England",
    country: "GB",
    uuid: "266d8309-a40b-4ffd-920b-c418c50ae1c4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2747",
    name: "Islington",
    region: "England",
    country: "GB",
    uuid: "c4dba9e0-528c-44d0-b2c9-9090b9802e6c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2748",
    name: "Ipswich Extra",
    region: "England",
    country: "GB",
    uuid: "6b3525e7-f3d7-4a43-8605-0d99f1e504c7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2754",
    name: "Holland Park Express",
    region: "England",
    country: "GB",
    uuid: "a99c4e75-1478-47e6-bd8e-5e7f61b93415",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2755",
    name: "Clapham Junction Express",
    region: "England",
    country: "GB",
    uuid: "73e731f8-5c24-41f8-953e-2dc82f7bc753",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2761",
    name: "Kew Gardens Express",
    region: "England",
    country: "GB",
    uuid: "421675cf-0e30-4937-bd7f-e1b53a568a41",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2763",
    name: "Kempshott Express",
    region: "England",
    country: "GB",
    uuid: "c689443b-408e-4106-a2b8-6e388b529b22",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2765",
    name: "Kensington Superstore",
    region: "England",
    country: "GB",
    uuid: "de2c2997-ae6a-450c-8c56-9f09e6fef664",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2766",
    name: "Kempston Bedford Rd Express",
    region: "England",
    country: "GB",
    uuid: "e0375230-1a42-415f-a941-cf4c7af9a6cc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2767",
    name: "Kettering Extra",
    region: "England",
    country: "GB",
    uuid: "232780a6-a6d7-40ac-b37e-9e635db6d7a5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2768",
    name: "Twickenham St Margarets Express",
    region: "England",
    country: "GB",
    uuid: "dddaee12-6e48-42b4-abb5-d51168a75e2a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2770",
    name: "Kidderminster Superstore",
    region: "England",
    country: "GB",
    uuid: "789ae2a4-a3de-43b8-948d-e77ba8058033",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2772",
    name: "Stoke-on-trent Kidsgrove Superstore",
    region: "England",
    country: "GB",
    uuid: "1cf2be88-aed8-447c-b130-395d46f35acd",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2774",
    name: "Kingsteignton Express",
    region: "England",
    country: "GB",
    uuid: "8346c0fb-6efd-48e0-a1e1-d4619b74531b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2780",
    name: "Kingswinford Esso Express",
    region: "England",
    country: "GB",
    uuid: "4336f644-fefb-4553-bf3f-1df7837c30c4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2781",
    name: "Kingswood Express",
    region: "England",
    country: "GB",
    uuid: "bd7a747f-cb84-479f-a44e-5436998854c2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2789",
    name: "Kings Cross Express",
    region: "England",
    country: "GB",
    uuid: "c2804113-2dcc-4141-b1ca-d32a292ea5e5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2793",
    name: "Kirby Frith Express",
    region: "England",
    country: "GB",
    uuid: "0cd4709d-0a87-4f24-9deb-aaa5bfd7b018",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2795",
    name: "Willerby Kirk Ella Esso Express",
    region: "England",
    country: "GB",
    uuid: "d8ac5a7c-4e02-4c2c-8fe2-b3fed44d8bf3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2797",
    name: "Knocknagoney Rd Extra",
    region: "Northern Ireland",
    country: "GB",
    uuid: "29b63db6-cc7d-41f6-b98c-ca7edb6002d6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2799",
    name: "Pontyclun Talbot Green Extra",
    region: "Wales",
    country: "GB",
    uuid: "3594dc28-0c0e-42f4-8446-7cb30a2bc22c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2800",
    name: "Launceston Superstore",
    region: "England",
    country: "GB",
    uuid: "c004d094-8676-4a61-a105-d27d5be7f949",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2801",
    name: "Lanark Gallowhill Rd Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "2fe59c06-7c60-45e3-abe1-e62d4a885ee9",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2803",
    name: "Larkfield Esso Express",
    region: "England",
    country: "GB",
    uuid: "0c96e7b7-1819-474b-a259-bf0a3fc578eb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2804",
    name: "Leyland Extra",
    region: "England",
    country: "GB",
    uuid: "cc3c4636-3ec8-4c9f-81f3-78c088b99eed",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2805",
    name: "Leyton Esso Express",
    region: "England",
    country: "GB",
    uuid: "d5352c43-8e47-44d1-ab3e-0ea80247417a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2806",
    name: "Leytonstone Superstore",
    region: "England",
    country: "GB",
    uuid: "40173237-2bca-46b0-9301-972768d5a02c",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2807",
    name: "Leigh-on-sea Esso Express",
    region: "England",
    country: "GB",
    uuid: "cb7a08ea-f468-4f2f-a8ff-c1f14648cee6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2808",
    name: "Leeds Seacroft Extra",
    region: "England",
    country: "GB",
    uuid: "3e334fc1-19e2-4838-b32c-876db0d6eabb",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2812",
    name: "Leatherhead Superstore",
    region: "England",
    country: "GB",
    uuid: "41b2ee1b-145e-499b-8dcb-5a624d867c49",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2813",
    name: "Leamington Spa Parade Express",
    region: "England",
    country: "GB",
    uuid: "541c6a1d-31b1-47ba-969b-acedccfc3b1e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2814",
    name: "Leeds Superstore",
    region: "England",
    country: "GB",
    uuid: "8f89039e-e3b7-44ea-a004-41569fdb8c86",
    services: {
      collect: false,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2815",
    name: "Ledbury Superstore",
    region: "England",
    country: "GB",
    uuid: "d51133bd-f1e1-45ca-9b63-9f01236e77c7",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2819",
    name: "Leicester Hamilton Extra",
    region: "England",
    country: "GB",
    uuid: "4be428b1-74f7-4995-83aa-cab4bf533898",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2820",
    name: "Leicester Fosse Esso Express",
    region: "England",
    country: "GB",
    uuid: "4fecc1cb-4a8f-402e-ae01-5e655bf5a479",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2823",
    name: "Colney Express",
    region: "England",
    country: "GB",
    uuid: "a836a17c-0e0b-403b-9866-740a3e02bc1d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2825",
    name: "Leighton Buzzard Superstore",
    region: "England",
    country: "GB",
    uuid: "3620202b-f048-4d9f-9de2-4418f7e73738",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2831",
    name: "Lincoln Canwick Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "1afc6735-8bb9-445d-8990-4df834c781b4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2835",
    name: "Llanelli Extra",
    region: "Wales",
    country: "GB",
    uuid: "b159dce3-2bb3-46d9-9cc5-96a8064bdfc2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2836",
    name: "Llandudno Junction Superstore",
    region: "Wales",
    country: "GB",
    uuid: "bf06af35-6e47-47bf-b85c-242539548cba",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2837",
    name: "Linlithgow Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "6aa87e13-a76a-4884-8f33-5177f00abc67",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2838",
    name: "Londonderry Lisnagelvin Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "69d387ec-c9c9-4349-8626-d0be50929461",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2840",
    name: "Lisburn Bentrim Rd Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "c5a79359-febf-4d2f-915b-e585c3e0505f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2844",
    name: "Long Eaton Express",
    region: "England",
    country: "GB",
    uuid: "a8e5ae73-657e-4540-9716-eb9d5d80e555",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2846",
    name: "Leicester Extra",
    region: "England",
    country: "GB",
    uuid: "4a6d504e-f526-42af-9377-840afcf3e9a9",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2848",
    name: "Lowestoft Leisure Way Superstore",
    region: "England",
    country: "GB",
    uuid: "c452cad1-6e7e-4706-aa70-46d207b0a719",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2849",
    name: "Loughborough Extra",
    region: "England",
    country: "GB",
    uuid: "fe26684e-80cf-4a7f-a0df-056d89e82f2b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2850",
    name: "Longton Extra",
    region: "England",
    country: "GB",
    uuid: "ce4c77b4-7cdf-4e1e-93b5-421e46a0eb8b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2853",
    name: "Limbury Mead Express",
    region: "England",
    country: "GB",
    uuid: "04a066aa-5d02-43be-8eca-454858b273b2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2856",
    name: "Ludlow Superstore",
    region: "England",
    country: "GB",
    uuid: "017bf579-cb26-4428-a423-1ff73d426fbc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2860",
    name: "Maidstone Grove Green Superstore",
    region: "England",
    country: "GB",
    uuid: "8a937a8f-a05d-42c6-b5d5-63546c5174e0",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2861",
    name: "Maida Vale Esso Express",
    region: "England",
    country: "GB",
    uuid: "7b52fbd5-8a8e-48fd-8e83-bda98b5c90bb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2863",
    name: "Weston Milton Express",
    region: "England",
    country: "GB",
    uuid: "28a71d84-be19-412e-b910-785c85ced437",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2871",
    name: "Mangotsfield Express",
    region: "England",
    country: "GB",
    uuid: "7e334036-347c-4349-afca-4f8dc5de7fe5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2875",
    name: "Market Deeping Superstore",
    region: "England",
    country: "GB",
    uuid: "4625967b-cec6-4820-b699-ec69a49de1b4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2876",
    name: "Macclesfield Hibel Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "5850971e-2326-4949-ab4a-7203eeb87e42",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2877",
    name: "Martlesham Extra",
    region: "England",
    country: "GB",
    uuid: "c9c9f94c-676d-4b5c-9850-7e6a333fc8fc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2880",
    name: "Midsomer Norton Superstore",
    region: "England",
    country: "GB",
    uuid: "0c2cba11-29eb-4a8e-833e-c2d7bd55efde",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2882",
    name: "Maldon Extra",
    region: "England",
    country: "GB",
    uuid: "2273cb49-e938-4de9-8bbf-9470d671f616",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2885",
    name: "Kingston Extra",
    region: "England",
    country: "GB",
    uuid: "db4dc38f-1db3-4a92-a5ca-f67ee2ff266d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2886",
    name: "Melton Mowbray Superstore",
    region: "England",
    country: "GB",
    uuid: "f021566c-1956-40cf-b17d-36596fedff6a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2893",
    name: "Milton Keynes Oldbrook Express",
    region: "England",
    country: "GB",
    uuid: "fd6a3351-1908-4a60-a548-6bd5bb934ca5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2894",
    name: "Mold Superstore",
    region: "Wales",
    country: "GB",
    uuid: "94bfd45b-2a7d-47cb-89bd-6302175660c2",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2898",
    name: "Milton Keynes Bletchley Extra",
    region: "England",
    country: "GB",
    uuid: "783cf240-b6e1-48dd-be4c-00d8aa261ef7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2899",
    name: "Longton Meir Hay Express",
    region: "England",
    country: "GB",
    uuid: "e238c1c4-6af1-41a1-b57d-a32b6510a27f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2900",
    name: "Meir Stoke-on-trent Superstore",
    region: "England",
    country: "GB",
    uuid: "1df2f6de-bded-432d-9602-2e277d6a95cc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2902",
    name: "Maidstone Tonbridge Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "908023ec-6105-4238-86f1-1f9f7c939df8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2907",
    name: "Montrose Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "fdbb30cf-d659-4f58-ae77-017f3beaa5da",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2912",
    name: "Longwell Green Express",
    region: "England",
    country: "GB",
    uuid: "91ebcd03-9cc1-4cd7-b40f-f3ae3f0a66f3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2913",
    name: "Nailsea Superstore",
    region: "England",
    country: "GB",
    uuid: "599a32ff-0a15-4d32-a841-a540f69acc2a",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2914",
    name: "Benton Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "10de4e69-4789-451e-842a-1a88a9e805e5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2915",
    name: "Fenham W Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "e4d20366-fd68-4fc2-9b8d-167219d79493",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2916",
    name: "Newton Aycliffe Extra",
    region: "England",
    country: "GB",
    uuid: "dc33f54b-217b-4dbd-acbe-dcab403cf49f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2917",
    name: "Newcastle Upon Tyne Extra",
    region: "England",
    country: "GB",
    uuid: "dc7fec8b-752a-4d62-82d8-252c86d2a301",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2919",
    name: "Newbury Extra",
    region: "England",
    country: "GB",
    uuid: "8a6a8d3d-9ea1-4315-89df-37e07818a9a1",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2920",
    name: "Kingsteignton Superstore",
    region: "England",
    country: "GB",
    uuid: "4c7f6035-bd08-4cef-a5d7-5fe9e49216f6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2924",
    name: "New Milton Superstore",
    region: "England",
    country: "GB",
    uuid: "3f8905a1-7c45-4387-be8b-55b3e583472b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2925",
    name: "Longlevens Express",
    region: "England",
    country: "GB",
    uuid: "f305d718-031e-4564-8429-41560e9f6ad2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2927",
    name: "Newbury Express",
    region: "England",
    country: "GB",
    uuid: "893221a4-e5e0-432f-b55d-1def8d0e53b0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2931",
    name: "Newport Extra",
    region: "England",
    country: "GB",
    uuid: "26280f68-0cc3-4f3b-840b-40e161da4d98",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2932",
    name: "Newport Pagnell Elthorne Express",
    region: "England",
    country: "GB",
    uuid: "2a101429-a2db-4fca-a76e-b92587206290",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2933",
    name: "New Oscott Extra",
    region: "England",
    country: "GB",
    uuid: "e3825344-ecf8-481b-8322-b2bea8d3adce",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2934",
    name: "New Malden Extra",
    region: "England",
    country: "GB",
    uuid: "21c13f1e-7e89-4d90-8a79-ebf3e9390039",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2938",
    name: "Jesmond Express",
    region: "England",
    country: "GB",
    uuid: "f1ee807c-2cf8-4180-8dc0-9cd1ed392539",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2939",
    name: "Barnet Esso Express",
    region: "England",
    country: "GB",
    uuid: "90e5d210-6b46-4e33-95dd-3dfd32ad17c2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2943",
    name: "Northwich Superstore",
    region: "England",
    country: "GB",
    uuid: "30348f41-6c3b-41a2-9462-81310d69984a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2946",
    name: "Northenden Express",
    region: "England",
    country: "GB",
    uuid: "cbd3f369-b3b5-418b-a451-935f6f563ed6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2947",
    name: "Ivybridge Lee Mill Extra",
    region: "England",
    country: "GB",
    uuid: "f6be75d0-991f-4d96-b63d-285cb769a268",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2949",
    name: "Nottingham Long Eaton Extra",
    region: "England",
    country: "GB",
    uuid: "289b291d-8419-41b1-9a3b-0fc0186b69eb",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2952",
    name: "Northampton South Extra",
    region: "England",
    country: "GB",
    uuid: "8f82fc7c-71c8-419c-89a9-574365f32e19",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2954",
    name: "Halstead",
    region: "England",
    country: "GB",
    uuid: "5d1fe184-1d93-42f3-8332-e415c71f0e4a",
    services: {
      collect: false,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2955",
    name: "Norwich Extra",
    region: "England",
    country: "GB",
    uuid: "73981b3e-c4a6-4b9d-9287-ec0fb49dbf19",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2956",
    name: "Portobello Road Express",
    region: "England",
    country: "GB",
    uuid: "963a027c-76c6-48b6-a342-fb8fd3efcbbb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2959",
    name: "Lode Heath Express",
    region: "England",
    country: "GB",
    uuid: "76db5b05-3ac1-42b8-8474-d777ead5abfd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2962",
    name: "Norwich Harford Bridge Superstore",
    region: "England",
    country: "GB",
    uuid: "50df87db-6bc6-4694-9d3a-babed2f14573",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2964",
    name: "Carlton Superstore",
    region: "England",
    country: "GB",
    uuid: "34f5b19a-faf9-427f-a532-281f1e7412a8",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2965",
    name: "North Cheam Esso Express",
    region: "England",
    country: "GB",
    uuid: "d72b6f15-6952-43b8-bfd5-c5713f55c697",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2966",
    name: "Ilchester Rd Express",
    region: "England",
    country: "GB",
    uuid: "dee64c7c-6b4b-46d9-b1c0-cd7c53120efc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2968",
    name: "North Shields Beach Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "4b0922e9-55dd-4397-b8b3-dfa82b0be776",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2969",
    name: "North Shields Extra",
    region: "England",
    country: "GB",
    uuid: "e7eb814e-55ac-4ede-ab33-751057af0e48",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2970",
    name: "Bradley Stoke Express",
    region: "England",
    country: "GB",
    uuid: "d67985a2-3d76-450d-ad82-7b7eeb6fdb87",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2971",
    name: "Stockton-on-tees Extra",
    region: "England",
    country: "GB",
    uuid: "45ee2904-7e4b-42aa-9f2c-ec0c66506375",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2972",
    name: "LANGLEY SLOUGH EXPRESS",
    region: "England",
    country: "GB",
    uuid: "ba4507d0-686b-4dae-9526-6e0b7ccbf377",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2973",
    name: "Matthias Road Express",
    region: "England",
    country: "GB",
    uuid: "6cc64704-14da-4324-9045-0a08bafc8a07",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2974",
    name: "Nuneaton Croft Rd Express",
    region: "England",
    country: "GB",
    uuid: "7075e2d5-e937-4434-921f-6dbd51e818e9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2975",
    name: "Ocean Village Express",
    region: "England",
    country: "GB",
    uuid: "70bda8ee-e308-4398-9f03-880c97567ef5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2976",
    name: "Warrington Orford Green Esso Express",
    region: "England",
    country: "GB",
    uuid: "097914c4-5874-4592-9a81-15168c73a178",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2977",
    name: "Oxford Rd Express",
    region: "England",
    country: "GB",
    uuid: "b7df5826-76e3-4196-b1ee-c926f18fa4bc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2979",
    name: "Southgate Bramley Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "675c0e2c-ca74-4e6e-b5fe-4fa4ab933102",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2989",
    name: "Oban Superstore",
    region: "England",
    country: "GB",
    uuid: "06f9c09e-53c5-447e-a10c-cfb8b3befd4c",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2990",
    name: "Oxford Cowley Road Express",
    region: "England",
    country: "GB",
    uuid: "c8ff4141-145b-4180-836e-f73cc6f29491",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2992",
    name: "Oldham Chadderton Superstore",
    region: "England",
    country: "GB",
    uuid: "4b1a1bc7-7ce9-4e25-b5a2-6b5ff1267d65",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2994",
    name: "Oxford Superstore",
    region: "England",
    country: "GB",
    uuid: "d5304e00-ee6a-4415-93f4-684d5f913b3a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2996",
    name: "Solihull Esso Express",
    region: "England",
    country: "GB",
    uuid: "f3f36be8-07bc-413a-9408-c4c86e2902c8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2997",
    name: "Stourbridge Esso Express",
    region: "England",
    country: "GB",
    uuid: "0deb09cd-6c78-41c6-8f16-0248ed3f8eaf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2998",
    name: "Oulton Broad Esso Express",
    region: "England",
    country: "GB",
    uuid: "ed1dfe55-312e-47ce-bdd1-9efe51b778e9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2999",
    name: "Furzton Express",
    region: "England",
    country: "GB",
    uuid: "ec29ba38-b62f-410b-abac-fc3f40293b3f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3008",
    name: "Perth Extra",
    region: "Scotland",
    country: "GB",
    uuid: "ad9c30c0-3ff0-446e-a076-02491a52f089",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "3009",
    name: "Peterborough Extra",
    region: "England",
    country: "GB",
    uuid: "1f084f8f-7727-454e-a99d-e6d752d97500",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3011",
    name: "Dogsthorpe Esso Express",
    region: "England",
    country: "GB",
    uuid: "8e842054-47e7-47c5-a08e-8d56c58981a8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3012",
    name: "Paddington Church Street Express",
    region: "England",
    country: "GB",
    uuid: "7561991c-5143-4c18-b830-8551cd4cad59",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3018",
    name: "Perth Express",
    region: "Scotland",
    country: "GB",
    uuid: "c2cc8c09-3e0f-40fe-b0a9-4cc48c27c920",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "3019",
    name: "Penarth Superstore",
    region: "Wales",
    country: "GB",
    uuid: "103f2ea6-823c-4829-b35a-90e896693f1d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3023",
    name: "Peterborough Hereward Cross Express",
    region: "England",
    country: "GB",
    uuid: "f5d9eac2-2272-44f3-82d1-312b9a034eed",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3026",
    name: "Penzance Superstore",
    region: "England",
    country: "GB",
    uuid: "67f06ade-b89d-40c0-902f-06217c069906",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3030",
    name: "Pinner Superstore",
    region: "England",
    country: "GB",
    uuid: "3f88f387-2283-4ca3-a2ed-4c1661db7283",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3031",
    name: "Plymouth Roborough Extra",
    region: "England",
    country: "GB",
    uuid: "ac7b3718-2264-4fcb-9094-e73c82c14262",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3033",
    name: "Plymouth New George Street Express",
    region: "England",
    country: "GB",
    uuid: "629f79b2-9100-45b5-9150-ac61ff0bbd02",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3036",
    name: "Poole Extra",
    region: "England",
    country: "GB",
    uuid: "c632337d-01ee-4c4b-8c85-c45abd9497e2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3039",
    name: "Plymouth Transit Way Superstore",
    region: "England",
    country: "GB",
    uuid: "a6a68f50-5f0b-4a9d-a07c-a6f81b3ed570",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3040",
    name: "Poole Fleets Corner Extra",
    region: "England",
    country: "GB",
    uuid: "524e8c80-4116-4af7-90b2-211c77d5eacf",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3041",
    name: "Prestwich Superstore",
    region: "England",
    country: "GB",
    uuid: "148b1673-990e-4b1a-8605-e912ad9044bf",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3047",
    name: "Poole Branksome Superstore",
    region: "England",
    country: "GB",
    uuid: "cb0127bf-6872-41ca-949e-429f86f5d05b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3050",
    name: "Potters Bar Superstore",
    region: "England",
    country: "GB",
    uuid: "6a377ccc-7b35-4fb1-8cb3-96476333be65",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3054",
    name: "Portswood Esso Express",
    region: "England",
    country: "GB",
    uuid: "96ce7cc9-f178-4a39-9110-f3fbee4e1dc4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3055",
    name: "Portsmouth Extra",
    region: "England",
    country: "GB",
    uuid: "caf49e58-512f-4aba-a239-d82a48213f29",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3056",
    name: "Port Talbot Superstore",
    region: "Wales",
    country: "GB",
    uuid: "087c06f2-ddc1-4802-8784-44102fa3248d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3058",
    name: "Poole Fernside Rd Express",
    region: "England",
    country: "GB",
    uuid: "f11c3a40-d61e-4711-9d23-345edb0b2f13",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3060",
    name: "Basildon Pitsea Extra",
    region: "England",
    country: "GB",
    uuid: "4171fed3-18ab-4561-942c-b1bd0c72eb8d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3061",
    name: "Leavesden Green Express",
    region: "England",
    country: "GB",
    uuid: "bc844f93-d592-42fb-bb82-729ebdcf6f19",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3063",
    name: "Pontypridd Extra",
    region: "Wales",
    country: "GB",
    uuid: "08115a6b-d6e8-4885-98f5-186fa28937d4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3064",
    name: "Outwood Express",
    region: "England",
    country: "GB",
    uuid: "d4592f25-b2db-4b0f-b54a-d9a5644a72ed",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3065",
    name: "Prescot Extra",
    region: "England",
    country: "GB",
    uuid: "b1539c9b-edca-44d0-ae17-98d9f970a1a6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3066",
    name: "Purley Extra",
    region: "England",
    country: "GB",
    uuid: "5897e996-e99b-4071-824a-1d013cea6454",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3069",
    name: "Norwich Magdalen Rd Express",
    region: "England",
    country: "GB",
    uuid: "e67c5cf9-ef29-4b97-abe4-ee08b240afbd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3070",
    name: "Ashford Mace Ln Express",
    region: "England",
    country: "GB",
    uuid: "57990bbf-85f2-4ba9-ab3f-77160d6fbb19",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3072",
    name: "Plympton Express",
    region: "England",
    country: "GB",
    uuid: "bed88565-c3f7-4f19-954e-ff77dca0ff52",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3073",
    name: "Lichfield Netherstowe Express",
    region: "England",
    country: "GB",
    uuid: "7a5eef6d-d0d5-4a54-88a2-fdf6a95c6a85",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3074",
    name: "Gloucester Quedgeley Extra",
    region: "England",
    country: "GB",
    uuid: "41e22d21-4de6-47be-9419-285c46c4e242",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3075",
    name: "Northbourne Express",
    region: "England",
    country: "GB",
    uuid: "bf128d26-117b-4863-817a-983b9e409cd9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3080",
    name: "Reading Shinfield Express",
    region: "England",
    country: "GB",
    uuid: "66dd7bcc-23f0-41cc-9eda-43edf6a3fc05",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3082",
    name: "Shenfield Express",
    region: "England",
    country: "GB",
    uuid: "5a7dfac9-b514-4519-828b-7d7d7ee2e0f4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3083",
    name: "Northwood Hills Esso Express",
    region: "England",
    country: "GB",
    uuid: "74d84e5f-3d2e-43d8-b0e8-c15cf9be9098",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3084",
    name: "Redditch Extra",
    region: "England",
    country: "GB",
    uuid: "a09b6c84-8f7d-407f-a0e2-257ae02af85c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3088",
    name: "Redfield Express",
    region: "England",
    country: "GB",
    uuid: "a54f8da6-aa78-4a8c-b3f6-e09228b8c026",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3092",
    name: "Reedley Esso Express",
    region: "England",
    country: "GB",
    uuid: "9589b0f1-2bc4-47dd-bfa3-da3a54362e40",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3093",
    name: "Regent Street Express",
    region: "England",
    country: "GB",
    uuid: "3b93c4f6-29a1-455e-abdb-d684e868c9df",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3095",
    name: "Reading Extra",
    region: "England",
    country: "GB",
    uuid: "bcd02abf-f6e8-4e93-a81e-dc7c9dff7eff",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3097",
    name: "Richmond George Street Express",
    region: "England",
    country: "GB",
    uuid: "31e88f97-7bab-45e7-b0f1-160b25d10ceb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3098",
    name: "Rayners Ln Express",
    region: "England",
    country: "GB",
    uuid: "789cec76-af1c-467b-ab37-861389ca59e6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3099",
    name: "Rickmansworth Superstore",
    region: "England",
    country: "GB",
    uuid: "21404796-d05d-4600-88fc-16773f8e59f4",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3101",
    name: "Rochdale Superstore",
    region: "England",
    country: "GB",
    uuid: "7d4195fb-eb7d-429d-8f35-885a4d501f67",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3102",
    name: "Richmond Express",
    region: "England",
    country: "GB",
    uuid: "466f16c9-9297-4296-9545-261db686ee00",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3104",
    name: "Rotherham Bawtry Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "16ec51bf-7146-4e59-9c83-5e062a9c423d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3105",
    name: "Romford Esso Express",
    region: "England",
    country: "GB",
    uuid: "ff471fe3-ce1f-48eb-8af3-84de7c516ebf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3108",
    name: "Royston Extra",
    region: "England",
    country: "GB",
    uuid: "f5c6da39-d156-4e0e-835d-f8e327a5e2e2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3109",
    name: "Rothwell Express",
    region: "England",
    country: "GB",
    uuid: "65204aef-ba66-428e-9925-df8e8baef72e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3115",
    name: "Rugby Superstore",
    region: "England",
    country: "GB",
    uuid: "6b05b3a4-6e98-4b44-b16d-41bd1eae7d52",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3117",
    name: "Manchester Rusholme Esso Express",
    region: "England",
    country: "GB",
    uuid: "1d066c1f-a95f-4a75-8afa-e0dcd265b967",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3120",
    name: "Romford Gallows Corner Extra",
    region: "England",
    country: "GB",
    uuid: "32c89df8-3e10-4f43-862a-ddf8197ea33f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3122",
    name: "Mossley Hill Express",
    region: "England",
    country: "GB",
    uuid: "60e135fc-d5f5-4630-b1b4-1fb4fa2c0419",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3124",
    name: "Lilliput Express",
    region: "England",
    country: "GB",
    uuid: "0d0aa925-3efd-4791-a18c-a7e57234edbd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3125",
    name: "Duston Limehurst Square Express",
    region: "England",
    country: "GB",
    uuid: "9006335b-44e4-4b5e-a0af-e0483ae494b9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3127",
    name: "Warsash Locks Heath Express",
    region: "England",
    country: "GB",
    uuid: "e68042cf-68c3-4d00-998b-49674c0c2333",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3128",
    name: "Kilnhouse Ln Express",
    region: "England",
    country: "GB",
    uuid: "9754ad56-097f-443a-a8c0-eab670527540",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3130",
    name: "Saffron Walden Superstore",
    region: "England",
    country: "GB",
    uuid: "b81c9253-e224-46a3-b2ca-ccc88e27709c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3131",
    name: "Colchester St Johns Express",
    region: "England",
    country: "GB",
    uuid: "f83b4474-c8ce-4dbb-8336-ae53b2d5b0f5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3132",
    name: "Hobs Moat Express",
    region: "England",
    country: "GB",
    uuid: "e81ec7f7-859c-48c4-85c7-97f27f1e7544",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3133",
    name: "Salisbury Extra",
    region: "England",
    country: "GB",
    uuid: "8b1a9309-b0cb-4fb1-bb34-8660db95c52f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3134",
    name: "NORTH FELTHAM RD EXP",
    region: "England",
    country: "GB",
    uuid: "5a55e6e3-a175-48a4-a1f1-09827257d141",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3137",
    name: "Sevenoaks Riverhead Superstore",
    region: "England",
    country: "GB",
    uuid: "e003e647-0233-40a6-886d-0257ac1191ee",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3142",
    name: "St Austell Daniels Ln Superstore",
    region: "England",
    country: "GB",
    uuid: "531a9e37-740d-47d3-8b83-9057977102fa",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3145",
    name: "St Neots Extra",
    region: "England",
    country: "GB",
    uuid: "2451ce8b-714a-4c0c-acf0-d0ecc3eb8da9",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3147",
    name: "Sale Superstore",
    region: "England",
    country: "GB",
    uuid: "fc45204f-1e46-4e0b-b365-47fa44512d2f",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3148",
    name: "St Pauls Cray Esso Express",
    region: "England",
    country: "GB",
    uuid: "41b0242b-0a07-4d71-8965-2c0e12c721bc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3149",
    name: "Sandhurst Extra",
    region: "England",
    country: "GB",
    uuid: "478c0609-2eae-4869-9881-26b7202130a7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3151",
    name: "Salisbury Express",
    region: "England",
    country: "GB",
    uuid: "94779ac4-7d95-42b1-97e9-f35a82e7d468",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3153",
    name: "Hayes South Esso Express",
    region: "England",
    country: "GB",
    uuid: "4b3b181b-287e-4c9c-b2e5-724a4f6b6681",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3156",
    name: "St Mary's Esso Express",
    region: "England",
    country: "GB",
    uuid: "b1f50cad-3ee1-4197-b32b-4ad017874de2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3158",
    name: "South Oxhey Esso Express",
    region: "England",
    country: "GB",
    uuid: "dcb623c6-21ac-4284-82db-adb9fe8198ce",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3165",
    name: "Stapenhill Express",
    region: "England",
    country: "GB",
    uuid: "207562d5-cf51-4ccd-8e05-2afb9b56196b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3166",
    name: "Scarborough Superstore",
    region: "England",
    country: "GB",
    uuid: "103f134f-b4e3-4541-9bd6-a8e83b632cfb",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3177",
    name: "Southend Extra",
    region: "England",
    country: "GB",
    uuid: "f95bb811-98ec-4e8f-a554-52a8753d0245",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3178",
    name: "Shoreham-by-sea Extra",
    region: "England",
    country: "GB",
    uuid: "dd6be197-9b44-4f9a-a94a-c69a9b6360b4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3179",
    name: "Sheerness Superstore",
    region: "England",
    country: "GB",
    uuid: "de4ef9d0-b6b7-445b-991a-571b26c199c3",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3180",
    name: "Sidcup Superstore",
    region: "England",
    country: "GB",
    uuid: "c116b9fb-492e-45bb-9f67-749cd23af322",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3181",
    name: "Sheffield Abbeydale Superstore",
    region: "England",
    country: "GB",
    uuid: "9dd9e065-ba75-4eb4-91f2-16d08b2d9ce9",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3188",
    name: "Solihull Extra",
    region: "England",
    country: "GB",
    uuid: "a5afb3d7-deb8-4238-a5f9-6798ab18c97e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3190",
    name: "Southampton Superstore",
    region: "England",
    country: "GB",
    uuid: "5baea3ac-87ce-4377-884c-b0aae330ee22",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3193",
    name: "Southport Extra",
    region: "England",
    country: "GB",
    uuid: "556ac11c-5b75-4b58-801a-d55fc702d352",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3211",
    name: "Slough Esso Express",
    region: "England",
    country: "GB",
    uuid: "89b34115-28a7-4ae8-8fd8-12100e5a0b51",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3212",
    name: "Stratford Upon Avon Superstore",
    region: "England",
    country: "GB",
    uuid: "74b1490e-f1b5-4701-8e2b-858a722a9ef6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3213",
    name: "Stevenage Extra",
    region: "England",
    country: "GB",
    uuid: "93c942b7-6467-4e79-9f65-d138f3b9117e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3217",
    name: "Swindon Express",
    region: "England",
    country: "GB",
    uuid: "534ed7dc-7593-4746-8dcc-b9fd3cf77c61",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3219",
    name: "Swansea Cadle Extra",
    region: "Wales",
    country: "GB",
    uuid: "0966204f-5d9b-41de-aba8-187ca997aba7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3220",
    name: "Sunbury-on-thames Extra",
    region: "England",
    country: "GB",
    uuid: "e748bf7a-4e08-4d21-a4c0-40177db10bd7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3228",
    name: "Skegness Superstore",
    region: "England",
    country: "GB",
    uuid: "11a13e4f-b8de-4c96-9e34-ed8eb37b875a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3230",
    name: "Swindon Extra",
    region: "England",
    country: "GB",
    uuid: "4f60cd8e-cb0c-4114-842a-09a97e5d123e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3232",
    name: "Strood Superstore",
    region: "England",
    country: "GB",
    uuid: "4f10c0bd-a02e-44a4-87d0-98398f6ed00c",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3234",
    name: "Sudbury Superstore",
    region: "England",
    country: "GB",
    uuid: "67e0bbf6-1e8b-4204-9d02-0173f8461fc1",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3235",
    name: "Sutton Cheam Extra",
    region: "England",
    country: "GB",
    uuid: "03a0ccea-1d17-4d26-81f9-5cab924f9f21",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3236",
    name: "Southchurch Esso Express",
    region: "England",
    country: "GB",
    uuid: "a1d40915-8fd9-429e-8c24-0b142ad96747",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3237",
    name: "Stirling Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "d7954763-c6f3-4a56-923d-e6b81a601b24",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "3239",
    name: "Stoke-on-trent Superstore",
    region: "England",
    country: "GB",
    uuid: "0f57216e-60a0-4560-9faa-6c4a323130bb",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3240",
    name: "Stowmarket Superstore",
    region: "England",
    country: "GB",
    uuid: "8b449d94-fded-4ffb-b0bc-b6df3983d196",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3242",
    name: "Reading Southcote Esso Express",
    region: "England",
    country: "GB",
    uuid: "fadea744-57bd-4697-8078-91350291f4a4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3243",
    name: "Scunthorpe Extra",
    region: "England",
    country: "GB",
    uuid: "a5bf8985-f091-4346-801a-a65c4d538557",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3244",
    name: "Stafford Esso Express",
    region: "England",
    country: "GB",
    uuid: "3feb2350-1078-4e46-936f-71fc18a9efec",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3247",
    name: "Spinny Hill Express",
    region: "England",
    country: "GB",
    uuid: "0dcd2195-135a-4427-8885-83b92cb1aa6c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3248",
    name: "Millbrook Wimpson Ln Express",
    region: "England",
    country: "GB",
    uuid: "7352d856-3386-468f-8946-ed04b5891bad",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3250",
    name: "Shenley Express",
    region: "England",
    country: "GB",
    uuid: "aaef5894-7ab7-4b79-8212-a8b00004cb84",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3252",
    name: "Thorpe Bay Express",
    region: "England",
    country: "GB",
    uuid: "95e9fef2-dbac-4ba3-a309-3f46f57579e4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3256",
    name: "Sidcup Longlands Express",
    region: "England",
    country: "GB",
    uuid: "abd8ed51-114e-40fd-9139-0bbe8aa111ad",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3257",
    name: "Eastbourne Seaside Express",
    region: "England",
    country: "GB",
    uuid: "dfede5a6-916c-4f1f-bf89-66ade69f2eac",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3259",
    name: "Salford Quays Express",
    region: "England",
    country: "GB",
    uuid: "760d7658-7239-4601-b9fb-beade4087ce4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3260",
    name: "Ashton Upon Mersey Express",
    region: "England",
    country: "GB",
    uuid: "795d0aee-7a42-4c14-82c4-27211799e598",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3262",
    name: "Lodge Park Express",
    region: "England",
    country: "GB",
    uuid: "d120d017-f5af-4b20-b23a-ddd638ff5f54",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3268",
    name: "Rowner Express",
    region: "England",
    country: "GB",
    uuid: "8a8c5912-0806-40f2-9d41-bd99a6742ecf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3269",
    name: "Birmingham Mailbox Express",
    region: "England",
    country: "GB",
    uuid: "567b9efc-ef71-4746-beea-da84da0bd031",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3272",
    name: "Fulwood Express",
    region: "England",
    country: "GB",
    uuid: "6306fd7a-da60-43af-99b1-18ea1eac6a8c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3275",
    name: "St Albans Jersey Farm Express",
    region: "England",
    country: "GB",
    uuid: "57dbf3ae-dbcf-43ca-91e9-2a3227597ae8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3277",
    name: "Leith Walk Express",
    region: "Scotland",
    country: "GB",
    uuid: "fb8c39f8-a67d-4d7c-80e2-0a811c24f196",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "3281",
    name: "Taunton Superstore",
    region: "England",
    country: "GB",
    uuid: "6780ab30-cbfc-424d-bbe8-5884a0a4f18b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3283",
    name: "Tenterden Superstore",
    region: "England",
    country: "GB",
    uuid: "baed1f7c-cc6c-4872-8500-32926a6363ce",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3287",
    name: "Torquay Fleet Street Express",
    region: "England",
    country: "GB",
    uuid: "944ebf2f-fce4-4326-ab66-ba46b65860b1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3288",
    name: "Thirsk Superstore",
    region: "England",
    country: "GB",
    uuid: "de313728-b80f-4d52-857c-6da2d3f045ca",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3290",
    name: "Telford Extra",
    region: "England",
    country: "GB",
    uuid: "2eb20421-93ed-46d4-8b79-f0ddde7954b1",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3291",
    name: "Colchester Tiptree Superstore",
    region: "England",
    country: "GB",
    uuid: "5759087f-e335-4d6e-8eed-414de14e35a1",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3292",
    name: "Thornton Heath Rd Express",
    region: "England",
    country: "GB",
    uuid: "cb4b09ba-7af7-481a-aad8-59089f4c2439",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3293",
    name: "Towcester Superstore",
    region: "England",
    country: "GB",
    uuid: "a7511626-b783-451f-97a7-63594612c513",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3295",
    name: "Tolworth Esso Express",
    region: "England",
    country: "GB",
    uuid: "203a5467-4270-4574-9812-2d77521f2a41",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3296",
    name: "Teignmouth Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "c0fdb835-c92e-4a65-a8c5-4835f2e8bb70",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3297",
    name: "Nottingham Toton Extra",
    region: "England",
    country: "GB",
    uuid: "dc778a6b-f172-431c-91b0-4be79e06e375",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3299",
    name: "Thornbury Superstore",
    region: "England",
    country: "GB",
    uuid: "ddc105b8-5e8b-4708-8d94-3a17a17a497a",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3301",
    name: "Thetford Superstore",
    region: "England",
    country: "GB",
    uuid: "1e9d48e0-8bcf-40f6-addf-dd3bc214533f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3302",
    name: "Totterdown Express",
    region: "England",
    country: "GB",
    uuid: "075e66d3-af2e-4b14-9db9-adcf2a616e20",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3303",
    name: "Throston Grange Express",
    region: "England",
    country: "GB",
    uuid: "80741158-af0d-416a-844a-cb4566c101a6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3304",
    name: "Grosvenor Road Express",
    region: "England",
    country: "GB",
    uuid: "2331d801-410c-464e-acbf-6d142c2b8bbd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3308",
    name: "Spalding Matmore Gate Express",
    region: "England",
    country: "GB",
    uuid: "6b69f488-2ebf-418f-b17a-75dfd153d62d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3309",
    name: "Tring Superstore",
    region: "England",
    country: "GB",
    uuid: "2ad4227a-a438-4ac8-b0e6-40446d3bb492",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3310",
    name: "Truro Superstore",
    region: "England",
    country: "GB",
    uuid: "fc2235e4-6e87-4f83-b917-42262518dd42",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3312",
    name: "Northolt Express",
    region: "England",
    country: "GB",
    uuid: "c504a27c-99ff-4834-8a22-b3cc87582143",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3315",
    name: "Stukeley Meadows Express",
    region: "England",
    country: "GB",
    uuid: "0fe585fe-5d19-4945-aefb-2b004c68ad61",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3316",
    name: "Trowbridge Extra",
    region: "England",
    country: "GB",
    uuid: "21c99405-c332-4020-818e-dc811c7fbdeb",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3317",
    name: "Brixton Tulse Hill Esso Express",
    region: "England",
    country: "GB",
    uuid: "36b42646-f767-43b5-a208-d429560398fd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3318",
    name: "Ledbury Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "b2945387-ebec-4913-bfec-cdff3ba41636",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3320",
    name: "Theydon Bois Express",
    region: "England",
    country: "GB",
    uuid: "e37de725-5a67-4daf-9523-cb961fc15030",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3324",
    name: "Twickenham Extra",
    region: "England",
    country: "GB",
    uuid: "f0de4982-bd54-435c-a7c7-53b74fe20499",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3326",
    name: "Peacehaven Express",
    region: "England",
    country: "GB",
    uuid: "9a820228-ecfc-4dcd-9c00-043d19110600",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3327",
    name: "Uttoxeter Superstore",
    region: "England",
    country: "GB",
    uuid: "ce9ae6e1-fb83-4623-8110-92fabe472df4",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3328",
    name: "Uttoxeter New Rd Express",
    region: "England",
    country: "GB",
    uuid: "a887a03a-c12e-42e2-b63c-d7e996c6afed",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3329",
    name: "Cranham Express",
    region: "England",
    country: "GB",
    uuid: "ee3c71f3-88a2-4627-b0e4-9c0fed387efe",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3330",
    name: "Uckfield Superstore",
    region: "England",
    country: "GB",
    uuid: "509a3e7d-6ecc-4691-bfdc-29c5aec13357",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3331",
    name: "Stanford-le-hope Express",
    region: "England",
    country: "GB",
    uuid: "35c0f8e2-4d89-468a-9b88-5c0e30ec1204",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3332",
    name: "Upton Park Green Street Express",
    region: "England",
    country: "GB",
    uuid: "78e55321-8358-42bf-9529-be598008d771",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3333",
    name: "Lea Valley Extra",
    region: "England",
    country: "GB",
    uuid: "2202e8da-d6a1-4ae8-92b0-98ff97b2d414",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3335",
    name: "Uxbridge High Street Express",
    region: "England",
    country: "GB",
    uuid: "bcd8cc79-e983-4d48-9943-a92b548ce8b8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3336",
    name: "St Davids Rd North Express",
    region: "England",
    country: "GB",
    uuid: "dc40c56f-eceb-46b7-b692-a0e669d6b03b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3338",
    name: "Valley Park Soton Express",
    region: "England",
    country: "GB",
    uuid: "19b09737-2d02-4f27-871d-aa54cb12315b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3344",
    name: "Wadebridge Superstore",
    region: "England",
    country: "GB",
    uuid: "925f5013-2458-4573-a060-ae404ac64dd5",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3345",
    name: "Warrington Extra",
    region: "England",
    country: "GB",
    uuid: "3d1a99f9-1edb-4366-bad7-2e9410b03ce1",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3349",
    name: "Romford Marlborough Express",
    region: "England",
    country: "GB",
    uuid: "cd058e31-039f-4309-a4f2-7f6831ed689e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3352",
    name: "Norwich Wroxham Rd Express",
    region: "England",
    country: "GB",
    uuid: "17d02498-2d62-4fe3-9bb3-00c0ff3687bf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3356",
    name: "Waltham Abbey Superstore",
    region: "England",
    country: "GB",
    uuid: "e22ee199-c8ae-47d0-a33e-2e715ee76ad7",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3359",
    name: "Walthamstow Hoe St Esso Express",
    region: "England",
    country: "GB",
    uuid: "36b78b1c-60dc-4644-afc7-f59b4c8461fa",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3361",
    name: "Bullsmoor Ln Esso Express",
    region: "England",
    country: "GB",
    uuid: "bf94c554-1ab1-4da7-bf41-6438e6789616",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3366",
    name: "Hamlet Court Express",
    region: "England",
    country: "GB",
    uuid: "c98e0af2-b06c-4bb1-a0a7-d1b3778e6130",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3370",
    name: "Warwick Superstore",
    region: "England",
    country: "GB",
    uuid: "8bb464c4-0007-4dc7-bd21-13dead910800",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3372",
    name: "Watford Extra",
    region: "England",
    country: "GB",
    uuid: "ea7d0219-77b8-40a2-ab73-1370c4442c2d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3374",
    name: "Wednesfield Esso Express",
    region: "England",
    country: "GB",
    uuid: "ae2f78ef-04f8-4729-b8a3-e2e4e7e19d7f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3376",
    name: "West Moors Express",
    region: "England",
    country: "GB",
    uuid: "9a29a396-48d4-4b4d-97cd-3aa0f825a016",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3377",
    name: "Northampton Weston Favell Extra",
    region: "England",
    country: "GB",
    uuid: "b3ab9beb-e2fc-4209-b0ce-2133d7c2d150",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3378",
    name: "Stockport Extra",
    region: "England",
    country: "GB",
    uuid: "ec8c4c25-787a-425b-9667-204564161bba",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3380",
    name: "Victoria Park Superstore",
    region: "England",
    country: "GB",
    uuid: "03db0da9-4a16-4632-bfd4-3413740d9b04",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3381",
    name: "Old Woking Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "8095cca7-1d61-4e38-a35a-5a36213e2a55",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3385",
    name: "Wells Superstore",
    region: "England",
    country: "GB",
    uuid: "aa3160b8-2726-44f9-9ec1-f35bdccc3171",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3386",
    name: "Shirley W Wickham Esso Express",
    region: "England",
    country: "GB",
    uuid: "63e39bf0-b2f3-4496-81ee-9dbf9e1bc2b7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3387",
    name: "Weston-super-mare Superstore",
    region: "England",
    country: "GB",
    uuid: "f116a9b7-28ea-4ecb-846c-6b71a9275359",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3393",
    name: "Winchmore Hill Esso Express",
    region: "England",
    country: "GB",
    uuid: "51de8bf3-3302-4152-ac6a-4725fedf21d3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3395",
    name: "Whitton Express",
    region: "England",
    country: "GB",
    uuid: "ce7212f6-e493-4604-83f0-69a1c744c658",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3397",
    name: "Whitchurch Express",
    region: "Wales",
    country: "GB",
    uuid: "3c314269-afcb-4f9e-9939-9922383100ce",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "3398",
    name: "Stafford Extra",
    region: "England",
    country: "GB",
    uuid: "c7fd1559-3883-455d-816a-569a9d6282b7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3399",
    name: "West Molesey Hurst Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "8a766f40-3c1a-4da6-93ec-a8e41311bf1c",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3401",
    name: "Whitstable Extra",
    region: "England",
    country: "GB",
    uuid: "7e20e2d9-e01f-4b0c-84ba-8e15aaa1f7af",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3404",
    name: "Windsor Superstore",
    region: "England",
    country: "GB",
    uuid: "23278068-2354-45c9-a583-ae0784b3bed5",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3406",
    name: "Winchester Extra",
    region: "England",
    country: "GB",
    uuid: "44ef7ef5-d57c-4278-9a37-b5261c1edc33",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3407",
    name: "Doncaster Wheatley Hill Express",
    region: "England",
    country: "GB",
    uuid: "acfe2d39-8855-4b98-a076-6d60046d27f4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3411",
    name: "Wokingham Superstore",
    region: "England",
    country: "GB",
    uuid: "e0f2a247-1372-457e-b4f0-c8c219a7781f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3417",
    name: "Witham Superstore",
    region: "England",
    country: "GB",
    uuid: "ab032e2b-1b9b-41d6-9d64-eaeb1a7c13b0",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3424",
    name: "Whitchurch Esso Express",
    region: "England",
    country: "GB",
    uuid: "970169fb-face-4152-a7bc-b737c1e5325d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3425",
    name: "Fareham Whiteley Superstore",
    region: "England",
    country: "GB",
    uuid: "47f0aedf-0926-42e0-b71e-7c7befc97ecf",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3426",
    name: "Wigan Extra",
    region: "England",
    country: "GB",
    uuid: "6bbe02b1-a09b-42b9-87d7-7605025175e4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3429",
    name: "Workington Superstore",
    region: "England",
    country: "GB",
    uuid: "bf8a5c62-e93c-4e8b-9081-386235eacfe4",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3430",
    name: "Worcester Superstore",
    region: "England",
    country: "GB",
    uuid: "d9ec3faf-31b0-4919-b890-c01dfc592a25",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3432",
    name: "Glenmoor Rd Bournemouth Express",
    region: "England",
    country: "GB",
    uuid: "50bc1743-36e4-4578-b64b-cad15cf786a7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3433",
    name: "Wrexham Extra",
    region: "Wales",
    country: "GB",
    uuid: "1fe2bf89-1365-43e1-b6bd-464563831736",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3439",
    name: "Worksop Gateford Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "9c720ee4-b43b-4628-8d70-e3963ba24731",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3440",
    name: "Worcester Warndon Superstore",
    region: "England",
    country: "GB",
    uuid: "61f6d745-0fc5-437c-8bef-aca4a6a7f3d4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3442",
    name: "Terriers North Esso Express",
    region: "England",
    country: "GB",
    uuid: "4593ac81-d5a3-40c7-86d9-6631f69aa641",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3443",
    name: "High Wycombe South Esso Express",
    region: "England",
    country: "GB",
    uuid: "5057b3e8-964b-427c-97ea-8b655c257b2f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3445",
    name: "Wood Green Express",
    region: "England",
    country: "GB",
    uuid: "eab6f4a1-70aa-4995-952b-0d437b936dbb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3446",
    name: "Croydon Whitehorse Rd Express",
    region: "England",
    country: "GB",
    uuid: "59b43b17-a1ec-4e41-8c41-e2aebbbcc325",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3447",
    name: "Woodingdean Esso Express",
    region: "England",
    country: "GB",
    uuid: "c682d6ca-a91f-4b60-be03-f36f1228bb92",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3450",
    name: "Woodley Express",
    region: "England",
    country: "GB",
    uuid: "5fdbff52-3203-4096-9543-4857512d2e78",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3458",
    name: "White City Express",
    region: "England",
    country: "GB",
    uuid: "76523845-ec3f-415a-bfd0-aea028ea8100",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3460",
    name: "Totton Express",
    region: "England",
    country: "GB",
    uuid: "d1a97323-123b-41d3-8d03-0987927eef8b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3463",
    name: "Warndon Express",
    region: "England",
    country: "GB",
    uuid: "1d87a0f0-dc8b-43db-9ea2-b3fef05720f1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3464",
    name: "Liverpool Wavertree Express",
    region: "England",
    country: "GB",
    uuid: "40b99a5a-0a81-4f12-ae44-62c5ee535019",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3465",
    name: "Southampton Wessex Rd Express",
    region: "England",
    country: "GB",
    uuid: "aab5ab67-58b0-45b5-b582-b82fce27d1e8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3467",
    name: "Chelsea Royal Hospital Rd Express",
    region: "England",
    country: "GB",
    uuid: "8e130bd0-75f1-454f-9fef-e096baf377c6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3470",
    name: "Hayes Yeading Extra",
    region: "England",
    country: "GB",
    uuid: "609d6d9b-1bdb-45a8-ad69-cd03c333e184",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3471",
    name: "Yate Station Rd Express",
    region: "England",
    country: "GB",
    uuid: "bba55247-7cdb-4be4-bf23-c871ca213e30",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3472",
    name: "Acomb Wood Express",
    region: "England",
    country: "GB",
    uuid: "9fb8be80-dce8-48ac-8bbc-2feba8690559",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3476",
    name: "Hengoed Ystrad Mynach Superstore",
    region: "Wales",
    country: "GB",
    uuid: "cab69698-bbe9-4320-b899-80da71617164",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3477",
    name: "Dartmouth Park Express",
    region: "England",
    country: "GB",
    uuid: "54deee7a-828f-4b7d-8069-741d5a7cbccd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3480",
    name: "York Extra",
    region: "England",
    country: "GB",
    uuid: "43524559-fda4-4b00-9843-fa2940edff2b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3481",
    name: "Weybridge Queens Rd Express",
    region: "England",
    country: "GB",
    uuid: "fd678000-52a8-4a7c-9446-2606a2ecc5ab",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3484",
    name: "Putney Express",
    region: "England",
    country: "GB",
    uuid: "f83e1c6d-e7bc-4f31-b604-21f1f48625ec",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3485",
    name: "Shaw Ramleaze Dr Express",
    region: "England",
    country: "GB",
    uuid: "bf0f4edb-aab6-48d9-84b5-84bf23f57c3c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3488",
    name: "Askham Bar Extra",
    region: "England",
    country: "GB",
    uuid: "6805c047-30a3-4553-8311-004c309c69d3",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3490",
    name: "Great Yarmouth Extra",
    region: "England",
    country: "GB",
    uuid: "5b71c464-d358-4ff1-b9f3-b57aeb76c53c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3492",
    name: "Nenagh Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "cbe39cbc-d54b-4c72-9c62-c7ddac68d5da",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3493",
    name: "Yeovil Extra",
    region: "England",
    country: "GB",
    uuid: "d03ba9ff-b552-43bf-b7b2-4583ea7d5ba4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3506",
    name: "Greystones Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "b14b6cbb-7f3f-4119-9921-932a7e91ad0b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3514",
    name: "Mullingar Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "a54f0c1c-b108-4dfe-8dfd-1614cc72dad4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3519",
    name: "Ennis Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "10311b7f-e022-499b-984a-05b425bf710b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3524",
    name: "Sligo Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "ffba23dd-1741-44b9-aad1-d00b7a6ebc4f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3548",
    name: "Bloomfields Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "9b563224-c3e8-41ee-8c0f-2c5d2082fee0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3549",
    name: "Wilton Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "e029f316-492c-4faf-af23-2f7634e76b6e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3564",
    name: "Longford Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "5ace4b01-8d6c-42f1-8a8f-d09583b20875",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3569",
    name: "Galway SC",
    region: "Irish Republic",
    country: "IE",
    uuid: "93bc3f36-190a-414a-8b0d-1ac9b5361838",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3575",
    name: "Notte St Express",
    region: "England",
    country: "GB",
    uuid: "0d13a5cf-bba3-42f3-bf76-758f80405237",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "3580",
    name: "Navan Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "743c9d84-46ba-4496-bd61-9f0d40e11db1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3635",
    name: "Mahon Point Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "000b7578-8ced-4939-a3b3-f25b0e509245",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3644",
    name: "Clarehall Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "d5a765ef-31e2-4ef6-91c4-dfea10c4bc5f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3679",
    name: "Castlebar Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "b3441261-ce82-4a07-8189-2c24a5a283e8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3682",
    name: "Killarney Park Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "0ab76e1e-360b-46d2-85db-8808d197f145",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3683",
    name: "Finglas Clearwater Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "0a253af4-6ce6-4717-a188-8f2ec43ac60a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3692",
    name: "Letterkenny Square Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "d1754f85-879a-4aab-8310-7d298dea7727",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3693",
    name: "Carlow Square Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "c7096d51-f846-4e8c-9fdc-d22bf415b35d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "3695",
    name: "Ardkeen Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "d627899d-b1e5-4157-a821-bf70eab1d19b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "4335",
    name: "Bedfont Staines Express",
    region: "England",
    country: "GB",
    uuid: "eb6cea1d-f41c-4f8d-a495-8f5c0dfdb259",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4337",
    name: "Braintree Coggeshall Express",
    region: "England",
    country: "GB",
    uuid: "131767dc-e705-4496-93d4-52a52adc3730",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4338",
    name: "Faringdon Superstore",
    region: "England",
    country: "GB",
    uuid: "e3befb93-def3-40da-a9a6-22121771732d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4341",
    name: "Gosport Superstore",
    region: "England",
    country: "GB",
    uuid: "ccc45ae3-b747-44df-8fbd-1e2e987b847c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4342",
    name: "Streatham Extra",
    region: "England",
    country: "GB",
    uuid: "97403b24-3741-4a2f-a5a6-1d74dcf3e41e",
    services: {
      collect: false,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4343",
    name: "Waterlooville Express",
    region: "England",
    country: "GB",
    uuid: "a74dbbcf-88cf-4776-941a-e141d18d6042",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4347",
    name: "Hetton Le Hole Express",
    region: "England",
    country: "GB",
    uuid: "8d4ced02-f257-4e42-a059-a2472e0318f7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4349",
    name: "Sharrow Express",
    region: "England",
    country: "GB",
    uuid: "b272066c-0eae-4e12-8b82-1ffbc8aedaeb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4353",
    name: "Airdrie Express",
    region: "Scotland",
    country: "GB",
    uuid: "18dcb8e9-c50f-4259-ac29-0defc43c076f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4355",
    name: "Windmillhill Express",
    region: "Scotland",
    country: "GB",
    uuid: "f00b65d9-181b-4453-927a-4acc4b033f6f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4356",
    name: "Chertsey Express",
    region: "England",
    country: "GB",
    uuid: "62e79380-d684-4f48-a79a-6e25ee85c6fe",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4359",
    name: "Bermondsey Spa Express",
    region: "England",
    country: "GB",
    uuid: "ced04950-3957-41ee-b358-80b0a8072599",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4362",
    name: "Lincoln Extra",
    region: "England",
    country: "GB",
    uuid: "b7442434-d757-4f96-a2fe-0c9e4296b31b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4365",
    name: "Haydock Vicarage Rd Express",
    region: "England",
    country: "GB",
    uuid: "c70b4bab-2f38-4f83-92b7-fca604cd3807",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4369",
    name: "Barnstaple High St Express",
    region: "England",
    country: "GB",
    uuid: "f83c3212-996d-4645-af3c-1fa0afe3e56d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4371",
    name: "Ipswich Norwich Express",
    region: "England",
    country: "GB",
    uuid: "23d47168-9223-4353-90be-93c4c021fe62",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4372",
    name: "Blythe Bridge Uttoxeter Express",
    region: "England",
    country: "GB",
    uuid: "5326532f-ed94-4548-b492-481fe7224af3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4375",
    name: "Wisbech Extra",
    region: "England",
    country: "GB",
    uuid: "38a16f85-7572-4a50-bfe0-4f8a49b47e71",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4376",
    name: "Mitcham Streatham Rd Express",
    region: "England",
    country: "GB",
    uuid: "6baa2243-0f77-4221-8f30-fac9cfd596f1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4377",
    name: "Abingdon Rd Express",
    region: "England",
    country: "GB",
    uuid: "8eeace01-8178-41c1-bc8f-076900893d00",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4380",
    name: "Romsey Rd Southampton",
    region: "England",
    country: "GB",
    uuid: "74b5d970-ff42-47a5-bfa5-8037c970268d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4381",
    name: "Ipswich Foxhall Express",
    region: "England",
    country: "GB",
    uuid: "6f42e66b-a12f-4a42-93c6-70e57ed2ca11",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4382",
    name: "St Ives Needingworth Express",
    region: "England",
    country: "GB",
    uuid: "57f82589-74c7-4af4-9187-0e538b6128d0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4392",
    name: "Canterbury New Dover Express",
    region: "England",
    country: "GB",
    uuid: "b461d75a-36f7-4826-9c28-ad68284984f5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4395",
    name: "Taplow Superstore",
    region: "England",
    country: "GB",
    uuid: "5894c74d-6d2b-4f02-bae3-994e8c0c6e03",
    services: {
      collect: true,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4396",
    name: "Colchester Magdalen Express",
    region: "England",
    country: "GB",
    uuid: "876d204c-5629-48db-ae75-2e268701e680",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4397",
    name: "Stony Stratford Express",
    region: "England",
    country: "GB",
    uuid: "ce7a69e4-054d-483a-ba3b-db738e031be2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4400",
    name: "Bow Gladstone Express",
    region: "England",
    country: "GB",
    uuid: "e342faf2-0885-45a6-936f-ef3369499024",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4407",
    name: "South Parks Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "eee46ddb-95df-4a1b-a63a-619850e41487",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4410",
    name: "Hope St Express",
    region: "Scotland",
    country: "GB",
    uuid: "778e1abd-6803-41a0-acfd-d1c2bc1d04f2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4413",
    name: "Tuckton Rd Express",
    region: "England",
    country: "GB",
    uuid: "b016ff34-b732-4abd-bf27-8fa7a0589fbb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4415",
    name: "Old Dumbarton Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "da1201f7-b21c-42b0-ac6b-b59900280d47",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4423",
    name: "Kinson Superstore",
    region: "England",
    country: "GB",
    uuid: "959ccb67-641e-4924-ab0a-02ddae21ad27",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4425",
    name: "Dunfermline Fire Station Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "d2c2ffef-4c96-46b2-b2a6-5e0ae95a79b7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "4428",
    name: "Linwood Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "08ac73c4-55c3-438a-b2c7-d8082395920d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "4429",
    name: "Tavistock Superstore",
    region: "England",
    country: "GB",
    uuid: "992afeeb-0aee-4b59-9983-fe7313f03a38",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4431",
    name: "Reading Whitley St Express",
    region: "England",
    country: "GB",
    uuid: "d8aef018-bb1d-4415-b2ad-63b07719ae51",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4436",
    name: "Kilburn High Rd Express",
    region: "England",
    country: "GB",
    uuid: "2a37f8f6-6eb3-4820-beab-a55aafe22537",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4445",
    name: "Calne Superstore",
    region: "England",
    country: "GB",
    uuid: "38af3c61-b973-4a36-8e17-c4e42d1da060",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4447",
    name: "Queensway Express",
    region: "England",
    country: "GB",
    uuid: "cd3d8240-6af5-4a61-8958-6a0c5723cd4c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4449",
    name: "Ballincollig Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "651cb7f9-38d3-4239-8f69-4abd2da5d9e1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "4451",
    name: "Liverpool Great Crosshall Express",
    region: "England",
    country: "GB",
    uuid: "eedd2215-335b-4c92-a7c7-dd241a9db3ce",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4457",
    name: "Canons Park Express",
    region: "England",
    country: "GB",
    uuid: "321459c1-4ae7-4065-b2f7-e9a08505dc26",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4466",
    name: "Farnborough Cove Rd Express",
    region: "England",
    country: "GB",
    uuid: "61da92a6-4426-4352-9089-b61e5582863e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4469",
    name: "Bath Weston Express",
    region: "England",
    country: "GB",
    uuid: "4afb6f4d-3d60-47c6-bed5-e0c264b9f6ac",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4472",
    name: "Peterborough Oundle Rd Express",
    region: "England",
    country: "GB",
    uuid: "d79a2721-f43b-4afc-b501-e92486730ba6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4473",
    name: "Coatbridge Express",
    region: "Scotland",
    country: "GB",
    uuid: "17315824-3ec3-46ba-9580-19d7e125c8ee",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4476",
    name: "Trymwood Express",
    region: "England",
    country: "GB",
    uuid: "2adea801-d4f3-4ba5-aaa5-d8373fe3b9b2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4480",
    name: "Bicester Superstore",
    region: "England",
    country: "GB",
    uuid: "119b2166-1930-4808-b60d-3395effcf581",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4483",
    name: "Newmarket Extra",
    region: "England",
    country: "GB",
    uuid: "a1f91daf-8d3a-4fd4-9490-e0dbab1261e9",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4485",
    name: "Kendal Highgate Express",
    region: "England",
    country: "GB",
    uuid: "f57e6229-55a4-475a-9165-e560d8ea862f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4490",
    name: "Molesey Rd Express",
    region: "England",
    country: "GB",
    uuid: "c9dbf234-3d56-47e0-858e-c97a49e5399d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4498",
    name: "Hailsham South Rd Express",
    region: "England",
    country: "GB",
    uuid: "4f562ab3-7404-4ae2-bd05-ab3b124f353c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4502",
    name: "Ruxley Ln Express",
    region: "England",
    country: "GB",
    uuid: "edb2bc42-bb66-4c69-a91d-da48df200584",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4503",
    name: "London Rd Express",
    region: "England",
    country: "GB",
    uuid: "6dc49c03-282c-412d-a72e-820129ad9c3a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4505",
    name: "Rotherham Extra",
    region: "England",
    country: "GB",
    uuid: "04fcc70b-6099-4858-9bbd-f5a33aa06e75",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4506",
    name: "Bridgewater Extra",
    region: "Northern Ireland",
    country: "GB",
    uuid: "0ad0da71-9d27-4665-a549-09b4c6c61306",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "4508",
    name: "Hereford Buckingham Express",
    region: "England",
    country: "GB",
    uuid: "c31403e1-b857-408e-9f74-d9021ce50271",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4517",
    name: "Sheffield Beighton Express",
    region: "England",
    country: "GB",
    uuid: "984ebebc-fa34-47a2-badf-4cd10e5713eb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4540",
    name: "Hillingdon Pield Rd Express",
    region: "England",
    country: "GB",
    uuid: "c563af14-6f6f-4a21-8137-0f3291702e9a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4541",
    name: "Spring Grove Express",
    region: "England",
    country: "GB",
    uuid: "4ebc6455-6426-45aa-9f38-77f9538d2627",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4558",
    name: "Silverdale Rd Express",
    region: "England",
    country: "GB",
    uuid: "6b9038f1-5fd3-48fb-b853-a07e803eba95",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4560",
    name: "Greetland Express",
    region: "England",
    country: "GB",
    uuid: "07311744-4c1e-4da2-9b53-0a9e9a7eb73b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4561",
    name: "Barrack Rd Express",
    region: "England",
    country: "GB",
    uuid: "95397999-8e71-4658-b5ae-b67b0c237e91",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4563",
    name: "Putney Upper Richmond Rd Express",
    region: "England",
    country: "GB",
    uuid: "c58ca7a8-f78d-465f-a56b-831928ca8358",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4564",
    name: "Bromley Plaistow Ln Express",
    region: "England",
    country: "GB",
    uuid: "7cf5325e-0874-429e-a1fb-889472dcb71f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4573",
    name: "Hemel Fletcher Way Express",
    region: "England",
    country: "GB",
    uuid: "c25a9fa1-f194-431b-9e3b-860f48c590f3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4577",
    name: "Archway Holloway Rd Express",
    region: "England",
    country: "GB",
    uuid: "4963b0d7-639d-40ae-be13-32670381b31f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4579",
    name: "Fratton Extra",
    region: "England",
    country: "GB",
    uuid: "78174853-fd6d-493f-95b6-daec71717c92",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4614",
    name: "Cavalier Way Express",
    region: "England",
    country: "GB",
    uuid: "fad132d6-646d-409d-93a8-51879ebf2398",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4615",
    name: "Basingstoke Oakridge Rd Express",
    region: "England",
    country: "GB",
    uuid: "236b4c78-2044-40a8-bc04-ff0fb3ca165f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4618",
    name: "Bristol Hatchet Rd",
    region: "England",
    country: "GB",
    uuid: "f0ddeb69-5a5b-438c-a509-b7b2d0fc3c67",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4624",
    name: "Sheffield Crosspool Express",
    region: "England",
    country: "GB",
    uuid: "b23a8559-7071-4688-800f-b84f07dba557",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4625",
    name: "Plymouth Alex Rd Express",
    region: "England",
    country: "GB",
    uuid: "e45eab5c-caaf-4cfd-b62b-3dd38edc7974",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4630",
    name: "Aberystwyth Superstore",
    region: "England",
    country: "GB",
    uuid: "d0be48eb-302c-4e12-9d19-c57fb5bffec4",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4642",
    name: "Salisbury Wilton Express",
    region: "England",
    country: "GB",
    uuid: "22938cbd-ce5b-4f4d-98e5-7d4b1c2ccd7f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4647",
    name: "Whyteleafe Express",
    region: "England",
    country: "GB",
    uuid: "0950905c-87da-430e-b2b5-b157095523f0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4659",
    name: "Haymarket Tower Express",
    region: "England",
    country: "GB",
    uuid: "d56132d7-b7c3-4cef-b160-d04e626d4e22",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4672",
    name: "Market Place Hull Express",
    region: "England",
    country: "GB",
    uuid: "f362c25c-f74a-4622-8f9d-a70083b2db6e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4673",
    name: "Swansea Mariner Street Express",
    region: "Wales",
    country: "GB",
    uuid: "557a19ca-7f28-4a59-8d80-5f26655d7c12",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "4676",
    name: "Martletts Crawley Express",
    region: "England",
    country: "GB",
    uuid: "3357fe45-9201-475a-919e-74260a155622",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4677",
    name: "Crossways Slough Express",
    region: "England",
    country: "GB",
    uuid: "8c9b8c4c-8ff4-4d91-9e19-c1c0938e19a2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4680",
    name: "Woking Commercial Way Express",
    region: "England",
    country: "GB",
    uuid: "2ecc4b7b-d45d-4f5b-ab9a-d20fd045eacc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4683",
    name: "Baker Street",
    region: "England",
    country: "GB",
    uuid: "84aeaa64-02e8-41f3-8473-e446f8db83ff",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4688",
    name: "Park Lane Tottenham Exp",
    region: "England",
    country: "GB",
    uuid: "43789ce4-38a6-42eb-b97c-e32a35dacde7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4690",
    name: "Staines High Street Express",
    region: "England",
    country: "GB",
    uuid: "9d900e46-f8ab-4a47-8fdc-4a214c5c18fe",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4693",
    name: "New Road Chingford",
    region: "England",
    country: "GB",
    uuid: "2b4d055c-c12b-4b54-9d25-ae0d622a5c59",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4694",
    name: "Dumont Express",
    region: "England",
    country: "GB",
    uuid: "2754ea08-18c7-45f4-bc13-6e8f9f054ac4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4754",
    name: "Peckham High Street Express",
    region: "England",
    country: "GB",
    uuid: "074285cb-8830-4f15-b345-309a79e481d4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4757",
    name: "Beaumont Road Express",
    region: "England",
    country: "GB",
    uuid: "5b41dcc1-3b24-4385-b51d-7d7c578c81b2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4758",
    name: "Wolverhampton Superstore",
    region: "England",
    country: "GB",
    uuid: "65e96d9f-9914-445b-9890-37784bc6d015",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4760",
    name: "Guildford Railton Road Express",
    region: "England",
    country: "GB",
    uuid: "718acb53-0af6-43cd-b012-cda6baf5e61a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4761",
    name: "Esher High Street Express",
    region: "England",
    country: "GB",
    uuid: "0319453c-cfd6-417b-a618-52a74bed221d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4766",
    name: "Portchester Express",
    region: "England",
    country: "GB",
    uuid: "1dabbdb1-d371-4ece-9486-354bb447603b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4767",
    name: "Pentewan Road Express",
    region: "England",
    country: "GB",
    uuid: "a5faf032-b8ae-4d73-890e-a69f163b508e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4771",
    name: "Beaufort House Express",
    region: "England",
    country: "GB",
    uuid: "e018e9dd-77fe-41dc-bacd-b7687217c726",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4776",
    name: "Lincoln Brayford Express",
    region: "England",
    country: "GB",
    uuid: "d5667748-3f8b-4e21-a656-e9c4a4de92b1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4779",
    name: "Chinese Garage Express",
    region: "England",
    country: "GB",
    uuid: "ec03d66a-8512-4857-9aab-2cf7d7077b55",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4781",
    name: "Swansea Treboeth Express",
    region: "Wales",
    country: "GB",
    uuid: "478aa16d-9096-4240-8047-39ed2c6edbed",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "4783",
    name: "Toothill Village Centre",
    region: "England",
    country: "GB",
    uuid: "2c6b303e-0c0b-4934-bb0b-cfd41823d951",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4784",
    name: "Orchard Park Express",
    region: "England",
    country: "GB",
    uuid: "db5bf8cd-67db-4470-ac33-1b374e238c16",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4786",
    name: "Sefton Express",
    region: "England",
    country: "GB",
    uuid: "5502b521-3cb1-4d47-8ed1-03418249cb29",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4787",
    name: "Altrincham Express",
    region: "England",
    country: "GB",
    uuid: "793f8dbc-d031-4ae7-b8ee-8e67cba18d7b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4791",
    name: "Chessington Express",
    region: "England",
    country: "GB",
    uuid: "4cf2dff6-d2bc-4f00-b466-ec31eadbd99a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4792",
    name: "Urmston Davyhulme Express",
    region: "England",
    country: "GB",
    uuid: "891c4651-4145-4a5c-8686-6b9d605d8ce4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4793",
    name: "Wisbech Express",
    region: "England",
    country: "GB",
    uuid: "364f08f4-5832-4bf5-bd95-a28823112213",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4794",
    name: "Kirby Express",
    region: "England",
    country: "GB",
    uuid: "950c9aff-37a2-4624-abaa-156e8baa9fd1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4795",
    name: "Garforth Express",
    region: "England",
    country: "GB",
    uuid: "27f3c742-11f8-44cf-b70e-ba0b4ed20d91",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4797",
    name: "Malinslee Express",
    region: "England",
    country: "GB",
    uuid: "8f3a53da-64dd-4800-9ea6-1714b1cb8244",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4798",
    name: "Telford Woodside Express",
    region: "England",
    country: "GB",
    uuid: "bcb53ad8-53ee-4212-8236-1ee0a3c7add7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4802",
    name: "Cramlington Express",
    region: "England",
    country: "GB",
    uuid: "521fa428-d58a-43b4-82b8-104b3070eb13",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4803",
    name: "Crookston Road",
    region: "Scotland",
    country: "GB",
    uuid: "9a2af6aa-d0e4-4ab1-ae3f-26aad4fbfc8b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4804",
    name: "Meadow Way Express",
    region: "England",
    country: "GB",
    uuid: "933b18b7-2b42-482a-823b-666e5e32454d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4806",
    name: "Castleford Express",
    region: "England",
    country: "GB",
    uuid: "a21c6e00-746c-4d8c-a50f-1903fbda1e64",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4807",
    name: "Crigglestone Express",
    region: "England",
    country: "GB",
    uuid: "c765f5ca-eae0-4c27-b5ed-7a50bd4aaf39",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4812",
    name: "Hampton Vale Express",
    region: "England",
    country: "GB",
    uuid: "ea06a159-c42c-4e00-be0a-f6d03f793f99",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4813",
    name: "Hardwicke Express",
    region: "England",
    country: "GB",
    uuid: "67f917e6-90b5-461f-b376-0a10a96d00b6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4814",
    name: "Bridlington Express",
    region: "England",
    country: "GB",
    uuid: "9ce0be72-fce7-4627-adc7-dd22fc46a67f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4817",
    name: "Eltham Express",
    region: "England",
    country: "GB",
    uuid: "3d5acfa8-ca76-42bd-b321-dfd8c45073ec",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4818",
    name: "Giffard Park Express",
    region: "England",
    country: "GB",
    uuid: "53676236-acfe-44bf-9333-695c1408d375",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4819",
    name: "Watford North Approach",
    region: "England",
    country: "GB",
    uuid: "00d61593-4922-4876-a192-2c0720aa6b40",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4821",
    name: "Beswick Express",
    region: "England",
    country: "GB",
    uuid: "20eefec6-1da4-4e36-a047-7fc3df6eec4f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4823",
    name: "Northern Moor",
    region: "England",
    country: "GB",
    uuid: "19c72964-d4f7-4aba-b07b-da09e0ad4116",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4824",
    name: "Northwood Express",
    region: "England",
    country: "GB",
    uuid: "7528dcda-40e3-4206-b942-2411fb3519ff",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4826",
    name: "Lichfield",
    region: "England",
    country: "GB",
    uuid: "4a04dca9-bb29-4167-aa78-4867699b259e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4827",
    name: "Springfield Express",
    region: "England",
    country: "GB",
    uuid: "b12c350e-e79e-420b-ab61-f8edd41e7ae2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4828",
    name: "Harwich Express",
    region: "England",
    country: "GB",
    uuid: "8d3b6c6a-4e06-4883-a030-6ca8e4916211",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4831",
    name: "Beaconsfield Express",
    region: "England",
    country: "GB",
    uuid: "7ae747e8-375c-4989-9de6-e65d406c3e97",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4833",
    name: "Nicol Street Express",
    region: "Scotland",
    country: "GB",
    uuid: "8a7b1881-1e5e-4fc1-b5d3-8336194d3ac0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4835",
    name: "Denmark Hill",
    region: "England",
    country: "GB",
    uuid: "c7b35cdc-9934-49aa-8748-acf3b430b844",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4840",
    name: "Bagot Street Express",
    region: "England",
    country: "GB",
    uuid: "e3a44428-8d52-4656-a661-cc4d0c2e2daf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4842",
    name: "Union Street Castlegate Express",
    region: "Scotland",
    country: "GB",
    uuid: "703cea13-a2e5-428d-8204-f1d2341e03d3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4843",
    name: "Coventry Bishopsgate Express",
    region: "England",
    country: "GB",
    uuid: "77386f6f-dcf9-4e41-9073-f8331c334dc0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4844",
    name: "Cambridge Christs Lane Express",
    region: "England",
    country: "GB",
    uuid: "ffc0573b-b051-454a-a0d1-6b1bbc671f5f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4846",
    name: "Stratford Upon Avon Express",
    region: "England",
    country: "GB",
    uuid: "a3c20568-1441-4f5f-b2db-ab303a0c0f56",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4847",
    name: "Moortown Express",
    region: "England",
    country: "GB",
    uuid: "356c7999-8645-4daa-8f59-59827373a45c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4854",
    name: "Pinner Express",
    region: "England",
    country: "GB",
    uuid: "ee528e13-6e51-46c5-8fdc-b5c35cdd77ad",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4875",
    name: "Sanderstead Express",
    region: "England",
    country: "GB",
    uuid: "8bef2a5b-2dd7-4390-a5e6-9677abe3d71c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4877",
    name: "Weymouth Express",
    region: "England",
    country: "GB",
    uuid: "9c25fcb8-95ee-41d6-bd81-538d9867f296",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4886",
    name: "Glasgow Queen Street Express",
    region: "Scotland",
    country: "GB",
    uuid: "d48bf46d-bef9-42fe-9918-53ce901b5cb1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "4888",
    name: "Twickenham Whitton Road Express",
    region: "England",
    country: "GB",
    uuid: "8a58f06b-733a-4774-bde7-f54088018987",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4890",
    name: "Solihull High Street Express",
    region: "England",
    country: "GB",
    uuid: "cd9e8b5b-f9bf-4f0f-9e28-1f658f41508f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4891",
    name: "Maylands Plaza Express",
    region: "England",
    country: "GB",
    uuid: "d7954d7f-9a3e-424d-8c5c-b46d4d1dfea8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4893",
    name: "High Street Winchester Express",
    region: "England",
    country: "GB",
    uuid: "80c73f88-c203-4602-b93c-43e5d730fe94",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4898",
    name: "PAIGNTON VICTORIA EXP",
    region: "England",
    country: "GB",
    uuid: "66636c80-95b1-46d1-9859-81f59e00e76e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4901",
    name: "Victoria Express",
    region: "England",
    country: "GB",
    uuid: "06d1c188-03b6-4ba7-b4d6-3d03556d90dc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4910",
    name: "Camden High Street Express",
    region: "England",
    country: "GB",
    uuid: "200c35ee-b6bd-463b-92f7-3508df75a9e9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4911",
    name: "Cutty Sark Express",
    region: "England",
    country: "GB",
    uuid: "40d34be8-a859-429c-bee6-4513adcf506d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4916",
    name: "Blackfriars Circus Express",
    region: "England",
    country: "GB",
    uuid: "4ae7f09f-6cd8-4202-893f-02a0b0ea8362",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4923",
    name: "Cringleford Express",
    region: "England",
    country: "GB",
    uuid: "f6dfda97-eac0-4d6e-ac40-35a757f73cda",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4926",
    name: "West Brompton Express",
    region: "England",
    country: "GB",
    uuid: "a2922097-91f7-42f5-9b7a-c37cefc6ffa6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4980",
    name: "REDDITCH STNDALNE C&C",
    region: "England",
    country: "GB",
    uuid: "30c448b5-7311-4e81-a228-f99fd20ec433",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5000",
    name: "Marlbrook Express",
    region: "England",
    country: "GB",
    uuid: "58d961a1-c5f7-43c6-b89c-fc05bde97b09",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5001",
    name: "Maidstone London Rd Express",
    region: "England",
    country: "GB",
    uuid: "03bb04b1-dd64-464f-95a6-78732eb19b82",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5003",
    name: "Milton Regis Express",
    region: "England",
    country: "GB",
    uuid: "e83f188c-93ed-4f6d-b28b-da3c6191dc5c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5004",
    name: "Thetford Norwich Rd Express",
    region: "England",
    country: "GB",
    uuid: "684c7bef-f5e4-40e6-baf7-ecf8bf125e4f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5012",
    name: "Dunstable Langdale Express",
    region: "England",
    country: "GB",
    uuid: "92c8a537-9bf3-4312-9eef-16c169a55277",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5014",
    name: "Evesham Worcester Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "8154d150-fec4-4e94-8711-64dd0d8ecb46",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5015",
    name: "Rowley Regis Express",
    region: "England",
    country: "GB",
    uuid: "df5fb92e-bd99-433c-8412-09d0f4346554",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5016",
    name: "March Broad St Express",
    region: "England",
    country: "GB",
    uuid: "a2989c8e-cd43-4d16-895f-bffab008cbe1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5019",
    name: "Lisieux Way Express",
    region: "England",
    country: "GB",
    uuid: "acceeb9d-4291-452e-a511-9a6980c06a31",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5020",
    name: "Appenine Way Express",
    region: "England",
    country: "GB",
    uuid: "327247b0-293b-45c5-a523-6a8e60782199",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5022",
    name: "Rotherham Brinsworth Ln Express",
    region: "England",
    country: "GB",
    uuid: "ce067583-96ff-4197-b462-bd22e482a145",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5023",
    name: "Milton Keynes Old Farm Park Express",
    region: "England",
    country: "GB",
    uuid: "0d553c8f-1383-4ee5-b3c6-80700f8280e1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5026",
    name: "Didcot Cockcroft Express",
    region: "England",
    country: "GB",
    uuid: "76f44b81-d442-4fe2-ab50-477c8696ec47",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5027",
    name: "Muscliffe Express",
    region: "England",
    country: "GB",
    uuid: "48fabb6d-7f05-4e35-9869-30e7a90d90d0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5031",
    name: "Newry Extra",
    region: "Northern Ireland",
    country: "GB",
    uuid: "71a8c3e9-2c60-4a79-9b49-47cb5660b7d5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5038",
    name: "Ribbleton Express",
    region: "England",
    country: "GB",
    uuid: "2a16b18e-1f6f-44d9-9224-f28da98f7282",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5040",
    name: "Notting Hill Gate Express",
    region: "England",
    country: "GB",
    uuid: "989ab0ef-7a00-4c6f-a5ad-164e45122a76",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5042",
    name: "Enfield Lock Express",
    region: "England",
    country: "GB",
    uuid: "86233c18-548d-4de3-bfc6-9c1d9c7be36d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5043",
    name: "Marsh Express",
    region: "England",
    country: "GB",
    uuid: "3b816c6d-36e9-4c2f-8fd8-196de8191330",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5045",
    name: "Forest Park Express",
    region: "England",
    country: "GB",
    uuid: "9c35641e-1b62-4c5b-a17c-4867510affe3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5047",
    name: "Burgess Hill Gatehouse Express",
    region: "England",
    country: "GB",
    uuid: "1654f559-440c-409b-b7dc-be555f1b3941",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5056",
    name: "Birmingham Corporation St Express",
    region: "England",
    country: "GB",
    uuid: "5f70335b-e1b9-42d2-ba0c-b10abdc2c2eb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5060",
    name: "Birstall Smithies Ln Express",
    region: "England",
    country: "GB",
    uuid: "69b892c1-e522-44b7-9fa9-1a2b979c90ae",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5061",
    name: "Shirley Express",
    region: "England",
    country: "GB",
    uuid: "72d51006-3b22-4bc2-a85b-c47c3c9af636",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5064",
    name: "Amington Express",
    region: "England",
    country: "GB",
    uuid: "208e19e8-fbf9-48c8-bfce-4c27de750f8e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5070",
    name: "Tinkers Bridge Express",
    region: "England",
    country: "GB",
    uuid: "c9a85d40-4e7c-4fa5-ad06-271d5f943812",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5071",
    name: "Norton Express",
    region: "England",
    country: "GB",
    uuid: "c653e733-5cc2-42c0-aa1b-53c2cd854346",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5073",
    name: "Moordown Express",
    region: "England",
    country: "GB",
    uuid: "2ceb2e67-dbbf-44cb-9ca9-73fb87dac19a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5075",
    name: "Parkstone Herbert Ave Express",
    region: "England",
    country: "GB",
    uuid: "3490d898-00c1-47c1-8857-72c8c497b102",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5077",
    name: "Ruislip Field End Rd Express",
    region: "England",
    country: "GB",
    uuid: "0e2836c2-db6f-497a-822e-f87677239ff4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5078",
    name: "Tiverton Moorhayes Park Express",
    region: "England",
    country: "GB",
    uuid: "70b6dc46-b2da-47da-b1dc-ffe305ae10d7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5079",
    name: "Hornchurch Ardleigh Express",
    region: "England",
    country: "GB",
    uuid: "1aa33819-a840-4495-b1df-1000dbe9d146",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5080",
    name: "Blackpool Central Dr Express",
    region: "England",
    country: "GB",
    uuid: "6cb6da81-29d9-46a7-8b9b-fab3cdeef3fc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5081",
    name: "Ashton-in-makerfield Esso Express",
    region: "England",
    country: "GB",
    uuid: "ae5fbeea-422a-4a8c-87d7-8132967877d2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5083",
    name: "Heywood York St Esso Express",
    region: "England",
    country: "GB",
    uuid: "52fbb89d-111f-4c6a-a83f-9da24d42ee00",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5084",
    name: "Eastwood Esso Express",
    region: "England",
    country: "GB",
    uuid: "a75ca0c0-fca5-4bac-af55-45ddb2c2dd1e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5085",
    name: "Yate Brimsham Park Express",
    region: "England",
    country: "GB",
    uuid: "9351e8f9-e5f7-4a92-a199-254823a4ef6d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5088",
    name: "Hanworth Express",
    region: "England",
    country: "GB",
    uuid: "c0603eae-eb4c-4708-9723-a88f300ca027",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5093",
    name: "Dalton Huddersfld Express",
    region: "England",
    country: "GB",
    uuid: "d4088d00-4a6e-461a-999b-2f076b8977a9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5094",
    name: "Bispham Express",
    region: "England",
    country: "GB",
    uuid: "507555fb-b90b-4a04-9775-fa1fb280a05d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5095",
    name: "Worle Express",
    region: "England",
    country: "GB",
    uuid: "f0824788-8cb6-4aed-b5fd-dff7c2697608",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5097",
    name: "Horsforth New Rd Express",
    region: "England",
    country: "GB",
    uuid: "66eff74e-1bfe-475e-bc45-39951f5a24f6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5098",
    name: "Coldfield Esso Express",
    region: "England",
    country: "GB",
    uuid: "5d519e85-11b3-47b0-87c5-21ea4de4045d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5099",
    name: "STOURBDG HALESOWEN EXPRESS",
    region: "England",
    country: "GB",
    uuid: "5f3b055e-f828-466d-b00f-609269b662d8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5101",
    name: "Paganhill Express",
    region: "England",
    country: "GB",
    uuid: "183a08ab-0554-4ed0-a22b-1065e0bc465e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5107",
    name: "Leeds Garforth Superstore",
    region: "England",
    country: "GB",
    uuid: "9bd23cdd-24f3-4788-844f-e40ca3098d84",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5110",
    name: "Carnforth Superstore",
    region: "England",
    country: "GB",
    uuid: "d82cd7c0-aa68-4c9b-8783-26efed3caf42",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5112",
    name: "Newton-le-willows Superstore",
    region: "England",
    country: "GB",
    uuid: "95dd60c9-92fb-4f5f-a1a8-2d6d0b326121",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5115",
    name: "Causewayside Express",
    region: "Scotland",
    country: "GB",
    uuid: "4834ec38-3701-4b83-addb-55a6b762ae6a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5117",
    name: "Bishopston Express",
    region: "England",
    country: "GB",
    uuid: "bce9f147-edab-465c-bcd6-463fafb6b7cd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5119",
    name: "Market Rasen Superstore",
    region: "England",
    country: "GB",
    uuid: "480bc9e1-98d0-4121-9641-8f44b903d1cf",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5121",
    name: "Sowerby Bridge Superstore",
    region: "England",
    country: "GB",
    uuid: "38b227ea-80e6-4742-a3a0-7e0c5b44336b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5124",
    name: "Rossendale Haslingden Superstore",
    region: "England",
    country: "GB",
    uuid: "349d5a68-c1db-4c9e-923f-bd5ecef297dc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5125",
    name: "Clacton-on-sea Superstore",
    region: "England",
    country: "GB",
    uuid: "23c41da3-2842-44e7-a8fe-c1d6bd52552f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5126",
    name: "Westhill Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "e17d9041-be2d-44e0-9317-aa992e3bd6f7",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5128",
    name: "Burnage Superstore",
    region: "England",
    country: "GB",
    uuid: "286d3c07-2492-47dd-b9a1-4f76c64a6016",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5129",
    name: "Pulborough Superstore",
    region: "England",
    country: "GB",
    uuid: "fc45a629-85ab-4b37-9e9f-1899e06851dc",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5130",
    name: "Monument Express",
    region: "England",
    country: "GB",
    uuid: "7e050303-6206-4e75-b61b-72972cb2a59f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5131",
    name: "Newtownbreda Extra",
    region: "Northern Ireland",
    country: "GB",
    uuid: "5059961a-6948-4444-98eb-bf6c068bbea7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5132",
    name: "Bradford Extra",
    region: "England",
    country: "GB",
    uuid: "a3da41cd-d37a-4e6c-80d8-85f1cd17736f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5133",
    name: "Wishaw Belhaven Extra",
    region: "Scotland",
    country: "GB",
    uuid: "faecbfba-e52a-4a73-878e-e4c8055cf4d4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5134",
    name: "Blairgowrie Welton Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "c9fb5e9d-c1e5-4aa4-9639-f291a818d4df",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5135",
    name: "Slough Extra",
    region: "England",
    country: "GB",
    uuid: "7ec779c2-c049-42b5-881d-37a903e016c5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5137",
    name: "Carrickfergus Castle Extra",
    region: "Northern Ireland",
    country: "GB",
    uuid: "863a73e4-200e-49b6-8fcd-2caa7bbcd108",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5138",
    name: "Tiverton Superstore",
    region: "England",
    country: "GB",
    uuid: "752b987a-f26e-471b-964d-8f3fa1842f8d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5140",
    name: "Colchester Bromley Rd Express",
    region: "England",
    country: "GB",
    uuid: "7cb232e3-131f-49d0-a849-37f27180286f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5142",
    name: "Woodville Express",
    region: "England",
    country: "GB",
    uuid: "0ca90fbd-9947-4379-95e4-fd1ce58298d5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5145",
    name: "Gillingham Sturdee Ave Express",
    region: "England",
    country: "GB",
    uuid: "d9b9ca65-99d5-49f8-85c9-a34e11963fb4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5146",
    name: "Doncaster Wentworth Rd Express",
    region: "England",
    country: "GB",
    uuid: "e40005bc-213b-42d2-8aa6-b214bb3d9b12",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5149",
    name: "Leicester Aberdale Rd Express",
    region: "England",
    country: "GB",
    uuid: "6bc8a87f-6c75-4ff1-80b5-50782b4e3521",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5150",
    name: "Earl Grey St Express",
    region: "Scotland",
    country: "GB",
    uuid: "c9a65c66-8d41-4ba7-bc9c-527a80a4cab6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5152",
    name: "Smithfield Express",
    region: "England",
    country: "GB",
    uuid: "8e45e867-44b7-46af-9180-8b6b2c741361",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5154",
    name: "Wellingborough Cannon St Express",
    region: "England",
    country: "GB",
    uuid: "a19c6661-ef01-42c7-affc-38fc60cb7f08",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5155",
    name: "Chichester South St Express",
    region: "England",
    country: "GB",
    uuid: "f1ad2955-7026-4f1c-9618-5abc6786a5c2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5156",
    name: "Fazakerley Longmoor Ln Express",
    region: "England",
    country: "GB",
    uuid: "781420b0-1820-4360-b48a-28faff530838",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5159",
    name: "Cleethorpes Grimsby Rd Express",
    region: "England",
    country: "GB",
    uuid: "4366ec6f-4445-444e-93ca-20fd79f440e6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5166",
    name: "Gloucester Lysons Ave Express",
    region: "England",
    country: "GB",
    uuid: "f7748337-62cc-4b27-ba5b-6e3a7a03124f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5167",
    name: "Farnham Hale Express",
    region: "England",
    country: "GB",
    uuid: "a05add5b-5b4d-4ff1-93a3-407f32cd2f27",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5168",
    name: "Coventry Cross Point Extra",
    region: "England",
    country: "GB",
    uuid: "275c3018-da44-49d5-8a75-60b5ab9e70b6",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5169",
    name: "Grimsby Extra",
    region: "England",
    country: "GB",
    uuid: "20335577-6a04-45af-8834-45900c0b02be",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5170",
    name: "Redruth Extra",
    region: "England",
    country: "GB",
    uuid: "54053ce1-5ea6-4691-a86c-dad043bb333b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5171",
    name: "Coatbridge Extra",
    region: "Scotland",
    country: "GB",
    uuid: "5066e9fa-f738-4959-b8ac-5f564f14e2a1",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5176",
    name: "Welwyn Express",
    region: "England",
    country: "GB",
    uuid: "ebc63294-e78a-40c8-9dd4-3119072aa75f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5182",
    name: "Wigston Superstore",
    region: "England",
    country: "GB",
    uuid: "ee582a01-3d18-4dd5-af28-b10033517052",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5184",
    name: "Hexham Extra",
    region: "England",
    country: "GB",
    uuid: "fe408126-8b29-4043-a7fc-83f98ecafd53",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5185",
    name: "Middlesbrough Coulby Newham Extra",
    region: "England",
    country: "GB",
    uuid: "8b667c7d-c1d3-4d7a-85ca-b83437ba393e",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5186",
    name: "Kentish Town Express",
    region: "England",
    country: "GB",
    uuid: "0475c929-21ce-4fab-a341-502666cbd106",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5187",
    name: "Middlesbrough Roman Rd Express",
    region: "England",
    country: "GB",
    uuid: "69d7e8f6-8ce6-4c38-b116-3e7c255a6580",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5188",
    name: "Armley Express",
    region: "England",
    country: "GB",
    uuid: "b4696764-8f28-4da9-b016-536f387271b8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5190",
    name: "Marylebone Melcombe St Express",
    region: "England",
    country: "GB",
    uuid: "dc569bb1-aa78-42a6-9fb1-e55353103a67",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5191",
    name: "Chigwell Manford Way Express",
    region: "England",
    country: "GB",
    uuid: "07d8d082-b58d-4daa-bf8a-37c98bac7572",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5192",
    name: "Heaton Haworth Rd Express",
    region: "England",
    country: "GB",
    uuid: "ebef0ca3-4957-4e01-977c-76065e97395a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5193",
    name: "Bolton Upon Dearne Express",
    region: "England",
    country: "GB",
    uuid: "fbf31bde-d7fd-451f-8193-bf6a105333df",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5194",
    name: "Bangor Extra",
    region: "Wales",
    country: "GB",
    uuid: "0c009e1b-b7b7-47d8-bf78-4144a2ca2ced",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "5196",
    name: "Chelmsford Broomfield Rd Express",
    region: "England",
    country: "GB",
    uuid: "45574c8c-1a99-44c3-9155-1c9f6e728b50",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5199",
    name: "Thamesmead Express",
    region: "England",
    country: "GB",
    uuid: "87534ef8-e58d-4fed-9606-8d26e5fb23de",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5200",
    name: "Anlaby Rd Express",
    region: "England",
    country: "GB",
    uuid: "e1221b83-693c-4147-ab65-9add7754b6f3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5201",
    name: "Hartlepool Catcote Rd Express",
    region: "England",
    country: "GB",
    uuid: "f405a7c6-8a06-44d4-88de-04fe1a6b9491",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5203",
    name: "Shirley Dickens Heath Express",
    region: "England",
    country: "GB",
    uuid: "e51dc45c-5931-4b31-90b3-94b624c0bbcd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5205",
    name: "Newport Malpas Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "2c995d7e-6171-4ab6-acdb-a5973ea87e85",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5207",
    name: "Birmingham Frankley Express",
    region: "England",
    country: "GB",
    uuid: "60989cc1-cd87-463b-8c29-452b6df606c0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5212",
    name: "Leyland Earnshaw Bridge Express",
    region: "England",
    country: "GB",
    uuid: "fe094508-0a62-4899-ad4f-bddd4cc71605",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5214",
    name: "Wimbledon Hill Express",
    region: "England",
    country: "GB",
    uuid: "7a79af71-dcaf-4b1f-8a95-08e807d844b8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5215",
    name: "East Dulwich Express",
    region: "England",
    country: "GB",
    uuid: "5b632d79-ee5a-4ebb-b74e-77cbd520622a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5217",
    name: "Clifton Regent St Express",
    region: "England",
    country: "GB",
    uuid: "c2b5dd5b-5525-4d60-ad9b-7537d8b3a60a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5220",
    name: "Oakley Vale Express",
    region: "England",
    country: "GB",
    uuid: "6dc0b5f7-4d47-4748-ae18-12a3a45ddd72",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5221",
    name: "Rochdale Whitworth Rd Express",
    region: "England",
    country: "GB",
    uuid: "fb154b2c-1bfc-4ffc-9db7-a45dfee8c1b4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5223",
    name: "Birmingham Hurst St Express",
    region: "England",
    country: "GB",
    uuid: "ab8cf94e-99c3-481a-9665-30bc08aa7332",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5225",
    name: "Stourbridge Audnam Express",
    region: "England",
    country: "GB",
    uuid: "7b5482b2-852a-4fe7-8b47-147c8f8b8375",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5226",
    name: "Folkestone Bouverie Rd Express",
    region: "England",
    country: "GB",
    uuid: "c5623768-a72d-4f87-9b13-f3c635082a6a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5229",
    name: "Blackburn Bank Top Express",
    region: "England",
    country: "GB",
    uuid: "2358fb43-b619-4209-b36d-ff8e7a2fbf97",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5230",
    name: "Colne Market St Express",
    region: "England",
    country: "GB",
    uuid: "0cec2376-1bc5-400b-916b-368e055d55e2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5233",
    name: "Uckfield Browns Ln Express",
    region: "England",
    country: "GB",
    uuid: "c025ad7d-a15e-44f6-a83f-9f0376d6f5d0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5234",
    name: "Crystal Palace Express",
    region: "England",
    country: "GB",
    uuid: "fe6b7ecc-eb4c-437b-bfea-875de1df7daa",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5235",
    name: "Bristol Wine St Express",
    region: "England",
    country: "GB",
    uuid: "69c9b551-55fa-4f58-abfc-74645c62c3e0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5238",
    name: "Strood Esso Express",
    region: "England",
    country: "GB",
    uuid: "8b70f36d-937f-4831-b2a4-39d7f753f51d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5239",
    name: "Dursley Cam Superstore",
    region: "England",
    country: "GB",
    uuid: "a0ebd8c5-54e0-4811-a628-6902fa3ac3fc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5241",
    name: "Westcliff-on-sea Rd Express",
    region: "England",
    country: "GB",
    uuid: "10b35051-ecad-4820-be49-eb0b0d7b9f15",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5242",
    name: "Haywards Heath Express",
    region: "England",
    country: "GB",
    uuid: "2c531d5e-a64f-46ef-bba2-5e4cd2645714",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5244",
    name: "High Rd Kilburn Express",
    region: "England",
    country: "GB",
    uuid: "b4fcc9a6-1157-47de-b904-4219f454e625",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5247",
    name: "Bristol Blenheim Court Express",
    region: "England",
    country: "GB",
    uuid: "e6c3b4ae-d8cb-4c6f-aacd-e7922862e52a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5249",
    name: "Swansea Llansamlet Extra",
    region: "Wales",
    country: "GB",
    uuid: "712706a7-d315-4984-999d-1559e7799aa1",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "5250",
    name: "Eastleigh Twyford Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "19ecf2a7-90b6-4ef8-b643-16952a6d835a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5251",
    name: "Bolton Wigan Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "4d87f290-0d9b-42c0-ab1a-012996454c63",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5252",
    name: "Cinderhill Express",
    region: "England",
    country: "GB",
    uuid: "76949b07-3515-4fc1-a3a8-fff237f1cb7f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5253",
    name: "Frinton Superstore",
    region: "England",
    country: "GB",
    uuid: "90f66796-6c2d-4b14-b00a-77c3cc06d206",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5254",
    name: "Acklam Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "2b0cd4c2-6825-4735-8507-af3fa32b210c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5256",
    name: "Exmouth Churchill Rd Express",
    region: "England",
    country: "GB",
    uuid: "72ab94c3-ef0e-4b2e-a244-c458cf598603",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5258",
    name: "Compton Esso Express",
    region: "England",
    country: "GB",
    uuid: "1ee04298-1af7-41b8-9b2c-95e4b375cbc8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5259",
    name: "Gloucester Eastern Ave Esso Express",
    region: "England",
    country: "GB",
    uuid: "5ce95441-db73-4bf2-8bb9-6ea40481db00",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5260",
    name: "King's Lynn Wootton Rd Express",
    region: "England",
    country: "GB",
    uuid: "295ad383-5dd1-414b-a3df-84afc13b46e7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5263",
    name: "Sale Manor Ave Express",
    region: "England",
    country: "GB",
    uuid: "65c4608e-37a2-4c11-8b93-5dca9ab55b16",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5264",
    name: "Blackpool Marton Express",
    region: "England",
    country: "GB",
    uuid: "c61c795e-085b-405c-8d03-873a1ea093f7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5268",
    name: "Cardiff Tyn-y-parc Express",
    region: "Wales",
    country: "GB",
    uuid: "a23a92c2-cfe7-4c95-97a8-bc3f7aa1524d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5270",
    name: "Sandwell Stone Cross Express",
    region: "England",
    country: "GB",
    uuid: "855aabb5-43b8-491f-9763-298223271d00",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5272",
    name: "Windle Island Express",
    region: "England",
    country: "GB",
    uuid: "1280df2e-78a1-425e-bf2f-de61895178a3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5274",
    name: "Middlesbrough Dixons Bank Express",
    region: "England",
    country: "GB",
    uuid: "8269842f-8b5c-4405-82c5-c9e5a09fd751",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5275",
    name: "Earlham Rd Express",
    region: "England",
    country: "GB",
    uuid: "c0790e12-b465-4831-ad17-486823924721",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5276",
    name: "Gosforth Express",
    region: "England",
    country: "GB",
    uuid: "d3518fa3-3471-4f23-96d0-3d4efcaac1f5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5277",
    name: "Warrington Winwick Rd Express",
    region: "England",
    country: "GB",
    uuid: "59867316-9146-4fa1-9d88-e69b71fe6148",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5278",
    name: "Willenhall Lichfield Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "5b70d71f-48a7-439a-a3b5-75713a8845b0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5279",
    name: "Rothwell Leeds Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "5e152ac0-ac95-44d3-b587-04c6fa6a5305",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5281",
    name: "Lakeside Point Express",
    region: "England",
    country: "GB",
    uuid: "b381631a-ab19-4ff3-a420-22c201aae0c7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5282",
    name: "Shoreditch Commercial St Express",
    region: "England",
    country: "GB",
    uuid: "66ac4ec5-12cb-48d4-91bb-864c461a3dff",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5283",
    name: "Great Junction St Express",
    region: "Scotland",
    country: "GB",
    uuid: "b85de8c5-0fbe-4f76-b581-c9124a6f8e01",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5284",
    name: "Norwich Plumstead Rd Express",
    region: "England",
    country: "GB",
    uuid: "2ad4c578-962b-42cd-8541-0f75c1952680",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5286",
    name: "Dunstable High St Esso Express",
    region: "England",
    country: "GB",
    uuid: "85d8f3fb-8793-4a70-932b-7913f1eba6c9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5287",
    name: "Hazel Grove Esso Express",
    region: "England",
    country: "GB",
    uuid: "24bf4c91-47fb-49e6-929c-64b886370605",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5290",
    name: "Huntly Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "7d169173-c4fb-4915-8940-df8709d23cbb",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5291",
    name: "Ilfracombe Superstore",
    region: "England",
    country: "GB",
    uuid: "1f86fa5f-4736-4eaa-a03b-245dc36f3a95",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5293",
    name: "Rutherglen Extra",
    region: "Scotland",
    country: "GB",
    uuid: "721be809-c5f6-4bda-a3fe-7f9e797139c0",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5297",
    name: "Clonmel Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "1b70cb77-a9d6-4966-ba91-74a592fbd791",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "5300",
    name: "Keith Moss St Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "693cc037-9ede-4afe-8689-aa477b56c579",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5306",
    name: "Maesteg Superstore",
    region: "Wales",
    country: "GB",
    uuid: "f772cf57-2794-4e12-bbcd-46fd16f95227",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "5307",
    name: "Silverburn Extra",
    region: "Scotland",
    country: "GB",
    uuid: "40344783-eb55-47d8-b7e0-c5c690bc24e0",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5309",
    name: "Manchester Quay St Express",
    region: "England",
    country: "GB",
    uuid: "ebf87994-fc81-4e8a-a902-12a626d30498",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5310",
    name: "Cardiff Salisbury Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "befbe784-6b0e-49a2-a487-61ca125568f7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5311",
    name: "Penge Croydon Rd Express",
    region: "England",
    country: "GB",
    uuid: "3ab0a919-67bc-487a-89cd-e61f1e7b63d7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5314",
    name: "Huntington Rd Express",
    region: "England",
    country: "GB",
    uuid: "5004dcf4-d6cb-43aa-be73-d7d10f5a052e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5316",
    name: "Parkstone Bournemouth Rd Express",
    region: "England",
    country: "GB",
    uuid: "be96552b-55f4-4d3c-bd7e-80850b3f34d3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5318",
    name: "Birmingham Rd Sutton Express",
    region: "England",
    country: "GB",
    uuid: "f752b30f-3fda-4686-8891-96b0c771a9ab",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5320",
    name: "Hatfield Station Rd Express",
    region: "England",
    country: "GB",
    uuid: "960e0ee3-f57f-495b-b51b-b65925ad0d8d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5321",
    name: "Brighton Jubilee St Express",
    region: "England",
    country: "GB",
    uuid: "55a2398a-4760-4cd9-86dc-e76bc8b75772",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5323",
    name: "Hindley Green Express",
    region: "England",
    country: "GB",
    uuid: "bae2d571-4e1d-4f03-9742-9af9c0069440",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5324",
    name: "Grangetown Corporation Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "02cd65d5-9276-48ce-b03e-977189e9f4f3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5326",
    name: "Haydock Church Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "e17bdfcd-a7b7-4597-808c-d0bf8f4664bf",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5329",
    name: "Nottingham Beeston Extra",
    region: "England",
    country: "GB",
    uuid: "3e9c672f-075b-492d-ae95-f5c05da5e5fb",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5330",
    name: "Wick Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "bfe5674e-93bb-473a-88da-05c9920a4489",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5331",
    name: "Carmarthen Extra",
    region: "Wales",
    country: "GB",
    uuid: "4621b458-7286-48fc-8f34-f3bd2dc58688",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "5332",
    name: "Shrewsbury Extra",
    region: "England",
    country: "GB",
    uuid: "f234abea-038c-4c25-9b29-1dae55a4e88f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5333",
    name: "Enniskillen Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "91e5f6b9-ee2e-4477-aa1f-5643ca166a50",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5335",
    name: "Ballymena Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "8975e7d4-5e4a-4b52-9d34-fd4e6a251795",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5336",
    name: "Galashiels Extra",
    region: "Scotland",
    country: "GB",
    uuid: "7d657234-7d46-49c2-a47e-dcd5df949d35",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5339",
    name: "Dalhousie Esso Express",
    region: "Scotland",
    country: "GB",
    uuid: "dff38c27-d38e-4f02-945b-5120b8c23e91",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5340",
    name: "Silksworth Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "54171f31-6d5e-4095-8b07-da4333d7fab0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5342",
    name: "Vauxhall Express",
    region: "England",
    country: "GB",
    uuid: "fb491585-106d-43d1-9b63-9d73dd1c9c50",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5343",
    name: "Colchester Crouch St Express",
    region: "England",
    country: "GB",
    uuid: "aa03e887-e92c-4e92-9aa6-8919e4dcfda1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5346",
    name: "Bearsted Esso Express",
    region: "England",
    country: "GB",
    uuid: "e0f22356-28ed-4990-8d3b-23fecd7c905a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5347",
    name: "Willesden Ln Kilburn Express",
    region: "England",
    country: "GB",
    uuid: "0a277616-f234-4caf-a285-77930ca0f143",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5348",
    name: "Leeds Easterly Rd Express",
    region: "England",
    country: "GB",
    uuid: "f611e833-9b79-4b73-a3d7-d130095e9d58",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5350",
    name: "Accrington Abbey St Esso Express",
    region: "England",
    country: "GB",
    uuid: "5cdd37bd-a8de-4bfd-81bb-21ece65a0569",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5352",
    name: "Pokesdown Express",
    region: "England",
    country: "GB",
    uuid: "1703bba0-6c3c-4286-999d-e4788cfffa78",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5357",
    name: "Hatch End Express",
    region: "England",
    country: "GB",
    uuid: "203737a2-47f6-431e-ae56-bd40ef1953bb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5358",
    name: "Streatham Place Express",
    region: "England",
    country: "GB",
    uuid: "1ef30949-6242-4b37-9864-4b6d76a15a73",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5360",
    name: "Hull Beverley Rd Express",
    region: "England",
    country: "GB",
    uuid: "5a7b9191-d940-4ff9-b0f1-5bbf766083da",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5363",
    name: "Gloucester Brockworth Extra",
    region: "England",
    country: "GB",
    uuid: "cb6a5e2d-98ad-4fc0-95d7-01b57a5c3a5f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5365",
    name: "Slough Wexham Rd Express",
    region: "England",
    country: "GB",
    uuid: "704629d2-6fbb-4ffb-a33e-5aec5698878c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5366",
    name: "Bedminster Express",
    region: "England",
    country: "GB",
    uuid: "8f5d6fd0-f6df-4479-9f49-f58c947301e1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5367",
    name: "Kilmarnock Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "fdbede44-8b8e-4f86-a1ba-29963dd9622c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5368",
    name: "Nottingham Hucknall Rd Express",
    region: "England",
    country: "GB",
    uuid: "c3e2d33f-cd9a-409f-b858-4fc6241d0b77",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5370",
    name: "Salvington Rectory Rd Express",
    region: "England",
    country: "GB",
    uuid: "46703e11-edd0-4791-b17f-0e20fc1dd678",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5371",
    name: "Ashtead Craddocks Express",
    region: "England",
    country: "GB",
    uuid: "5ed04485-5018-4eca-8aad-2235a33659c8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5372",
    name: "Waltham Cross Theobalds Park Express",
    region: "England",
    country: "GB",
    uuid: "af7c8793-1af8-4b55-872b-c3ff7cf3efec",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5373",
    name: "Normanby Express",
    region: "England",
    country: "GB",
    uuid: "c4c96017-1982-49ab-b315-2beb4e76fc46",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5374",
    name: "Sutton Brighton Rd Express",
    region: "England",
    country: "GB",
    uuid: "5889da5c-7793-4a56-afe4-0a5881ebe312",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5375",
    name: "Smithies Carlton Rd Express",
    region: "England",
    country: "GB",
    uuid: "00e354d4-ec65-45ee-a21c-630db3ceb012",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5377",
    name: "Benfleet Rd Express",
    region: "England",
    country: "GB",
    uuid: "6335e143-085c-4575-b607-f7a5cc3043f5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5378",
    name: "Nottingham Top Valley Extra",
    region: "England",
    country: "GB",
    uuid: "c0ec6509-543c-4797-8bf8-1a980456cad1",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5379",
    name: "Mansfield Jubilee Extra",
    region: "England",
    country: "GB",
    uuid: "fcd9acf8-12e0-415e-8a0e-f5a534adc4e2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5380",
    name: "Barbican Express",
    region: "England",
    country: "GB",
    uuid: "cfbb585f-2d6d-4d58-9192-0b27d54cee29",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5382",
    name: "Hornsey High St Express",
    region: "England",
    country: "GB",
    uuid: "d126cbb9-2774-4035-bc39-dd6847910a95",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5383",
    name: "Harringay Express",
    region: "England",
    country: "GB",
    uuid: "bd8622bf-c124-43b5-b1cf-1230add21f04",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5384",
    name: "Isleworth Express",
    region: "England",
    country: "GB",
    uuid: "6ad5bdc8-5197-4adf-aeee-2325b1164757",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5386",
    name: "Birmingham Bournville Esso Express",
    region: "England",
    country: "GB",
    uuid: "7176041f-bcfe-44dd-9277-dc25c12dcb8d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5388",
    name: "West Ealing Express",
    region: "England",
    country: "GB",
    uuid: "66985bca-c4c7-4cbb-b1ec-c6f9a885f0a7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5391",
    name: "Hounslow Bath Rd Express",
    region: "England",
    country: "GB",
    uuid: "de99fbb7-8c47-4717-aef4-f05ab761418a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5392",
    name: "Birmingham Jewellery Quarter Express",
    region: "England",
    country: "GB",
    uuid: "d4ae332a-a58c-42b4-886f-508e82791a5c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5393",
    name: "Ashby Express",
    region: "England",
    country: "GB",
    uuid: "3c1c99d6-d23a-4e55-9812-7f9dbcf885ba",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5395",
    name: "Newcastle Upon Tyne Quayside Express",
    region: "England",
    country: "GB",
    uuid: "76fd86a0-bc11-4e75-b4c7-cba37209ef6f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5397",
    name: "Wolverhampton Willenhall Rd Express",
    region: "England",
    country: "GB",
    uuid: "207e625f-0092-42db-a19f-dbf43b4de946",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5398",
    name: "Bletchley Buckingham Rd Express",
    region: "England",
    country: "GB",
    uuid: "210f85e2-bd49-4be3-8dcb-94d36b6b1a7b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5399",
    name: "Heald Green Express",
    region: "England",
    country: "GB",
    uuid: "21ef0686-9896-4c7f-b176-bf9371c3b90c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5400",
    name: "Preston Blackpool Rd Express",
    region: "England",
    country: "GB",
    uuid: "17ab988d-4b02-477f-b64b-aad4745bbdec",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5401",
    name: "Southampton Cobden Ave Express",
    region: "England",
    country: "GB",
    uuid: "42ac97b8-db60-426b-8d86-35d646ae62c6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5402",
    name: "Hull Spring Bank Express",
    region: "England",
    country: "GB",
    uuid: "c57703b0-63f2-4804-87d1-dbc2f94c70b4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5403",
    name: "Penn Rd Express",
    region: "England",
    country: "GB",
    uuid: "4056e432-d05d-4958-a167-cb9f7d110dfb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5404",
    name: "Hackney Express",
    region: "England",
    country: "GB",
    uuid: "16c80102-c3ba-4d26-8d5a-12002804b854",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5408",
    name: "Chelmsford Interchange Express",
    region: "England",
    country: "GB",
    uuid: "a067d2be-7755-434c-99fc-e99f2aecd6bb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5412",
    name: "Billingham Bypass Esso Express",
    region: "England",
    country: "GB",
    uuid: "ccee9f2a-e114-4cc8-bd62-25fe382c1095",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5415",
    name: "Hemel Hempstead Barnacres Express",
    region: "England",
    country: "GB",
    uuid: "b6513861-fb19-4bd7-b53e-f91bb33e2a5d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5416",
    name: "Holderness Rd Express",
    region: "England",
    country: "GB",
    uuid: "8019333b-fcf2-46bd-b8d1-8403c4396bd3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5417",
    name: "Mansfield Rd Express",
    region: "England",
    country: "GB",
    uuid: "e1e6035c-12c4-4067-9f33-10c5bef9c28e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5418",
    name: "Whitechapel Express",
    region: "England",
    country: "GB",
    uuid: "a4d97322-2379-4526-97b6-cdf03ace32e8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5419",
    name: "Prestwick Main St Express",
    region: "Scotland",
    country: "GB",
    uuid: "55ec9ce5-9b14-446e-ad7e-d17a777cc6e8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5420",
    name: "Tooting Upper Tooting Rd Express",
    region: "England",
    country: "GB",
    uuid: "2e2fd418-d532-418b-9746-86f489cd3249",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5423",
    name: "Clarkston Express",
    region: "Scotland",
    country: "GB",
    uuid: "35d09b57-0cb7-4ada-b64b-15f5f7f8a2de",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5425",
    name: "Kirkby In Ashfield Esso Express",
    region: "England",
    country: "GB",
    uuid: "ed52d1f7-096d-4b19-8de7-828b930b5acf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5427",
    name: "Ovenden Esso Express",
    region: "England",
    country: "GB",
    uuid: "b23b8871-79f1-4d16-8f6e-3b7f45693fae",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5428",
    name: "Wexford Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "70424558-b079-4fea-abeb-3f447aeadb82",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "5431",
    name: "Hull Newland Ave Express",
    region: "England",
    country: "GB",
    uuid: "6763a4a4-1cff-4f8c-b3c1-d669a610c052",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5432",
    name: "Greenwich Express",
    region: "England",
    country: "GB",
    uuid: "48d9c5bc-1223-45bb-a4a3-5505fbeeaca4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5433",
    name: "Newport Chepstow Rd Esso Express",
    region: "Wales",
    country: "GB",
    uuid: "7fa11fb7-3c8c-4874-8bc1-428bb7447fd7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5434",
    name: "Lanehouse Rocks Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "b313736a-b9cf-427c-afcc-5c2f045ea299",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5435",
    name: "Ardwick Green Esso Express",
    region: "England",
    country: "GB",
    uuid: "5226f23e-e828-4e49-8aed-2f5663fa55ef",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5436",
    name: "Cardiff Canton Express",
    region: "Wales",
    country: "GB",
    uuid: "b741a8d9-a19a-4b20-8ecb-c6f895fe0d61",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5437",
    name: "Mansfield Chesterfield Extra",
    region: "England",
    country: "GB",
    uuid: "d270c72d-91f6-45b3-b5b9-9f7414029484",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5438",
    name: "Shepton Mallet Superstore",
    region: "England",
    country: "GB",
    uuid: "a8496a09-e9ae-458b-b40d-ecc8d563db63",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5439",
    name: "Ealing Broadway Express",
    region: "England",
    country: "GB",
    uuid: "a39ff9fb-e441-4b8f-bc32-88a796f7180e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5441",
    name: "Port Glasgow Extra",
    region: "Scotland",
    country: "GB",
    uuid: "558ddbcb-a673-4ce2-8edc-1772d669906f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5443",
    name: "Bury Tottington Rd Express",
    region: "England",
    country: "GB",
    uuid: "37026cfd-8649-4ef6-9b91-b0b4a10aa5cd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5444",
    name: "Downham Bromley Rd Express",
    region: "England",
    country: "GB",
    uuid: "1957e28d-aa84-462b-a074-ebca7f639233",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5445",
    name: "Allestree Express",
    region: "England",
    country: "GB",
    uuid: "ea81531f-09d8-49a1-a8a3-3dbf76625be0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5447",
    name: "Failsworth Extra",
    region: "England",
    country: "GB",
    uuid: "41e6e625-d2d5-40ea-8da1-907cf44dade2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5448",
    name: "Liverpool Crosby Rd Express",
    region: "England",
    country: "GB",
    uuid: "b428113b-1fb8-4ee8-83d8-3c33afdbcbf8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5450",
    name: "Hull Bricknell Ave Express",
    region: "England",
    country: "GB",
    uuid: "75dd41e4-200c-465f-bc48-3c442b293bdd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5453",
    name: "Highbury Express",
    region: "England",
    country: "GB",
    uuid: "2641f797-6d73-43ef-ab12-db8f6b9b136e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5455",
    name: "Codnor Express",
    region: "England",
    country: "GB",
    uuid: "e004d597-c3f2-4f9a-8ebc-a3348a0ea5f7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5456",
    name: "Hull St Stephens Extra",
    region: "England",
    country: "GB",
    uuid: "ee78d8ae-f8b5-4810-9ca0-0fdce7979b9e",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5458",
    name: "Stretford Extra",
    region: "England",
    country: "GB",
    uuid: "1c5378e8-5c1a-4c3e-807b-ab3dd8ede285",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5460",
    name: "Clifton Lee Esso Express",
    region: "England",
    country: "GB",
    uuid: "00e1746e-8572-4b28-9690-4e8d79632af0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5461",
    name: "Farnham Common Express",
    region: "England",
    country: "GB",
    uuid: "005e672d-8150-468b-a633-e4d67dbb23cd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5464",
    name: "Stonycroft Queens Dr Esso Express",
    region: "England",
    country: "GB",
    uuid: "a0a68e0b-7800-4b76-bc7f-ed53c3f8e87b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5468",
    name: "Olympia Express",
    region: "England",
    country: "GB",
    uuid: "153fe456-21b2-43a6-a072-a6a4df6d544d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5469",
    name: "Stoke Newington High St Express",
    region: "England",
    country: "GB",
    uuid: "0b7ae57d-902b-41ac-b0d7-3f0aa0e4bfaa",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5470",
    name: "West Norwood Express",
    region: "England",
    country: "GB",
    uuid: "64098b45-0403-4e67-9e88-8ad82fede5c9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5472",
    name: "Plomer Green Ave Express",
    region: "England",
    country: "GB",
    uuid: "9184c245-8f69-4843-8505-2b3995f1d59a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5473",
    name: "Ellon Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "9172153a-e942-4f50-94a3-a79495b6a4d3",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5476",
    name: "Scarborough Castle Express",
    region: "England",
    country: "GB",
    uuid: "ebe43bfe-f54f-40b9-a63f-098b496d8675",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5477",
    name: "Enfield Windmill Hill Express",
    region: "England",
    country: "GB",
    uuid: "ae685abb-3c0a-4d61-bae2-9ad94e435589",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5478",
    name: "Ashford Express",
    region: "England",
    country: "GB",
    uuid: "4275255a-3738-4168-aa8c-1397a61b364c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5479",
    name: "Hale Express",
    region: "England",
    country: "GB",
    uuid: "58abcaad-e1d8-4fae-a839-d555a93908b9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5480",
    name: "Sauchiehall St Express",
    region: "Scotland",
    country: "GB",
    uuid: "369bd5e8-6dcc-4cbc-8ce2-d93fd33392fe",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5481",
    name: "Walthamstow Tower Mews Express",
    region: "England",
    country: "GB",
    uuid: "3e0dafab-fea0-4ba0-bba4-2f9ce4e0a561",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5482",
    name: "Swansea De La Beche St Express",
    region: "Wales",
    country: "GB",
    uuid: "e03f93fe-16b8-4f61-9bf3-ee46e73416f8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5484",
    name: "Craiglockhart Express",
    region: "Scotland",
    country: "GB",
    uuid: "7d7d3237-5dc4-44ce-a0b3-8a429e79e22a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5486",
    name: "Stoke Newington Green Lanes Express",
    region: "England",
    country: "GB",
    uuid: "d4ce0c02-740e-4b21-bd7b-bf0e57b86855",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5487",
    name: "Seven Sisters Rd Express",
    region: "England",
    country: "GB",
    uuid: "edd1f8b5-cc50-4b0e-9ad5-8712b6326dc4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5488",
    name: "Cardiff City Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "68eff55f-2781-4349-83d2-64779eabb75d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5489",
    name: "Hills Rd Cambridge Express",
    region: "England",
    country: "GB",
    uuid: "f5b68ceb-1c0d-4bc9-9d20-87114482804e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5494",
    name: "Streatham High St Express",
    region: "England",
    country: "GB",
    uuid: "7bf13ad0-6fa0-4aef-8112-ba6087c10dd9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5495",
    name: "Hinckley Express",
    region: "England",
    country: "GB",
    uuid: "f733abdb-d551-4ba5-88e3-47f3a8d559ae",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5496",
    name: "Middlesbrough Marton Rd Express",
    region: "England",
    country: "GB",
    uuid: "ab376d3d-de0e-49dd-b569-31692cf2a69e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5498",
    name: "Kings Heath Express",
    region: "England",
    country: "GB",
    uuid: "bdeab28d-ce1a-4241-abb8-6f1e44907d08",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5500",
    name: "Kelham Island Express",
    region: "England",
    country: "GB",
    uuid: "89a3a2cd-0f50-4875-a387-13504ab770bf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5501",
    name: "Southgate Rd Express",
    region: "England",
    country: "GB",
    uuid: "34f8751b-2ab1-4e5a-8975-73f2071f1cbd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5502",
    name: "Cardiff Maes Y Coed Express",
    region: "Wales",
    country: "GB",
    uuid: "bb30549d-9867-4558-b0ec-f712dfef9af6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5506",
    name: "Edgbaston Hagley Rd Express",
    region: "England",
    country: "GB",
    uuid: "f21ca48f-336a-462c-b045-f359f586bc58",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5507",
    name: "Sheffield Barnsley Rd Express",
    region: "England",
    country: "GB",
    uuid: "c7aed671-8709-425f-8619-8063a5482c8b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5508",
    name: "Shoreditch Express",
    region: "England",
    country: "GB",
    uuid: "ba2fbb31-250f-408a-9a34-32449d46540a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5509",
    name: "Hither Green Express",
    region: "England",
    country: "GB",
    uuid: "7746081c-dcbd-4a08-8b16-4d9464fc1e9a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5510",
    name: "South Norwood Express",
    region: "England",
    country: "GB",
    uuid: "8c5b0c08-6576-4dbc-8bde-a210684554a7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5511",
    name: "Wallington Woodcote Rd Express",
    region: "England",
    country: "GB",
    uuid: "57df3de3-f16f-40a7-8899-eb0ceb800a87",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5512",
    name: "Dyce Express",
    region: "Scotland",
    country: "GB",
    uuid: "78deaf2e-c836-43fc-90d9-ecd3fb0e076e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5513",
    name: "Lewisham Way Express",
    region: "England",
    country: "GB",
    uuid: "f7482495-26cb-4737-8c10-b308e1afa376",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5514",
    name: "Croydon Leon House Express",
    region: "England",
    country: "GB",
    uuid: "7c45ee5e-612c-421c-a6a2-c6f219b502cb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5518",
    name: "Borough Long Ln Express",
    region: "England",
    country: "GB",
    uuid: "334eb534-0731-4d1a-80f3-0fd7c5aee9cb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5519",
    name: "Southampton Shirley Rd Express",
    region: "England",
    country: "GB",
    uuid: "801a1444-aa45-4b45-b489-593eb34c7680",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5520",
    name: "Chester Sealand Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "a836cf29-a887-47a1-b288-b6729f3e835c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5524",
    name: "Taunton E Reach Esso Express",
    region: "England",
    country: "GB",
    uuid: "0e33a96b-4326-405e-9f88-80feeec73888",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5526",
    name: "Bath Englishcombe Ln Express",
    region: "England",
    country: "GB",
    uuid: "2c67cb9d-87b6-4a61-aed3-ddc5fa3218f7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5528",
    name: "Reading W Extra",
    region: "England",
    country: "GB",
    uuid: "6eaa913c-ca23-4de0-916a-3c42d137b368",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5529",
    name: "Chorlton Esso Express",
    region: "England",
    country: "GB",
    uuid: "940e9934-4ef1-417f-ad9c-00c5028c5908",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5530",
    name: "Valley Dr Gravesend Express",
    region: "England",
    country: "GB",
    uuid: "30f02b29-1b7f-4e8c-b1c7-8e242207a989",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5531",
    name: "Potters Bar Express",
    region: "England",
    country: "GB",
    uuid: "efd5c172-592a-4c48-9594-6f4ebac663d1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5532",
    name: "Hampstead Belsize Rd Express",
    region: "England",
    country: "GB",
    uuid: "a765afab-e46b-404e-a31f-a1892358c380",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5533",
    name: "Bitterne Spring Rd Express",
    region: "England",
    country: "GB",
    uuid: "b82cfaf3-c9c8-4d2f-a1dd-64e22a4b04e9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5536",
    name: "Ayr Express",
    region: "Scotland",
    country: "GB",
    uuid: "8382c97f-0ca7-46a0-b6cc-ec008082cda7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5537",
    name: "Maidstone Hermitage Ln Express",
    region: "England",
    country: "GB",
    uuid: "c171a5e2-dd1a-418c-ac10-474ac53f2e94",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5538",
    name: "Mansfield Dukeries Esso Express",
    region: "England",
    country: "GB",
    uuid: "ec1ccda2-91c7-4fc2-a157-6752ef0ce308",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5539",
    name: "ESSEX ROAD EXPRESS",
    region: "England",
    country: "GB",
    uuid: "a3f36e63-f8f2-4d01-a966-f197540dba97",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5541",
    name: "Grappenhall Express",
    region: "England",
    country: "GB",
    uuid: "749f2f98-8fb5-4468-8e81-dd62eb8655c5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5542",
    name: "Bathwick Hill Express",
    region: "England",
    country: "GB",
    uuid: "83968bf2-8766-47f3-b122-37e7bdd93d6e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5545",
    name: "Manninghm Ln Bradford Express",
    region: "England",
    country: "GB",
    uuid: "9302fe74-f87e-49a6-9130-db112ecbd32d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5546",
    name: "Windsor Bridge Express",
    region: "England",
    country: "GB",
    uuid: "a99618c8-ee26-4bb3-ae1f-337ba2247c8c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5548",
    name: "Coonagh Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "c2a4a7fd-7318-4cc8-adc6-a2e1e526892d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "5549",
    name: "Gornal Dudley Express",
    region: "England",
    country: "GB",
    uuid: "c281fb50-7f13-4853-8e52-0d9ef0458230",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5551",
    name: "Huddersfield Halifax Express",
    region: "England",
    country: "GB",
    uuid: "166c0c1f-e935-4518-acb1-d22a15159f06",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5553",
    name: "Ball Hill Walsgrave Rd Express",
    region: "England",
    country: "GB",
    uuid: "c52260c9-4e34-4f0b-9d48-e1323741e05d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5554",
    name: "Bradford Bolton Express",
    region: "England",
    country: "GB",
    uuid: "c01f2571-751b-4472-8136-bd79404f46c6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5557",
    name: "Sketty Gower Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "c33c003f-a935-46d2-9685-e3f630a43fd5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5560",
    name: "Tooting Broadway Express",
    region: "England",
    country: "GB",
    uuid: "ec996c7a-794e-4df6-92e5-25e180d398be",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5561",
    name: "Ruislip Park Way Express",
    region: "England",
    country: "GB",
    uuid: "84736752-4558-4505-8012-db53a350f677",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5562",
    name: "Goring Way Express",
    region: "England",
    country: "GB",
    uuid: "d33ccc30-fedd-4cd1-94fb-68c88a0b5edd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5565",
    name: "Lisson Grove Express",
    region: "England",
    country: "GB",
    uuid: "bf0fd18b-6d63-4e46-a02d-686c8a0a249a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5566",
    name: "Manchester Gorton Extra",
    region: "England",
    country: "GB",
    uuid: "304ca0b5-5a65-44f7-929e-4cc42af75978",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5567",
    name: "Ryde Extra",
    region: "England",
    country: "GB",
    uuid: "c5a24fba-8b3c-479a-b2c5-3e871ef1c6f2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5569",
    name: "Rotherham Wortley Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "1895efab-74f3-4f27-830f-47e8eb566da2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5575",
    name: "St Neots Loves Farm Express",
    region: "England",
    country: "GB",
    uuid: "8dbbd1f3-3605-44ca-9d84-13b1bdb7f45c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5579",
    name: "Cardonald Esso Express",
    region: "Scotland",
    country: "GB",
    uuid: "b7f192bb-16f4-4e5c-bab0-29ee90e64592",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5581",
    name: "LOWER HOLLOWAY EXPRESS",
    region: "England",
    country: "GB",
    uuid: "0ba0b4ce-de80-4d95-87ec-366353fa13b5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5582",
    name: "Bristol Soundwell Esso Express",
    region: "England",
    country: "GB",
    uuid: "af1eded3-a55b-43aa-81a8-78ab1c7bdde9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5583",
    name: "Priory Vale Express",
    region: "England",
    country: "GB",
    uuid: "f93d3e8a-3fe4-46b4-b2e2-d58df61ac580",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5584",
    name: "Acton Express",
    region: "England",
    country: "GB",
    uuid: "500b2fad-6115-41ea-b243-c5a40adff370",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5591",
    name: "North Hykeham Express",
    region: "England",
    country: "GB",
    uuid: "b12489c2-bf90-4b60-a3a0-e8a219fd8113",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5593",
    name: "Birstall Leicester Express",
    region: "England",
    country: "GB",
    uuid: "6c556ae0-aeb0-4fff-8d3b-2688bef3cc4d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5594",
    name: "Milton Keynes Oxley Park Express",
    region: "England",
    country: "GB",
    uuid: "79a78a3b-c45a-4bbc-882f-08e237662ff3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5595",
    name: "Wallasey Poulton Rd Express",
    region: "England",
    country: "GB",
    uuid: "f6891e52-3ced-4ddf-a5f9-7acc6705581e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5601",
    name: "Hastings Extra",
    region: "England",
    country: "GB",
    uuid: "d521900a-06ff-4dff-aba4-6e8399922272",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5602",
    name: "Westhoughton Express",
    region: "England",
    country: "GB",
    uuid: "7446c99b-2cc6-4cae-b490-0a7002b0665f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5603",
    name: "Duke St Express",
    region: "England",
    country: "GB",
    uuid: "955fdca9-c9b8-423b-9134-f23f7bfef2b8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5604",
    name: "Bradford St Esso Express",
    region: "England",
    country: "GB",
    uuid: "ae050677-f885-4179-93db-2de242f1c630",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5605",
    name: "Kettering Windmill Ave Esso Express",
    region: "England",
    country: "GB",
    uuid: "f45a27c5-b6e3-4446-9ae7-afc4303c1a06",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5607",
    name: "Evesham Esso Express",
    region: "England",
    country: "GB",
    uuid: "d694b476-34f7-49c5-9a2a-49915a7ef5d3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5608",
    name: "Eltham High St Esso Express",
    region: "England",
    country: "GB",
    uuid: "14b21d5a-e103-4ad7-ad2f-2c20165ad73b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5611",
    name: "Dagenham Heathway Express",
    region: "England",
    country: "GB",
    uuid: "f31611b6-ad59-4498-b456-b60c84eb6fc9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5618",
    name: "Hedge End Express",
    region: "England",
    country: "GB",
    uuid: "bc8932c8-2e76-4d85-8b44-caceb7fdb840",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5619",
    name: "Eastham Rake Express",
    region: "England",
    country: "GB",
    uuid: "3879bb4f-612a-4eab-8a79-249980a7f734",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5620",
    name: "Kingsbury Circle Express",
    region: "England",
    country: "GB",
    uuid: "70e5a399-2077-4d57-a4a5-5688cc0f7324",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5621",
    name: "Brayton Express",
    region: "England",
    country: "GB",
    uuid: "098a2dfd-51f3-422a-ae51-cd75b6ed1476",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5622",
    name: "Clocktower Liverpool Express",
    region: "England",
    country: "GB",
    uuid: "7287c977-d0da-4425-a98a-acbdc0f081df",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5628",
    name: "Nottingham Castle Boulevard Express",
    region: "England",
    country: "GB",
    uuid: "1b977825-6374-41b7-96fb-61c7dcb6c54b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5630",
    name: "Dumbarton Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "a3743861-3524-4e9e-a32b-1e76fc68f2fb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5631",
    name: "Southbourne Grove Express",
    region: "England",
    country: "GB",
    uuid: "2ce682dd-0e07-4c71-918f-4df5c99b0bb2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5632",
    name: "Fleetwood Express",
    region: "England",
    country: "GB",
    uuid: "50f55c7d-7f36-4f99-bd06-3f9d1f12c945",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5635",
    name: "Bradford Sunbridge Rd Express",
    region: "England",
    country: "GB",
    uuid: "8bd5b3ca-d7eb-40b9-97ac-8838647fa544",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5636",
    name: "Camelon Esso Express",
    region: "Scotland",
    country: "GB",
    uuid: "bfdd2257-ac65-47d3-871c-9f135a2dabe9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5637",
    name: "Bishopbriggs Express",
    region: "Scotland",
    country: "GB",
    uuid: "61f752e2-26dc-496a-bee4-dc643e59e8dc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5639",
    name: "ABERDEEN GRT WST EXPRESS",
    region: "Scotland",
    country: "GB",
    uuid: "76704ea5-bba6-4088-9a68-f5e9088cd058",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5644",
    name: "Romford Manor Park Express",
    region: "England",
    country: "GB",
    uuid: "43a7e54e-b102-4f1a-a2c2-f3ffb512edbc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5645",
    name: "New Malden Express",
    region: "England",
    country: "GB",
    uuid: "c97d1345-97bc-4b39-9876-f516e86023aa",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5648",
    name: "Drayton Park Express",
    region: "England",
    country: "GB",
    uuid: "8a693468-e9b4-483f-8dca-029b1d782240",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5649",
    name: "Norbiton Express",
    region: "England",
    country: "GB",
    uuid: "d8022c58-bc7f-454e-a2d3-354f8163f67d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5652",
    name: "Bradley Stoke Extra",
    region: "England",
    country: "GB",
    uuid: "fa1bcdf3-2065-4a1e-8d33-15f19314b6d5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5654",
    name: "Huddersfld Wakefield Express",
    region: "England",
    country: "GB",
    uuid: "a0b3c49d-5b0a-4cc3-90ce-6616489d130a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5655",
    name: "Edgware Hale Ln Express",
    region: "England",
    country: "GB",
    uuid: "f45b778b-9d38-4b05-879d-93944da0ed14",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5656",
    name: "Robin Hood Express",
    region: "England",
    country: "GB",
    uuid: "2ab133f1-6dbc-4b08-b147-88231dd7a276",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5657",
    name: " March Hostmoor Superstore",
    region: "England",
    country: "GB",
    uuid: "15f8e189-611f-4e07-959c-36f6071f2a2c",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5660",
    name: "Fletcher Gate The Pod Express",
    region: "England",
    country: "GB",
    uuid: "edd2a816-e4b3-4a6f-a8b4-d5324c58362c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5662",
    name: "Leicester Granby St Express",
    region: "England",
    country: "GB",
    uuid: "c50cd61b-102a-4896-b4f0-8f1f6e151159",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5664",
    name: "Durrington Express",
    region: "England",
    country: "GB",
    uuid: "438df9d9-8156-4b0a-83e6-b2954a358ede",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5667",
    name: "Clifton Ln Esso Express",
    region: "England",
    country: "GB",
    uuid: "279a49a5-5607-41e3-8e0a-5f1cab9728ed",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5668",
    name: "Trongate Express",
    region: "Scotland",
    country: "GB",
    uuid: "5e4f2507-c084-4f8a-9cc0-297ee4dca0bf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5669",
    name: "Auld Cross Esso Express",
    region: "Scotland",
    country: "GB",
    uuid: "ed9f7dda-6afe-46ab-9b50-539a210ee969",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5670",
    name: "Picardy Place Express",
    region: "Scotland",
    country: "GB",
    uuid: "c2a3bf05-d434-4c79-a642-6019ebb67be0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5671",
    name: "Leaventhorpe Esso Express",
    region: "England",
    country: "GB",
    uuid: "31c1d7d8-59c6-4ac7-8269-a385f7ac5db1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5674",
    name: "Whippendell Rd Express",
    region: "England",
    country: "GB",
    uuid: "5d69e815-c3f2-4577-8031-5f70ea999596",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5675",
    name: "Bedford Ford End Express",
    region: "England",
    country: "GB",
    uuid: "b1aa9e65-3832-4d2f-9089-aa6a64fcd8dc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5676",
    name: "Newquay Narrowcliff Express",
    region: "England",
    country: "GB",
    uuid: "d7b1b2bb-76a2-452e-bc23-e576b2cd8829",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5678",
    name: "Clapham Wandsworth Express",
    region: "England",
    country: "GB",
    uuid: "cd6257a0-f90f-412b-9944-e3a22f4a2cb0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5679",
    name: "Warmley Deanery Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "a748c597-fb42-4bd7-ae8e-40feb59826d8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5680",
    name: "Claughton Express",
    region: "England",
    country: "GB",
    uuid: "06a1d96e-44a3-44db-a1ad-0ac94eb67e66",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5681",
    name: "Wellingborough Queensway Express",
    region: "England",
    country: "GB",
    uuid: "ce1a8d01-9541-4f6a-88b8-67d99a66405c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5684",
    name: "Dunfermline Express",
    region: "Scotland",
    country: "GB",
    uuid: "e06d9161-1935-4f62-a2fa-4f11eee39c22",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5685",
    name: "Bradwell Express",
    region: "England",
    country: "GB",
    uuid: "7763b69f-eace-4381-afc9-f484d382d3a8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5686",
    name: "Croydon Rd Express",
    region: "England",
    country: "GB",
    uuid: "d0c9360a-1c4e-4f6e-99f2-00b02210365c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5687",
    name: "Redhill Surrey Express",
    region: "England",
    country: "GB",
    uuid: "6df17891-e79d-41b7-8e33-e5db78fcf0dd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5688",
    name: "Southampton Way Express",
    region: "England",
    country: "GB",
    uuid: "a86d8f2e-f71b-40b9-bbd0-cc23e3b51604",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5692",
    name: "Stansted Express",
    region: "England",
    country: "GB",
    uuid: "5d310911-4b4c-46fe-9a27-8469b3175f73",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5698",
    name: "Rockfield Esso Express",
    region: "Scotland",
    country: "GB",
    uuid: "c534b0e3-f092-409e-9377-35435bd6aeca",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5700",
    name: "Aintree Molyneux Way Express",
    region: "England",
    country: "GB",
    uuid: "db18eeaf-477f-4da8-84f7-905aceb4a5e9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5703",
    name: "Cathays Terrace Express",
    region: "Wales",
    country: "GB",
    uuid: "bb3480ba-f535-41b4-b190-40580459bae0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5706",
    name: "Knaphill High St Express",
    region: "England",
    country: "GB",
    uuid: "aabe8fc9-5770-41e8-b13a-62a38e85f2f6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5711",
    name: "West Hampstead Express",
    region: "England",
    country: "GB",
    uuid: "d61a8318-8031-4548-91b2-51ae6f87a98d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5713",
    name: "Baillieston Express",
    region: "Scotland",
    country: "GB",
    uuid: "e5c3482c-06b1-4b3c-bd04-6357f54d68b6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5715",
    name: "Ely Cardiff Express",
    region: "Wales",
    country: "GB",
    uuid: "0c126b09-e51b-40a7-a1fe-82bab09a6ee3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5724",
    name: "Northampton Link Rd Express",
    region: "England",
    country: "GB",
    uuid: "50919855-06b6-42f8-aca8-863bf6d681f4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5725",
    name: "Rustington Sterling Parade Express",
    region: "England",
    country: "GB",
    uuid: "62219c05-b3dc-4b8f-a3c9-ded4e5ccfbbf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5727",
    name: "Woodford Green Express",
    region: "England",
    country: "GB",
    uuid: "9a8a8f32-d7a9-4fed-96cf-abbceee32442",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5729",
    name: "Sydenham Express",
    region: "England",
    country: "GB",
    uuid: "03bd5524-4220-4cbb-9098-ddaa421cb6a2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5731",
    name: "Oldham Huddersfield Rd Extra",
    region: "England",
    country: "GB",
    uuid: "fb45749c-a549-4fd6-999a-3354141115f0",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5732",
    name: "Swansea Uplands Crescent Express",
    region: "Wales",
    country: "GB",
    uuid: "8be05358-3c41-4480-9f24-03cad1b6220f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5735",
    name: "Herne Bay Express",
    region: "England",
    country: "GB",
    uuid: "0e86b1fd-1ff2-4d3c-848a-abeb17aa640a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5736",
    name: "Limehouse Express",
    region: "England",
    country: "GB",
    uuid: "29c09952-4af1-4452-a534-df80ddfc207b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5737",
    name: "Sheffield Broadfield Rd Express",
    region: "England",
    country: "GB",
    uuid: "45357662-afc0-45f2-9777-4978fe8e344f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5740",
    name: "Hemsworth Superstore",
    region: "England",
    country: "GB",
    uuid: "df504503-e0e8-46b0-86f7-999884544162",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5745",
    name: "Dundee South Rd Extra",
    region: "Scotland",
    country: "GB",
    uuid: "c874bb55-e65e-472f-8d95-c24bc648517c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5746",
    name: "Luton Dunstable Rd Express",
    region: "England",
    country: "GB",
    uuid: "d15b30a7-c41e-4ac7-98e4-cd09228601f5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5751",
    name: "Erdington Six Ways Express",
    region: "England",
    country: "GB",
    uuid: "47f3f9ba-63b5-485d-a8dc-21d2e6b32686",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5753",
    name: "Prestwich Bury Express",
    region: "England",
    country: "GB",
    uuid: "8b018af9-317c-4333-ae74-6d45d66e165c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5760",
    name: "Lerwick Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "a68adaa3-dc21-40fd-b82c-032200ac51fc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5762",
    name: "Stornoway Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "1863bedb-7392-4ddd-96de-4b795e7a02e6",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5768",
    name: "Barton Upon Humber Superstore",
    region: "England",
    country: "GB",
    uuid: "14d1a200-727b-4be3-97bc-6efb15cc69c8",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5769",
    name: "Hermiston Gait Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "81f0f336-e480-4727-aa63-cefbecbca9df",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5775",
    name: "Kensal Rise Express",
    region: "England",
    country: "GB",
    uuid: "0c06fe4e-f641-4d2a-9407-e841b058259e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5779",
    name: "Coventry Shelton Square Express",
    region: "England",
    country: "GB",
    uuid: "d4be4181-5b95-401a-9283-9da20433191b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5782",
    name: "Fegg Hayes Express",
    region: "England",
    country: "GB",
    uuid: "28f5f8a5-5ec4-4bda-ac4b-ff126b77ce4a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5783",
    name: "Aldridge Paddock Ln Express",
    region: "England",
    country: "GB",
    uuid: "4bc028f5-31b2-47ff-96fc-7878b7e24383",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5786",
    name: "Arbroath Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "0e8eb779-0056-4586-b3ea-fa44c4d4494c",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5787",
    name: "Ickenham High Rd Express",
    region: "England",
    country: "GB",
    uuid: "ee4deee7-0810-478e-99de-95ac5f6bb3cc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5789",
    name: "Crown St Express",
    region: "England",
    country: "GB",
    uuid: "f7010627-adb9-4c20-bf8e-c8345d214195",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5790",
    name: "Maynooth Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "8c74188b-1a3d-4737-9da6-5152cdedd7a2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "5791",
    name: "Tarbock Woodlands Esso Express",
    region: "England",
    country: "GB",
    uuid: "ed82926e-d075-407a-84fc-c514260368bf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5794",
    name: "Drogheda Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "316c8879-90d4-42ab-a3cf-472e78feb565",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "5795",
    name: "Leeds Beeston Express",
    region: "England",
    country: "GB",
    uuid: "57be0034-1720-4275-8223-2b8fd56e29b4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5798",
    name: "Crewe Arms Esso Express",
    region: "England",
    country: "GB",
    uuid: "e447be3c-6698-4ffa-9a03-b24230713a97",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5800",
    name: "Bristol St North Express",
    region: "England",
    country: "GB",
    uuid: "78056e67-5877-431d-babe-e72ce3e79168",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5801",
    name: "Broken Cross Macclesfield Express",
    region: "England",
    country: "GB",
    uuid: "5149f503-05fe-479c-93a4-9bb09bc76942",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5802",
    name: "Fairfield Express",
    region: "England",
    country: "GB",
    uuid: "7030df8c-5845-4dd8-8466-3903107caf2c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5805",
    name: "Cornmill Shopping Centre Express",
    region: "England",
    country: "GB",
    uuid: "fa2aebe8-3d79-4906-93b5-aca357c7f908",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5806",
    name: "Wakefield Express",
    region: "England",
    country: "GB",
    uuid: "41ea2d02-f1ad-4dbf-9a42-392e12d7a9fd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5807",
    name: "Southampton Burgess Rd Express",
    region: "England",
    country: "GB",
    uuid: "13fb5468-2d32-4141-9510-b22efabe33f4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5808",
    name: "Ossett Express",
    region: "England",
    country: "GB",
    uuid: "0e4d3d37-5489-4a97-b027-4cc8ea2207d4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5810",
    name: "Slough Burnham Ln Express",
    region: "England",
    country: "GB",
    uuid: "570f5d48-5d74-4294-b3b1-493e9e5979a4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5814",
    name: "Riverbank Court Express",
    region: "Wales",
    country: "GB",
    uuid: "3490d87a-cea4-41ef-ace5-a1a8822120ab",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5818",
    name: "Cardiff Wellfield Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "ad31c891-2fb4-4b80-8e1b-c0036c210500",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5819",
    name: "Claremont Crescent Express",
    region: "England",
    country: "GB",
    uuid: "2daa6038-9bd5-4ac3-a124-8a835a38bb3e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5820",
    name: "Waunceirch Express",
    region: "Wales",
    country: "GB",
    uuid: "ddba7237-bce4-4c34-b180-2b901bbb65b6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5822",
    name: "Earlsfield Garratt Ln Express",
    region: "England",
    country: "GB",
    uuid: "6ca8cab3-6cd8-488a-98e2-f1e08171cef7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5828",
    name: "Coventry Holyhead Express",
    region: "England",
    country: "GB",
    uuid: "1d54a931-b87a-4925-9508-7b380045c2ff",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5831",
    name: "Leicester Saffron Express",
    region: "England",
    country: "GB",
    uuid: "34fbe193-e178-48ed-ae80-baff443a051d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5839",
    name: "Leicester Humberstone Express",
    region: "England",
    country: "GB",
    uuid: "b37a0901-4c28-4e7d-8484-261fec84ee73",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5841",
    name: "Poplar High St Express",
    region: "England",
    country: "GB",
    uuid: "37bcb822-2a56-4579-8ae7-bc4c0a2aa760",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5842",
    name: "South Ockendon Derry Court Express",
    region: "England",
    country: "GB",
    uuid: "9038cdfb-de81-4e45-b666-77ffe9f01864",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5850",
    name: "Braunton Superstore",
    region: "England",
    country: "GB",
    uuid: "96229216-c340-4372-a118-1aedbb4b3738",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5851",
    name: "Hanley Extra",
    region: "England",
    country: "GB",
    uuid: "b981067e-0283-4b37-a061-7593c519147b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5852",
    name: "Lichfield Extra",
    region: "England",
    country: "GB",
    uuid: "bbbd8c01-856f-4a75-a624-d86b9e54ef78",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5856",
    name: "Chesterfield Pavements Express",
    region: "England",
    country: "GB",
    uuid: "097ee45a-ccd2-4281-8beb-1045bb2cf422",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5858",
    name: "Penarth Express",
    region: "Wales",
    country: "GB",
    uuid: "f595531e-23bd-4b69-be7b-507a592c4bfc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5861",
    name: "Fortune Green Rd Express",
    region: "England",
    country: "GB",
    uuid: "62d10357-7410-4c26-a29c-d1215b5e247a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5862",
    name: "Winchester Andover Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "03e51923-573e-48f1-bc50-86dba9ac7eb6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5864",
    name: "Paisley Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "180f23c5-3e6c-4385-97bf-ac977d7c5ec4",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5865",
    name: "Exeter Cowick St Express",
    region: "England",
    country: "GB",
    uuid: "f83e06b3-fece-4f36-9b91-830aca36d958",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5869",
    name: "Cardiff North Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "82f3d988-aa1b-4885-a8d1-0910f5e74eca",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5872",
    name: "Cheltenham Hewlett Rd Express",
    region: "England",
    country: "GB",
    uuid: "f44862eb-d904-43b2-83cd-e7c663b9d636",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5873",
    name: "Letchworth Express",
    region: "England",
    country: "GB",
    uuid: "20ba912d-a9b7-444d-a05d-64195b38fb49",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5875",
    name: "Cambridge Clifton Rd Express",
    region: "England",
    country: "GB",
    uuid: "e85d75c4-0712-461d-9924-8c2bc1a13640",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5877",
    name: "Hucknall Annesley Rd Express",
    region: "England",
    country: "GB",
    uuid: "f88719b8-9139-4988-a088-d9a7e8e30acc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5880",
    name: "Bournemouth Triangle Express",
    region: "England",
    country: "GB",
    uuid: "d0e7a1e7-7944-48c8-9260-fa94688322e9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5882",
    name: "Willingdon Freshwater Square Express",
    region: "England",
    country: "GB",
    uuid: "f522a964-97d7-4f1d-b28b-cc830f78c8ea",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5884",
    name: "Beaumont Rd Express",
    region: "England",
    country: "GB",
    uuid: "6622ca9d-154a-495c-ada8-767b08f2c569",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5886",
    name: "Derby St Peters Street Express",
    region: "England",
    country: "GB",
    uuid: "c0a9574d-72ac-47a6-b344-2a399712fbfa",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5887",
    name: "Cambridge Rd Harrogate Express",
    region: "England",
    country: "GB",
    uuid: "90321af1-6020-4877-8f59-de88763f83e6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5890",
    name: "Harlesden Stonebridge Express",
    region: "England",
    country: "GB",
    uuid: "d650e594-0015-42d8-b944-07997a5b4ea9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5893",
    name: "Worcester Foregate St Express",
    region: "England",
    country: "GB",
    uuid: "5926fc72-a76c-4119-bd8d-d1955fa063b3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5899",
    name: "Dewsbury Esso Express",
    region: "England",
    country: "GB",
    uuid: "5714b7e0-c918-4073-9d36-2b9e0d575eb6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5900",
    name: "Broughty Ferry Express",
    region: "Scotland",
    country: "GB",
    uuid: "83e8a76c-0c5f-41e5-a15d-b388752b824f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5902",
    name: "Hinckley Superstore",
    region: "England",
    country: "GB",
    uuid: "4fca1c45-16d2-4e82-a8bd-c23fdbc990f5",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5904",
    name: "Orpington Extra",
    region: "England",
    country: "GB",
    uuid: "cfac614b-292b-4043-9cef-4cd5593d0b6f",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5907",
    name: "East Ham High St Express",
    region: "England",
    country: "GB",
    uuid: "018af9a8-cad2-4948-a06f-9eebed454eeb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5908",
    name: "Whalley Range Express",
    region: "England",
    country: "GB",
    uuid: "6c8c2b92-1ec0-4cc2-b6aa-1367ba2a80e6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5909",
    name: "St. Matthews St Express",
    region: "England",
    country: "GB",
    uuid: "6a0460be-89d9-4af3-be28-fa5216409199",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5911",
    name: "East Ham Pilgrims Way Express",
    region: "England",
    country: "GB",
    uuid: "53431aae-9ac5-45b3-98e5-0aed66e77565",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5912",
    name: "City Rd Express",
    region: "England",
    country: "GB",
    uuid: "52a67251-acea-4ca9-8983-05f8ff1573a7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5913",
    name: "Bath Row Birmingham Express",
    region: "England",
    country: "GB",
    uuid: "d98d1ded-7ba5-41b5-9a70-68249b3a0ce4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5916",
    name: "Princess St Manch Express",
    region: "England",
    country: "GB",
    uuid: "20609d99-19a8-4f2d-a4ae-f11df79fe7c9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5917",
    name: "Penketh Express",
    region: "England",
    country: "GB",
    uuid: "f6b2505c-650a-40c4-acdf-873ba4712bc6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5921",
    name: "Leicester Hinckley Rd Express",
    region: "England",
    country: "GB",
    uuid: "5024a9a1-203a-4584-9a07-9d3783cee97b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5922",
    name: "Harrow Pinner Rd Express",
    region: "England",
    country: "GB",
    uuid: "2f07754a-fee8-4e47-b258-f8d07926cd8b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5923",
    name: "Wanstead Express",
    region: "England",
    country: "GB",
    uuid: "c3edcc98-f46e-4f94-bae7-df2a23d02154",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5926",
    name: "Farringdon Rd Express",
    region: "England",
    country: "GB",
    uuid: "7dd1e4bc-3079-410e-9dd2-7c06ff841406",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5929",
    name: "Turnpike Lane Express",
    region: "England",
    country: "GB",
    uuid: "fd9eff05-e730-4760-8256-b713d6e297fd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5930",
    name: "Crediton Superstore",
    region: "England",
    country: "GB",
    uuid: "a9d208bf-08a9-4a91-ba8b-11ffbc5e0366",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5932",
    name: "Barking Ripple Rd Express",
    region: "England",
    country: "GB",
    uuid: "2a4a0203-55ba-4190-bcfa-7c1841f59e86",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5933",
    name: "Forest Gate Woodgrange Rd Express",
    region: "England",
    country: "GB",
    uuid: "14dc62b0-ef44-4518-96e0-09b9784fef5a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5934",
    name: "East Sheen Express",
    region: "England",
    country: "GB",
    uuid: "af5495f8-45e2-4170-bad4-62583000ef11",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5935",
    name: "Eastcote Field End Rd Express",
    region: "England",
    country: "GB",
    uuid: "5dba5696-9fb4-46ab-9925-e662a3d03e32",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5936",
    name: "Consett Durham Rd Express",
    region: "England",
    country: "GB",
    uuid: "f036d890-26e8-4e4c-a1e5-a7899ac49f1b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5937",
    name: "Kingsbridge Superstore",
    region: "England",
    country: "GB",
    uuid: "c9df7a3b-6ee5-4d6b-8ef7-14f139c75332",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5939",
    name: "Haverhill Superstore",
    region: "England",
    country: "GB",
    uuid: "1785e3f7-ff35-4070-be35-ba9ec30c1744",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5944",
    name: "Holland On Sea Express",
    region: "England",
    country: "GB",
    uuid: "2dce29a3-a6af-4ee7-8c5c-b77ef383246d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5945",
    name: "Walthamstow Forest Express",
    region: "England",
    country: "GB",
    uuid: "d647643b-d9f7-427b-9c27-3f7330f6a42a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5946",
    name: "Hackney Rd Express",
    region: "England",
    country: "GB",
    uuid: "f04028f9-c20b-42fe-affc-a4a241d80265",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5947",
    name: "Liverpool Bold St Express",
    region: "England",
    country: "GB",
    uuid: "cbbe233f-3b9a-4e78-91f7-f0ce22937ed4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5949",
    name: "Leytonstone Rd Express",
    region: "England",
    country: "GB",
    uuid: "9c95a821-49fc-4822-95f6-f19e97a2149a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5950",
    name: "Cheadle Wilmslow Express",
    region: "England",
    country: "GB",
    uuid: "dceffd89-71ef-42a4-a1ec-b98e0fbf1e3b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5953",
    name: "Pentonville Rd Express",
    region: "England",
    country: "GB",
    uuid: "31860f33-fd1e-442c-8e2a-b74b97670d51",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5955",
    name: "Lytham St Annes Express",
    region: "England",
    country: "GB",
    uuid: "9ac8ea18-5faf-43b5-ae80-cdcbbaa3b2a2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5956",
    name: "Mansell St Express",
    region: "England",
    country: "GB",
    uuid: "fc6767b2-1b89-49de-8061-d83d95d8afac",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5958",
    name: "Bishop's Stortford South St Express",
    region: "England",
    country: "GB",
    uuid: "082aefb1-975c-4b01-95ca-c69a45f88381",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5959",
    name: "Westburn Esso Express",
    region: "Scotland",
    country: "GB",
    uuid: "a34a6346-6c51-4ea6-b31f-f284f24f83e2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "5966",
    name: "Oxford Banbury Rd Express",
    region: "England",
    country: "GB",
    uuid: "54541ac0-e47a-455d-bde2-502f913d5d18",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5967",
    name: "Newcastle Chillingham Rd Express",
    region: "England",
    country: "GB",
    uuid: "a961946c-4a3a-4d99-9141-973d1bd9c5ab",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5971",
    name: "Hungerford Superstore",
    region: "England",
    country: "GB",
    uuid: "2a226efc-eb39-4a17-a91f-7751c53484d0",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5982",
    name: "Skipton Superstore",
    region: "England",
    country: "GB",
    uuid: "82380da5-650e-4bb9-89cc-770871875090",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5983",
    name: "Ilford Cranbrook Rd Express",
    region: "England",
    country: "GB",
    uuid: "4b872240-1a4c-4dc7-a657-28ded82d4591",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5984",
    name: "Belgrave Gate Leicester Express",
    region: "England",
    country: "GB",
    uuid: "2f377025-38a9-4d5a-b9df-7c0928289d84",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5985",
    name: "Chaseside Southgate Express",
    region: "England",
    country: "GB",
    uuid: "16f0704a-a514-4b92-8e01-b0cc73a29f5e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5986",
    name: "Preston Rd Wembley Express",
    region: "England",
    country: "GB",
    uuid: "b75b7bd2-2d2c-4277-b2d5-01a0545934e6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5987",
    name: "Taunton High St Express",
    region: "England",
    country: "GB",
    uuid: "bd95d42d-5119-41ac-892e-9d2e66063df1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5989",
    name: "Bow Violet Rd Express",
    region: "England",
    country: "GB",
    uuid: "349e831a-1b14-46d4-a163-c002460416bb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5990",
    name: "Rogerstone Newport Express",
    region: "Wales",
    country: "GB",
    uuid: "f3257ef9-4011-4891-9fd2-5f1285e48a2c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5992",
    name: "Chesterfield Extra",
    region: "England",
    country: "GB",
    uuid: "d1396a49-c5d1-4153-8060-9f4e5686e3db",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5994",
    name: "Cardiff St Marys Express",
    region: "Wales",
    country: "GB",
    uuid: "772202ab-d6db-4c17-a629-1c0e317b4a0e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "5995",
    name: "Eccles Monton Rd Express",
    region: "England",
    country: "GB",
    uuid: "4ae97f50-18c5-4a26-8e02-5897a4bc7d81",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5996",
    name: "Kingsley Park Express",
    region: "England",
    country: "GB",
    uuid: "246b7e64-44f7-4ea2-9240-0a443fa08d61",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "5998",
    name: "Tesco Aylesford CFC",
    region: "England",
    country: "GB",
    uuid: "8d72afa9-3f2e-4b23-9c6a-9f0d842833ab",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6002",
    name: "Havant Extra",
    region: "England",
    country: "GB",
    uuid: "47aa742c-7de2-4e77-ba9a-28f9037bd2bc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6004",
    name: "Ilkeston Express",
    region: "England",
    country: "GB",
    uuid: "3e19b2f9-f33a-4c8f-b0d0-0c282060a8f8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6005",
    name: "Frances Wharf Express",
    region: "England",
    country: "GB",
    uuid: "1c2c093c-da6e-4c76-bb63-9336d2f8ffc3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6009",
    name: "Mile End Rd Lond Express",
    region: "England",
    country: "GB",
    uuid: "5d8f4942-7a10-424f-a095-0f01df3b4dab",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6010",
    name: "Ballinasloe Superstore",
    region: "Irish Republic",
    country: "IE",
    uuid: "e96da057-1dc8-43e0-9e4b-28cd16adc434",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "6013",
    name: "Clifton St Express",
    region: "Wales",
    country: "GB",
    uuid: "fd86e8bd-eb98-45e9-8ff7-8f22053520b2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "6014",
    name: "Hounslow Staines Rd Express",
    region: "England",
    country: "GB",
    uuid: "ac9b8cd5-6e29-4d33-a6c5-929138053f90",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6017",
    name: "Walkden Extra",
    region: "England",
    country: "GB",
    uuid: "750f5bd0-eb2a-468a-b94a-8c37a2f13974",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6020",
    name: "Clapham Oval Express",
    region: "England",
    country: "GB",
    uuid: "b826de70-3838-4c40-8660-43559464f639",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6023",
    name: "Harrow Shaftsbury Express",
    region: "England",
    country: "GB",
    uuid: "ef3845b0-6aae-4a9f-b19c-da2d49ef317b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6024",
    name: "Shepherds Bush Express",
    region: "England",
    country: "GB",
    uuid: "983365cf-4ac0-4776-8efc-dc8b50002b14",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6025",
    name: "Middleton Extra",
    region: "England",
    country: "GB",
    uuid: "b29a6a77-c057-4824-8caf-aab64c182d70",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6032",
    name: "Mortlake Express",
    region: "England",
    country: "GB",
    uuid: "4d5dbbc0-5d74-4105-a626-eae500770df3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6033",
    name: "Chadwell Heath Express",
    region: "England",
    country: "GB",
    uuid: "7468b40c-dd10-4a64-b21a-5b1abf600711",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6035",
    name: "Wallasey Liscard Express",
    region: "England",
    country: "GB",
    uuid: "d6d82cdb-b543-448f-8efc-3314683a8e2a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6037",
    name: "Burnley Express",
    region: "England",
    country: "GB",
    uuid: "04299e82-692f-4f5e-9307-fcb96c59e544",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6038",
    name: "Elm Park Romford Express",
    region: "England",
    country: "GB",
    uuid: "808f2ffc-4f91-4a0b-9824-747e729190ae",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6039",
    name: "Fulham Munster Rd Express",
    region: "England",
    country: "GB",
    uuid: "a187a0f7-1bec-4e6b-9895-b39f522691d0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6040",
    name: "College House Express",
    region: "England",
    country: "GB",
    uuid: "36e95a67-be1c-4c6b-abe4-b83e5a70c997",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6042",
    name: "Cheapside Express",
    region: "England",
    country: "GB",
    uuid: "054de321-99f1-486b-9de5-38821290c487",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6044",
    name: "Queens Rd Peckham Express",
    region: "England",
    country: "GB",
    uuid: "f28cf577-2227-42b4-b6bc-0e093f984bb9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6045",
    name: "Lillie House Express",
    region: "England",
    country: "GB",
    uuid: "481d5704-3508-4d86-a39d-fafe7f23f3c0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6046",
    name: "Kingstanding Birmingham Express",
    region: "England",
    country: "GB",
    uuid: "cb3f9217-9e15-4cae-82cf-8c1c5f88d024",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6048",
    name: "Deptford High St Express",
    region: "England",
    country: "GB",
    uuid: "8872f5dc-f165-46b4-9f04-9c6140bc8733",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6049",
    name: "Aberdeen Union St Express",
    region: "Scotland",
    country: "GB",
    uuid: "243260ab-cf64-436c-9122-cf3e09f6d607",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6050",
    name: "Newton Mearns Express",
    region: "Scotland",
    country: "GB",
    uuid: "d2f51d4b-ded2-4b9a-b68e-95bd458b634f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6053",
    name: "Newtown Superstore",
    region: "Wales",
    country: "GB",
    uuid: "c9fd421a-03b1-46e5-a720-391c529d33d5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "6054",
    name: "Cwmbran Express",
    region: "Wales",
    country: "GB",
    uuid: "15b14760-53f4-4177-81ca-10fd925bdff0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "6055",
    name: "South Bridge Express",
    region: "Scotland",
    country: "GB",
    uuid: "f634559c-2ba2-4425-b050-effdc0c9bed6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6056",
    name: "West Durrington Extra",
    region: "England",
    country: "GB",
    uuid: "1389934c-525a-44df-b0dd-e20032044fb3",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6057",
    name: "Greenwich Creek Rd Express",
    region: "England",
    country: "GB",
    uuid: "61fb728a-8667-42e6-b66a-a2eaa9b323fd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6059",
    name: "Barnet Greenhill Express",
    region: "England",
    country: "GB",
    uuid: "82d25f05-cbf3-4b0d-89ac-0fc0814597a0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6060",
    name: "Derby Stenson Rd Express",
    region: "England",
    country: "GB",
    uuid: "e59611ea-68cf-4f59-a036-92d5c16f6c6f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6061",
    name: "Sidwell St Express",
    region: "England",
    country: "GB",
    uuid: "75d2cea5-96e0-4dc9-990f-c03586ebd8bb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6063",
    name: "Baltimore Express",
    region: "England",
    country: "GB",
    uuid: "b1ec3413-9fa3-42de-88cb-810910c005f5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6064",
    name: "Glasgow Victoria Express",
    region: "Scotland",
    country: "GB",
    uuid: "d6bfa655-e820-4947-b111-e961ca22b2a0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6066",
    name: "Kingsway Local Centre Express",
    region: "England",
    country: "GB",
    uuid: "440f1d78-2335-4b14-b161-5d59f9171436",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6069",
    name: "Lambeth Kennington Rd Express",
    region: "England",
    country: "GB",
    uuid: "ffd1ee0c-951a-401d-877f-60eb32b3135d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6070",
    name: "Bermondsey Park Express",
    region: "England",
    country: "GB",
    uuid: "137a2e71-24c8-4789-8393-d2176156fa61",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6071",
    name: "Wimbledon Chase Express",
    region: "England",
    country: "GB",
    uuid: "825b0580-c852-4f9f-92f7-2a12c3fa6312",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6072",
    name: "Oldham Ashton Express",
    region: "England",
    country: "GB",
    uuid: "7f01ffae-9e94-4af6-af09-6a20a029b42f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6073",
    name: "Thornton Marsh Express",
    region: "England",
    country: "GB",
    uuid: "964f88d4-9454-47fa-899e-1ec5235ca6d3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6075",
    name: "Upton Park Express",
    region: "England",
    country: "GB",
    uuid: "bc6e0059-2ed8-4ad5-8c29-c3aa12981b6f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6076",
    name: "Middleton Oldham Rd Express",
    region: "England",
    country: "GB",
    uuid: "3b83cf44-97ad-4f96-b8db-26a2567c7bd1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6077",
    name: "Blackfriar Express",
    region: "England",
    country: "GB",
    uuid: "7ff05e39-e394-4459-ab64-4863b3460aab",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6078",
    name: "Radcliffe Water St Express",
    region: "England",
    country: "GB",
    uuid: "591ce796-cfa5-4993-936f-7f38a6f59849",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6079",
    name: "Erith Express",
    region: "England",
    country: "GB",
    uuid: "ff18a298-a064-40fe-8946-4d40c0b72887",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6080",
    name: "Warrington Man Rd Express",
    region: "England",
    country: "GB",
    uuid: "4d58a392-788c-4a6d-aaa8-1be427719ba6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6082",
    name: "Halton Leeds Express",
    region: "England",
    country: "GB",
    uuid: "4b2536dc-3e37-4b82-8415-0ca5790eb9f0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6086",
    name: "Battle Wallsend Express",
    region: "England",
    country: "GB",
    uuid: "9ba94e1f-91c9-4cd0-8e9b-d5fdb3d63293",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6087",
    name: "Torquay Babbacombe Rd Express",
    region: "England",
    country: "GB",
    uuid: "42cd65da-e8bf-41c6-9881-142a30c9868c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6089",
    name: "Lancaster King St Express",
    region: "England",
    country: "GB",
    uuid: "5a7bb943-cf6b-4e7d-9a4a-212af33e270e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6090",
    name: "Hudders Leeds Rd Express",
    region: "England",
    country: "GB",
    uuid: "80437dcd-ad48-4ada-b066-183faf73dc5f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6091",
    name: "Ruislip High St Express",
    region: "England",
    country: "GB",
    uuid: "084c7cca-a078-48c4-970a-25efce03ea26",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6093",
    name: "Folkestone Foord Rd Express",
    region: "England",
    country: "GB",
    uuid: "484cc52f-b988-444f-866c-c7b9789059e7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6094",
    name: "Gravesend Perry St Express",
    region: "England",
    country: "GB",
    uuid: "76913c03-6714-403a-87d7-46b91ef16ba5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6097",
    name: "Plympton St Mary Express",
    region: "England",
    country: "GB",
    uuid: "dff114fa-2908-42aa-9714-bc24177277e4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6099",
    name: "Glasgow Byres Road Express",
    region: "Scotland",
    country: "GB",
    uuid: "c53e590c-0a8d-48d7-bd43-275c6ec31c63",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6101",
    name: "Plumstead Lakedale Rd Express",
    region: "England",
    country: "GB",
    uuid: "59566356-4764-403e-b745-75761281618e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6103",
    name: "Nottingham Compton Express",
    region: "England",
    country: "GB",
    uuid: "316761ba-f2ae-4faf-bfd3-68a35088a70c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6106",
    name: "Callington Superstore",
    region: "England",
    country: "GB",
    uuid: "d0ea601a-acb2-4016-a260-f5d357555eb0",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6109",
    name: "Tesco Greenford CFC",
    region: "England",
    country: "GB",
    uuid: "8d72afa9-3f2e-4b23-9c6a-9f0d842833ac",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6111",
    name: "Stanground Express",
    region: "England",
    country: "GB",
    uuid: "fa77e5de-a408-4021-90ae-3c151c54876d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6112",
    name: "Birmingham Colmore Express",
    region: "England",
    country: "GB",
    uuid: "174a8cc9-864e-40ae-8a1f-b220f1155862",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6117",
    name: "East Rd Express",
    region: "England",
    country: "GB",
    uuid: "48eba2aa-f03b-4bbf-8b43-fcc02d0bae72",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6118",
    name: "Richmond Kew Rd Express",
    region: "England",
    country: "GB",
    uuid: "b48d466c-938f-4ed0-b176-aff0329649e3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6119",
    name: "Selly Oak Bristol Rd Esso Express",
    region: "England",
    country: "GB",
    uuid: "f9865c36-30b6-4f91-82db-1af926feea12",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6125",
    name: "Baildon Express",
    region: "England",
    country: "GB",
    uuid: "e4c5f1d8-1480-4cd6-9dca-720a81e17f51",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6126",
    name: "Ipswich Nacton Rd Express",
    region: "England",
    country: "GB",
    uuid: "d9353641-a30c-47fd-ac46-5fbbab53b3b4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6127",
    name: "Kettering London Rd Express",
    region: "England",
    country: "GB",
    uuid: "c9689d40-348f-4a38-9aa2-867367e4e167",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6129",
    name: "Leyland Express",
    region: "England",
    country: "GB",
    uuid: "c3fa75cf-d254-4ae6-a108-77fb8851337c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6131",
    name: "Old Stevenage Express",
    region: "England",
    country: "GB",
    uuid: "1d7c8467-2203-4a4f-ac90-1f0d08bdefd4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6132",
    name: "Bristol Axbridge Rd Express",
    region: "England",
    country: "GB",
    uuid: "d117dad1-aa48-4fb0-9080-66962a018366",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6133",
    name: "Battersea Park Express",
    region: "England",
    country: "GB",
    uuid: "bbb3d654-6b16-46d4-9c89-5a06b5729f75",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6135",
    name: "Loughborough Rushes Superstore",
    region: "England",
    country: "GB",
    uuid: "f7be48d6-e834-492a-8829-14c2400262ca",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6137",
    name: "Luton Bishopscote Express",
    region: "England",
    country: "GB",
    uuid: "7c947bed-708a-459e-bff3-ca98f322c52b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6138",
    name: "Canons Express",
    region: "England",
    country: "GB",
    uuid: "737c94c6-71c2-4c0d-87c3-6d4c70393704",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6139",
    name: "St Mary’s Reading Exp",
    region: "England",
    country: "GB",
    uuid: "022ace94-cac9-4a82-a95a-e367ea943646",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6140",
    name: "Deansgate Express",
    region: "England",
    country: "GB",
    uuid: "60e81b8b-2031-4ad2-a7db-a941320cfbab",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6141",
    name: "Great Barr Express",
    region: "England",
    country: "GB",
    uuid: "52b9c73f-7281-4f7b-9bcf-0eb24a18b8c5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6142",
    name: "Hayes Uxbridge Rd Express",
    region: "England",
    country: "GB",
    uuid: "8848be3f-d4a9-456c-955c-dcae132daa0a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6144",
    name: "Harrow Apollo Express",
    region: "England",
    country: "GB",
    uuid: "27806502-aeae-40c4-a6ac-74dce65c6339",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6145",
    name: "Dundee Hawkhill Express",
    region: "Scotland",
    country: "GB",
    uuid: "165196d8-dd1b-4144-bd8e-686b96af9478",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6148",
    name: "Southampton High St Express",
    region: "England",
    country: "GB",
    uuid: "e547e8ec-f05a-4105-a45e-a357e0f3d28d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6150",
    name: "East Rd Shoreditch Express",
    region: "England",
    country: "GB",
    uuid: "5e976f72-1dc9-4602-99e7-4279e9b2bf9e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6151",
    name: "Napiershall Express",
    region: "Scotland",
    country: "GB",
    uuid: "50878bd1-e242-4400-8992-4b5096c464f0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6152",
    name: "South Lambeth Express",
    region: "England",
    country: "GB",
    uuid: "b15d5ab7-4608-4f3a-a4b1-c972fb5b03b1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6153",
    name: "Sheffield Birley Rd Express",
    region: "England",
    country: "GB",
    uuid: "ace861de-e30b-437e-ad94-a5e6375f50c9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6154",
    name: "Accrington Extra",
    region: "England",
    country: "GB",
    uuid: "194d795d-33b2-49cf-85ce-a05583b02bfc",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6156",
    name: "Kingston Thames Express",
    region: "England",
    country: "GB",
    uuid: "9b101bab-8fe5-4120-b0bf-fa28f2a0dfb7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6157",
    name: "Dundee Strathmartine Road Express",
    region: "Scotland",
    country: "GB",
    uuid: "768dc686-a19f-45df-aa01-bb4baec3c304",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6159",
    name: "Northampton St Edmunds Express",
    region: "England",
    country: "GB",
    uuid: "76cc95e7-509b-430a-88a9-3ec71e7b7d9a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6161",
    name: "Walsall Extra",
    region: "England",
    country: "GB",
    uuid: "4d673a63-1a3a-4f66-84a7-e3ac9dbcd786",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6162",
    name: "Leyton High Rd Express",
    region: "England",
    country: "GB",
    uuid: "5a20a450-02a6-4e36-98ff-60ab251d4610",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6164",
    name: "Glasgow St Enoch Express",
    region: "Scotland",
    country: "GB",
    uuid: "a1d52c78-0f2a-470e-86e7-438f768cf9f9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6165",
    name: "Guildford Bridge Express",
    region: "England",
    country: "GB",
    uuid: "58625a31-cd32-44c8-9279-e8db49f10fd0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6166",
    name: "Coulsdon Express",
    region: "England",
    country: "GB",
    uuid: "4a320ab1-421c-47e0-afed-a552da48f2a1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6167",
    name: "Oxford St Aldates Express",
    region: "England",
    country: "GB",
    uuid: "e60f847c-e80b-4205-a513-5029694d63ce",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6168",
    name: "Percy St Express",
    region: "England",
    country: "GB",
    uuid: "9512fa68-077e-4b9f-86f5-c6e58f0e7a75",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6169",
    name: "North St Express",
    region: "Scotland",
    country: "GB",
    uuid: "5895e6c1-2fe0-449f-8b43-7b29c9ae20c2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6170",
    name: "Hayes Station Rd Express",
    region: "England",
    country: "GB",
    uuid: "97b014d8-b2d8-4b5a-a061-ec76a5389cf7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6171",
    name: "Paisley Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "0ec28e61-2698-4aee-bdce-39e0de45c735",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6172",
    name: "Tower Bridge Express",
    region: "England",
    country: "GB",
    uuid: "bc672caf-678a-471a-bcf2-22ad5de02701",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6173",
    name: "Swansea Langdon Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "3cca0f38-a15f-4369-9989-ee8ade530769",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "6174",
    name: "Twickenham Express",
    region: "England",
    country: "GB",
    uuid: "6ff1a517-2778-4609-9c3e-eee2c0a3319d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6176",
    name: "Exwick Express",
    region: "England",
    country: "GB",
    uuid: "2285bae0-4713-4fb2-a3bc-827f297d142c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6179",
    name: "St Edmunds Cornhill Express",
    region: "England",
    country: "GB",
    uuid: "29f2af47-a93e-44f3-9142-b419c05f51c5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6181",
    name: "Berwick-upon-tweed Superstore",
    region: "England",
    country: "GB",
    uuid: "383d6620-ac94-49b4-a58b-966eafb47d69",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6183",
    name: "Fountainbridge Express",
    region: "Scotland",
    country: "GB",
    uuid: "00e6b17f-87ef-4784-a17a-98a61247ad5a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6186",
    name: "Wembley Quadrant Express",
    region: "England",
    country: "GB",
    uuid: "b4e5571d-5ecc-42b2-b0b2-aaf547011e8b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6187",
    name: "Caledonian Rd Express",
    region: "England",
    country: "GB",
    uuid: "8d7cc86e-59da-4729-b001-60fece08024b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6189",
    name: "North End Portsmouth Express",
    region: "England",
    country: "GB",
    uuid: "d8c2dfbc-28ea-4b96-a8ed-6528912111d7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6190",
    name: "Morley Elland Rd Express",
    region: "England",
    country: "GB",
    uuid: "ffefe482-7713-4f06-8d29-d5b506d789df",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6192",
    name: "Newbury Superstore",
    region: "England",
    country: "GB",
    uuid: "09200817-026f-4f9f-8601-e37442134812",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6193",
    name: "Musselburgh Extra",
    region: "Scotland",
    country: "GB",
    uuid: "91eaf45a-7fbf-4712-8d1c-5d3eaff83d7f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6194",
    name: "Cheltnhm Rd Bristol Express",
    region: "England",
    country: "GB",
    uuid: "3958aa70-24dd-4863-8efb-d48cf4065126",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6195",
    name: "Leicester Bede Island Express",
    region: "England",
    country: "GB",
    uuid: "a980c696-8e5a-4cfa-b7f1-ae25d11b2912",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6196",
    name: "Welling Superstore",
    region: "England",
    country: "GB",
    uuid: "f65d03a3-c303-44e5-8270-aeecd69c70d1",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6197",
    name: "Dudley Extra",
    region: "England",
    country: "GB",
    uuid: "5e28c46d-90e7-4093-b874-816bfa1ae359",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6198",
    name: "Glasgow Maryhill Extra",
    region: "Scotland",
    country: "GB",
    uuid: "9d997d26-70bd-4a96-9567-fbc924cce603",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6200",
    name: "Norwich Dereham Express",
    region: "England",
    country: "GB",
    uuid: "c2fbaa11-0aed-4059-b57e-6a6c5bbd62c1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6201",
    name: "Bounds Green Rd Express",
    region: "England",
    country: "GB",
    uuid: "8da96af6-e67c-4060-a2f5-314edc222f60",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6203",
    name: "Wishaw Coltnes Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "e0b28a13-3350-43a6-b3b4-7aaf7511ec46",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6205",
    name: "Nottingham Oakdale Express",
    region: "England",
    country: "GB",
    uuid: "e2060f67-e0a2-4969-baf2-e99c2b3da625",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6206",
    name: "Clacton-on-sea Express",
    region: "England",
    country: "GB",
    uuid: "64c1820a-67c3-48c5-93c8-9d68216941ba",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6207",
    name: "St Albans Express",
    region: "England",
    country: "GB",
    uuid: "a9807e22-9e04-427b-8b7b-ed5a3a4ab0fa",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6210",
    name: "Hornsea Superstore",
    region: "England",
    country: "GB",
    uuid: "8976a6ab-8995-42d4-be55-9753be62e37d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6211",
    name: "Myrtle St Liverpool Express",
    region: "England",
    country: "GB",
    uuid: "99de6148-3417-430e-9fb9-c0452a87c757",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6212",
    name: "Stratford Express",
    region: "England",
    country: "GB",
    uuid: "35ec3054-e165-4bbb-b316-fdfd3c324a77",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6214",
    name: "London Road Southampton Express",
    region: "England",
    country: "GB",
    uuid: "66892e6c-e45d-48aa-ac41-a3932f6dcb80",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6215",
    name: "Askew Rd Shepherds Bush Express",
    region: "England",
    country: "GB",
    uuid: "bc2659eb-9c8f-4d0b-a314-70dfa652302e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6216",
    name: "Caerleon Rd Newport Express",
    region: "Wales",
    country: "GB",
    uuid: "29fdc058-f218-46b7-a173-84cd231fa958",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "6217",
    name: "Southend Rd Grays Express",
    region: "England",
    country: "GB",
    uuid: "6b0d7594-87d8-4225-8f95-1cc82af22ac7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6220",
    name: "Hereson Rd Ramsgate Express",
    region: "England",
    country: "GB",
    uuid: "2a433924-1cf9-4ac7-9103-3d9d04828eff",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6224",
    name: "Beckenham Express",
    region: "England",
    country: "GB",
    uuid: "74e41410-369b-4528-969d-cbe2f0c6d7cc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6225",
    name: "Risca Extra",
    region: "Wales",
    country: "GB",
    uuid: "c47892b3-b9e9-4b0f-9722-33a8d96f711c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "6230",
    name: "Hackney Dalston Ln Express",
    region: "England",
    country: "GB",
    uuid: "002d4173-80aa-4fd5-a43e-c97a4d2aa061",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6231",
    name: "Kennington Park Rd Express",
    region: "England",
    country: "GB",
    uuid: "1010197f-9582-4dc9-aed9-84aa7ed55bfe",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6232",
    name: "Chorlton-cum-hardy Express",
    region: "England",
    country: "GB",
    uuid: "e292153b-c29d-4171-983c-d559e622cdb3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6233",
    name: "St Pauls St Leeds Express",
    region: "England",
    country: "GB",
    uuid: "3b21626b-4113-4b6b-b5bc-baaa890b4753",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6234",
    name: "Chingford Express",
    region: "England",
    country: "GB",
    uuid: "3468e924-c0a4-4893-8e87-03171def5386",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6235",
    name: "Butts Rd Express",
    region: "England",
    country: "GB",
    uuid: "4eb55b71-cea2-498f-ac8e-85df70f02fa1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6236",
    name: "Queens Rd Cheltenham Express",
    region: "England",
    country: "GB",
    uuid: "d212965b-1df2-432e-b451-644c87109504",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6239",
    name: "Streatham Crown Express",
    region: "England",
    country: "GB",
    uuid: "7dd689e3-b4ac-4f35-ba35-479ab53e4d8a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6240",
    name: "Crumlin Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "be1476cb-e0c4-4a2c-8e13-0113cc49ff80",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "6242",
    name: "Westbourne Poole Express",
    region: "England",
    country: "GB",
    uuid: "e6cd03bd-a18a-480e-bb8d-9a8159c2c470",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6243",
    name: "Middleton Langley Express",
    region: "England",
    country: "GB",
    uuid: "1cd08cbb-7963-4716-9d08-01e869163de9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6244",
    name: "Lea Bridge Rd Express",
    region: "England",
    country: "GB",
    uuid: "7ae04bab-5597-4c91-b679-66bdef784421",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6245",
    name: "Briton Ferry Express",
    region: "Wales",
    country: "GB",
    uuid: "29c28f1d-6e6c-4693-a664-8edb3ed2d298",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "6250",
    name: "Chorley Buckshaw Superstore",
    region: "England",
    country: "GB",
    uuid: "6f11ee56-30a0-49a3-968c-11612dbe6049",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6252",
    name: "Filey Superstore",
    region: "England",
    country: "GB",
    uuid: "2b875f9e-cc74-470d-bd76-ac150004518a",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6256",
    name: "Fulham Sherbrooke Rd Express",
    region: "England",
    country: "GB",
    uuid: "c79bfa4f-1140-46c3-a02f-7922efa56ec6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6257",
    name: "Millbrae Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "4c60fdde-0ffc-46db-8530-5b77d052ab64",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6258",
    name: "Cheadle Stockport Rd Express",
    region: "England",
    country: "GB",
    uuid: "c5994714-b275-4bb2-8fc7-afc5e1860362",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6260",
    name: "Margate Canterbury Rd Express",
    region: "England",
    country: "GB",
    uuid: "f754376a-5166-49a8-8a41-52fad3a8db91",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6262",
    name: "Maidenhead Bath Rd Express",
    region: "England",
    country: "GB",
    uuid: "6de3b53a-2a59-47eb-ad27-8eeb700c537e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6264",
    name: "Helston Superstore",
    region: "England",
    country: "GB",
    uuid: "3ffeb3bb-cfe4-427b-8463-e01f7c00b941",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6265",
    name: "Clay Cross Extra",
    region: "England",
    country: "GB",
    uuid: "f7ffbf08-8585-45f6-a6ad-21a2f6f5a76a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6269",
    name: "Barnstaple Taw View Extra",
    region: "England",
    country: "GB",
    uuid: "f3dd76fa-3162-422f-acdd-cdaf7c591834",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6270",
    name: "Newtownards Extra",
    region: "Northern Ireland",
    country: "GB",
    uuid: "b7c84365-8305-41c5-9aed-34d74093ad23",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "6271",
    name: "Craigavon Extra",
    region: "Northern Ireland",
    country: "GB",
    uuid: "5312a9fa-3d8d-467b-8edb-8f962d634413",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "6273",
    name: "Kirkwall Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "639176dd-2c70-43e5-a76b-46ca236163ae",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6274",
    name: "Naas Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "b9a10d5b-ed2c-478c-9392-f1dee42ac485",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "6276",
    name: "Rugby Cattlemarket Express",
    region: "England",
    country: "GB",
    uuid: "d3e6f554-d556-4d88-a282-2e071aa90967",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6277",
    name: "Chesterfield Derby Rd Express",
    region: "England",
    country: "GB",
    uuid: "fabab5b7-a437-423f-a263-177e24c7af14",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6278",
    name: "Lower Clapton Rd Express",
    region: "England",
    country: "GB",
    uuid: "cf333420-2ed0-45eb-a804-18de9bf4e224",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6280",
    name: "Allerton Rd Liverpool Express",
    region: "England",
    country: "GB",
    uuid: "db39f4de-595f-4d70-a81a-2884698a18f7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6282",
    name: "Northwich Chester Rd Express",
    region: "England",
    country: "GB",
    uuid: "a27f8bf5-663e-417a-a7df-c20e03394dee",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6286",
    name: "Queensbury Superstore",
    region: "England",
    country: "GB",
    uuid: "b83b57a0-5fcf-480b-a129-920b311928e7",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6287",
    name: "Banchory Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "dc061996-a386-470d-a642-b3799362a768",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6291",
    name: "Camberwell Express",
    region: "England",
    country: "GB",
    uuid: "a25e7f9b-8ae8-4376-bfea-00a6b6cbb52e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6292",
    name: "Oxford Magdalen St Express",
    region: "England",
    country: "GB",
    uuid: "1626eb43-bd57-4f4a-acfc-d54a94739d65",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6294",
    name: "Amesbury Superstore",
    region: "England",
    country: "GB",
    uuid: "9adb615e-59f3-4650-bec5-2f22a5a2832d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6296",
    name: "Park Rd Extra",
    region: "England",
    country: "GB",
    uuid: "0a8fbebe-08e3-4d61-b191-9f49fe15ec43",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6299",
    name: "West Heath Birmingham Express",
    region: "England",
    country: "GB",
    uuid: "40fdfc3f-60f7-4f12-8238-33550f397046",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6300",
    name: "Welford House Leicester Express",
    region: "England",
    country: "GB",
    uuid: "d87b06dc-84ad-42b1-a12b-6369155a8e8a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6305",
    name: "Birmingham Hockley Express",
    region: "England",
    country: "GB",
    uuid: "9c7de5b2-cce5-47b2-9ad5-c35c8e174481",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6312",
    name: "Clytha Park Newport Express",
    region: "Wales",
    country: "GB",
    uuid: "fadb58b6-91fd-4fcb-8929-fb3161a89df3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "6313",
    name: "London Road Gloucester Express",
    region: "England",
    country: "GB",
    uuid: "37a231d7-6a5c-4131-9930-b05d8f66a1e9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6314",
    name: "Sisters Rd Express",
    region: "England",
    country: "GB",
    uuid: "0fc315c6-2fc8-44ad-a206-67b8665bd055",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6315",
    name: "Fulham Imperal Wharf Express",
    region: "England",
    country: "GB",
    uuid: "c8c46082-9d98-46a5-a250-348cd4723a5f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6316",
    name: "Bournemouth Holden Rd Express",
    region: "England",
    country: "GB",
    uuid: "47ed1b86-f026-4e75-9f8a-e4eb2476a63a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6319",
    name: "Borough Rd Express",
    region: "England",
    country: "GB",
    uuid: "1db87b41-6a84-4fc3-ba2b-2cb6cab0ca5b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6321",
    name: "Epsom Station Express",
    region: "England",
    country: "GB",
    uuid: "0594e0f6-5843-46e8-b3f4-b73e82f73480",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6325",
    name: "Blackpool Westcliffe Dr Express",
    region: "England",
    country: "GB",
    uuid: "54ac9a62-ac0d-41e1-a659-cdd38e219d51",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6329",
    name: "Bishop Auckland Extra",
    region: "England",
    country: "GB",
    uuid: "5d64b560-c910-4aeb-af8c-b2a58d6b78f6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6331",
    name: "Marlborough Superstore",
    region: "England",
    country: "GB",
    uuid: "e3abf722-bfd2-425e-9139-2d502a969e25",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6332",
    name: "Delamere St Chester Express",
    region: "England",
    country: "GB",
    uuid: "4c697d31-485e-4138-9918-5c92150b63e3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6333",
    name: "Tain Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "99f1b838-b4bb-4cef-bf22-71d8ba43b835",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6338",
    name: "High St Banbury Express",
    region: "England",
    country: "GB",
    uuid: "682b3c64-fb50-4d85-9d5b-6d937e080b56",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6339",
    name: "Mount Rd Chingford Express",
    region: "England",
    country: "GB",
    uuid: "80aca204-ed90-4f02-b104-09aed54f9424",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6341",
    name: "Marton Dr Blckpool Express",
    region: "England",
    country: "GB",
    uuid: "e3037954-7d56-40de-8d87-f1e505e30f73",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6342",
    name: "Liverpool Rd Irlam Express",
    region: "England",
    country: "GB",
    uuid: "a2851056-2b5b-413f-b12b-54ee3784298c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6347",
    name: "Wombwell Express",
    region: "England",
    country: "GB",
    uuid: "e73b212f-b00a-4f1b-b341-6148b9f8e8a3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6353",
    name: "Merchant Express",
    region: "Scotland",
    country: "GB",
    uuid: "74f3abb1-03ae-4937-a7eb-6bf180455e72",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6354",
    name: "Wembley Tube Station Express",
    region: "England",
    country: "GB",
    uuid: "1ac70813-45fe-4d46-a388-143785e03f9b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6357",
    name: "Eastwood Notts Rd Express",
    region: "England",
    country: "GB",
    uuid: "79d0705d-44f2-476e-acbd-8356df079bc8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6358",
    name: "St Albans Hatfield Rd Express",
    region: "England",
    country: "GB",
    uuid: "7c49c3c3-7af3-4873-b038-80560e6c9d58",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6364",
    name: "Ilford Ley St Express",
    region: "England",
    country: "GB",
    uuid: "2eb2dfe9-b80d-4310-8a18-1de074b182e8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6365",
    name: "High Rd Leytonstone Express",
    region: "England",
    country: "GB",
    uuid: "67a4b1dc-6f35-49f1-9743-7aef77b887a5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6366",
    name: "Paston Express",
    region: "England",
    country: "GB",
    uuid: "b14c4ead-7399-4558-a86f-e88622a281bb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6368",
    name: "Crosby Coronation Rd Express",
    region: "England",
    country: "GB",
    uuid: "618d74e1-3ca9-4e84-b590-63922183ab00",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6369",
    name: "Leicester Melton Rd Express",
    region: "England",
    country: "GB",
    uuid: "f27efe0d-cfa5-4f10-800c-10323fa988e1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6371",
    name: "Woolwich Express",
    region: "England",
    country: "GB",
    uuid: "3d98ce40-3cbe-43d9-b926-06c3ed78e1a7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6372",
    name: "Eastern Seaside Rd Express",
    region: "England",
    country: "GB",
    uuid: "942fe687-f088-4a75-a71d-a3e97bb62fe3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6374",
    name: "Bath Wellsway Express",
    region: "England",
    country: "GB",
    uuid: "64c2a4fd-6af9-4eeb-b524-c6294c4c0aa7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6375",
    name: "Gloucester Painswick Rd Express",
    region: "England",
    country: "GB",
    uuid: "db4ecb82-5325-40d8-9384-0b84a158ea68",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6377",
    name: "Plymouth Discovery Heights Express",
    region: "England",
    country: "GB",
    uuid: "5293f499-3822-4e1a-8e29-72063f4758a0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6379",
    name: "Bourne Superstore",
    region: "England",
    country: "GB",
    uuid: "5aad6b12-6713-4cd9-9937-3f92bcdc2a0d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6380",
    name: "Gatley Church Rd Express",
    region: "England",
    country: "GB",
    uuid: "745f988a-fd9a-4b08-86bb-6f3b307d921a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6384",
    name: "Tulketh Mill Preston Express",
    region: "England",
    country: "GB",
    uuid: "47d87230-6274-4564-9207-1e96a93c354f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6385",
    name: "Rawlinson St Barrow Express",
    region: "England",
    country: "GB",
    uuid: "d7996fab-f9f6-41de-a192-223900ec4810",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6388",
    name: "Birmingham Bristnall Express",
    region: "England",
    country: "GB",
    uuid: "f1404274-bcf4-4af5-b5e7-e8becad790ba",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6390",
    name: "Great Suffolk St Express",
    region: "England",
    country: "GB",
    uuid: "20c9a53e-4084-4c27-9aa5-4ac0c96e7c91",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6392",
    name: "Manchester Swinton Express",
    region: "England",
    country: "GB",
    uuid: "72a739d2-c2d3-406e-bcce-ccf0d7fd1d57",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6394",
    name: "Rochdale Edenfield Express",
    region: "England",
    country: "GB",
    uuid: "de63463e-bc63-493a-9ec9-0addd31ef962",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6397",
    name: "Portlaoise Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "5d826b8a-a12e-4b8d-bed6-04c11284a450",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "6398",
    name: "Balbriggan Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "50376941-d15f-498b-acf4-58233f757d5a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "6400",
    name: "Carluke Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "23a734a5-3ce3-45d7-8102-c2a1667d8ad8",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6401",
    name: "Sheffield Extra",
    region: "England",
    country: "GB",
    uuid: "2dada48a-db85-4312-98c1-a3de71cefa0e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6403",
    name: "Rickmansworth Express",
    region: "England",
    country: "GB",
    uuid: "06491dde-9e76-4f55-a931-180d98997cbd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6406",
    name: "Hereford Game Express",
    region: "England",
    country: "GB",
    uuid: "45fc34b8-0c5f-48d0-9680-0803fe1d5727",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6407",
    name: "Prince Edward Rd Express",
    region: "England",
    country: "GB",
    uuid: "c18e6595-a2bc-46dc-bd9e-a6050c9763fb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6408",
    name: "Goodmayes Rowallen Express",
    region: "England",
    country: "GB",
    uuid: "216af882-41ba-4c53-8048-e31ed7f8714e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6409",
    name: "Hornsey Express",
    region: "England",
    country: "GB",
    uuid: "63945527-3818-438b-b57a-bc91eb91e546",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6411",
    name: "Rugby Bilton Express",
    region: "England",
    country: "GB",
    uuid: "2989f61f-80e1-40c5-a9ca-da2f2ec66198",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6412",
    name: "Whetstone Express",
    region: "England",
    country: "GB",
    uuid: "5fc1c919-891e-45a8-82c4-eed97fd20132",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6419",
    name: "Crewe Extra",
    region: "England",
    country: "GB",
    uuid: "4e693d6f-584e-443e-bcdd-0c0010de5655",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6420",
    name: "Yate Extra",
    region: "England",
    country: "GB",
    uuid: "710da469-21c3-41bb-b124-e615839e1c61",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6423",
    name: "Gracemount Express",
    region: "Scotland",
    country: "GB",
    uuid: "8e07b65a-27ad-4e1d-9b47-37332476b542",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6425",
    name: "Ayr Maybole Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "fdd2ece0-b3fc-40e9-94f8-8606fb3f821c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6426",
    name: "Abingdon Fitzharris Express",
    region: "England",
    country: "GB",
    uuid: "34fcad61-48ca-4621-b4a1-267aab97c5b6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6427",
    name: "Brixton Rd Express",
    region: "England",
    country: "GB",
    uuid: "017cfe34-d81d-4862-ab32-686cbfff11eb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6431",
    name: "Walthamstow St James St Express",
    region: "England",
    country: "GB",
    uuid: "f7c5d21c-1ba7-4f94-b1b9-f67f91a41604",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6432",
    name: "Wood Green Lordship Express",
    region: "England",
    country: "GB",
    uuid: "9531ac6d-9458-4a78-b369-1276636074df",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6434",
    name: "Welling Bellegrove Express",
    region: "England",
    country: "GB",
    uuid: "1c82e39c-ae43-49e5-bb82-e4b6cbdd8154",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6435",
    name: "Low Moor Bradford Express",
    region: "England",
    country: "GB",
    uuid: "6b185dee-ea8f-4d05-95a2-9d9f3b0fdc58",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6439",
    name: "Nottingham Oxclose Ln Express",
    region: "England",
    country: "GB",
    uuid: "fde99a4e-d226-4bc0-ac26-d3e75733ddba",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6440",
    name: "Tesco Enfield CFC",
    region: "England",
    country: "GB",
    uuid: "854a6b24-60df-4e76-b3de-87cf15153e18",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6441",
    name: "Walsall Rd Express",
    region: "England",
    country: "GB",
    uuid: "21b7e1b9-2c90-45be-9da6-68a38728ec3e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6442",
    name: "Whiston Windy Arbour Express",
    region: "England",
    country: "GB",
    uuid: "9f94b2ce-b46c-4c5c-8ccd-06984f94ab20",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6444",
    name: "Great Harwood Superstore",
    region: "England",
    country: "GB",
    uuid: "746819e5-a3a1-4789-a495-7c126687b72f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6445",
    name: "Liverpool Prescot St Express",
    region: "England",
    country: "GB",
    uuid: "0eecb477-0ca1-4105-add9-c55c52c5ef91",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6449",
    name: "Farnworth Superstore",
    region: "England",
    country: "GB",
    uuid: "3a3be41d-52d7-4ed1-983c-28a1e6088ed5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6450",
    name: "Cefn Mawr Superstore",
    region: "Wales",
    country: "GB",
    uuid: "23f54b80-980b-4c5a-8818-c6bee069f0c2",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "6453",
    name: "Greystoke Ave Express",
    region: "England",
    country: "GB",
    uuid: "3074f200-2ef6-4400-8c72-030bb98e9e53",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6457",
    name: "Seaton Superstore",
    region: "England",
    country: "GB",
    uuid: "31cf80d2-8245-4f72-b23f-5c0b30f659e8",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6458",
    name: "Lincoln High St Express",
    region: "England",
    country: "GB",
    uuid: "d9f601a6-2102-4822-bfcd-8fcf94db4f5f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6459",
    name: "Newport Spytty Extra",
    region: "Wales",
    country: "GB",
    uuid: "fb2ff6e4-e6a6-4128-a07d-076481eff96f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "6461",
    name: "Feltham Horse And Groom Express",
    region: "England",
    country: "GB",
    uuid: "9b7f24c9-425f-4fe2-8208-4098513b61d8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6463",
    name: "Yardley Extra",
    region: "England",
    country: "GB",
    uuid: "f28c96fd-4405-40ed-8884-58795ab6274e",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6467",
    name: "Aberdeen Woodend Superstore",
    region: "England",
    country: "GB",
    uuid: "91e16ac8-dc6a-4a8d-8872-24cfbdaf275c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6470",
    name: "Winsford Delamere Express",
    region: "England",
    country: "GB",
    uuid: "b8ddd40a-6f1c-4b2f-b5c3-98ef57eadb8a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6471",
    name: "Ammanford Superstore",
    region: "Wales",
    country: "GB",
    uuid: "ecae6dd3-af70-4fe3-a6bf-f8498ccceeb0",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "6473",
    name: "Bedworth Extra",
    region: "England",
    country: "GB",
    uuid: "542ce0da-2e65-4cf6-9445-c3ee868bc575",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6474",
    name: "Sheffield Dykes Hall Express",
    region: "England",
    country: "GB",
    uuid: "a4eb9527-8dd1-4954-bea1-144bdf6482fb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6476",
    name: "Leigh Extra",
    region: "England",
    country: "GB",
    uuid: "5bffae65-19d3-4870-bb91-7ff88ae3aba8",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6477",
    name: "Widnes Extra",
    region: "England",
    country: "GB",
    uuid: "9cd3eff8-04e3-482c-afaf-e9e188a8075b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6479",
    name: "Sheffield West Street Express",
    region: "England",
    country: "GB",
    uuid: "b088c148-74fd-4920-b60a-3c66874e1888",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6483",
    name: "Rainham Express",
    region: "England",
    country: "GB",
    uuid: "bf26dfaa-4d83-460e-ae6f-67e4ad94b6e1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6485",
    name: "Tooley Street Express",
    region: "England",
    country: "GB",
    uuid: "79c327fd-5da9-458f-b8f7-40b37d06ebf4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6490",
    name: "Tottenham Hale Village Express",
    region: "England",
    country: "GB",
    uuid: "9f5d1318-07df-42b0-a71c-d92dd4a7de61",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6491",
    name: "Cathcart Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "d62f9193-0d14-4eba-8911-541b4ece6a7e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6493",
    name: "Wandsworth High St Express",
    region: "England",
    country: "GB",
    uuid: "f3a91488-e291-4427-8659-394bd45354e6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6495",
    name: "Catford Rushey Rd Express",
    region: "England",
    country: "GB",
    uuid: "c50425a4-4c54-4e7a-82eb-8f151e9f12d1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6496",
    name: "LDN PENGE HIGH ST EXP",
    region: "England",
    country: "GB",
    uuid: "a0f9b5c9-7a35-45b5-ae90-a748785a2cdc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6499",
    name: "Romford Fairview Express",
    region: "England",
    country: "GB",
    uuid: "674f9ef6-3097-458b-a1f9-c62ede889ec2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6500",
    name: "Eltham Coronet Express",
    region: "England",
    country: "GB",
    uuid: "22be4765-9cad-4838-ab93-4068ee1a8a24",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6501",
    name: "Lee Solent Marine Express",
    region: "England",
    country: "GB",
    uuid: "03ed0a70-8f1e-4305-abba-8b38498e5d69",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6502",
    name: "Seaham Stockton Rd Express",
    region: "England",
    country: "GB",
    uuid: "72c224c6-7829-4b72-b950-7e2a9a7bafc7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6504",
    name: "St Helens Extra",
    region: "England",
    country: "GB",
    uuid: "7e83d497-95e4-483e-8f64-e72dc78deeda",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6505",
    name: "Falkirk Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "29235214-a553-4be1-9f43-4a52cd38630d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6506",
    name: "Northcott Extra",
    region: "Northern Ireland",
    country: "GB",
    uuid: "3a7ce632-24dd-4918-a455-4025c8cbb7f4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "6507",
    name: "Great Malvern Express",
    region: "England",
    country: "GB",
    uuid: "a2d79de9-c22a-47fd-8195-b8cd9a99149f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6508",
    name: "Bristol Bell Hill Rd Express",
    region: "England",
    country: "GB",
    uuid: "800364f4-7f04-44cf-acf7-195118e2fa19",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6511",
    name: "Maidstone Loose Rd Express",
    region: "England",
    country: "GB",
    uuid: "48ff4ec9-7665-4279-86d6-593cf94d813a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6512",
    name: "St Anne's Rd Express",
    region: "England",
    country: "GB",
    uuid: "3e346d41-907b-4e82-8af8-6019dce4c096",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6513",
    name: "Eston Cleveland Extra",
    region: "England",
    country: "GB",
    uuid: "11861da9-352c-4bd1-9034-90993782454b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6516",
    name: "Rayleigh Rd Express",
    region: "England",
    country: "GB",
    uuid: "0de87d90-16cf-483f-9823-1660dda140a7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6517",
    name: "Preston Friargate Express",
    region: "England",
    country: "GB",
    uuid: "1d14d723-ce18-4752-bf52-fed182f34583",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6518",
    name: "Piccadilly York Express",
    region: "England",
    country: "GB",
    uuid: "53247371-f2b6-4a89-9b03-f5a15b7d0744",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6519",
    name: "Abingdon Oxford Rd Express",
    region: "England",
    country: "GB",
    uuid: "656129e3-cbdc-4cd3-8211-1b89406b14dd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6524",
    name: "Gateshead Carr Hill Rd Express",
    region: "England",
    country: "GB",
    uuid: "1d73c1ba-0bfe-4eb2-a9c1-a891be48c735",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6525",
    name: "Airdrie Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "416b21d1-2a6d-4cf8-bd91-1ea6544fb177",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6527",
    name: "Crawley Haslett Ave Express",
    region: "England",
    country: "GB",
    uuid: "23f6ab53-5f2e-4fb3-9382-557d38d06948",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6529",
    name: "Mirfield Queens Rd Express",
    region: "England",
    country: "GB",
    uuid: "e21cd8e6-8064-4c67-9c3c-7b984e537e8e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6531",
    name: "Hawkhurst Superstore",
    region: "England",
    country: "GB",
    uuid: "33022e35-3b48-40d7-89c0-cd0cb8ab0069",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6532",
    name: "Reading Tilehurst Express",
    region: "England",
    country: "GB",
    uuid: "1ef7c88c-15e9-44ce-89d6-586d0c256a76",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6533",
    name: "Bournemouth Dolphin Express",
    region: "England",
    country: "GB",
    uuid: "6a75eca2-ad52-4641-a94b-540eeac009b9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6536",
    name: "Longlands Rd Express",
    region: "England",
    country: "GB",
    uuid: "94bbf3d2-fce1-46a9-83ec-867f390d2cf8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6537",
    name: "Cricklewood Broadway Express",
    region: "England",
    country: "GB",
    uuid: "d9158b2a-cb87-4336-9853-abc8322c2524",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6539",
    name: "Glasgow Sauchiehall Street Express",
    region: "Scotland",
    country: "GB",
    uuid: "0df9f990-c40f-470f-84db-ca3e442b3eb6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6541",
    name: "New Southgate Friern Express",
    region: "England",
    country: "GB",
    uuid: "32e409a0-9daa-42bf-b8b9-1d4e4be54b1c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6542",
    name: "Woking Guildford Rd Express",
    region: "England",
    country: "GB",
    uuid: "a464fcc0-c54f-4126-9d91-adb637f6d58a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6544",
    name: "Denton Mancunian Rd Express",
    region: "England",
    country: "GB",
    uuid: "b166abeb-b572-47d8-be1f-0afb18050a1c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6546",
    name: "Stevenage Chells Express",
    region: "England",
    country: "GB",
    uuid: "7e66a30c-a597-4907-baec-35b6057694b9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6549",
    name: "Whelley Express",
    region: "England",
    country: "GB",
    uuid: "44b05fb7-f9fe-4947-9ea1-a727b461527c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6550",
    name: "Niddrie Express",
    region: "Scotland",
    country: "GB",
    uuid: "64d423e1-e41f-4fff-80a3-0165a10815b4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6551",
    name: "Haymarket Express",
    region: "Scotland",
    country: "GB",
    uuid: "b6b80b0c-437d-4759-a285-6e6fca6e4d95",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6553",
    name: "Hattersley Extra",
    region: "England",
    country: "GB",
    uuid: "6455350f-0145-4c28-827e-d196f3bfc843",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6557",
    name: "Queensferry Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "30b2fe25-b286-4650-83bb-d0814e06bf8f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6560",
    name: "Camberwell New Rd Express",
    region: "England",
    country: "GB",
    uuid: "4ac41135-9078-4676-85d3-1a951e3dd57e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6565",
    name: "Hitchin Station Lyon Express",
    region: "England",
    country: "GB",
    uuid: "a55ce9d9-1b68-4c59-9961-d7b7d37c5e96",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6566",
    name: "Battersea Rd Express",
    region: "England",
    country: "GB",
    uuid: "4b30b186-6e05-4c6e-9da3-18f632c2d215",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6567",
    name: "Brixton Coldharbour Ln Express",
    region: "England",
    country: "GB",
    uuid: "3886d64d-eb09-4227-9337-9f06cabf73fc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6568",
    name: "Borough New Kent Rd Express",
    region: "England",
    country: "GB",
    uuid: "9778c6dc-b75b-4d2b-80c4-c7ad0d3a6ba3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6569",
    name: "Stafford Stone Rd Express",
    region: "England",
    country: "GB",
    uuid: "39202dce-b72e-40f2-9ad8-c76a9a1e5c56",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6570",
    name: "Boldmere Rd Express",
    region: "England",
    country: "GB",
    uuid: "0bf19b8d-7fb6-4242-a11d-49a532c4eb25",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6573",
    name: "Leicester Superstore",
    region: "England",
    country: "GB",
    uuid: "4795363d-6920-4806-b36c-a04efa7f0474",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6575",
    name: "South Norwood Hill Express",
    region: "England",
    country: "GB",
    uuid: "bc19784d-f22d-4b9b-a4e7-81bfc8b09bae",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6576",
    name: "Westway Hove Express",
    region: "England",
    country: "GB",
    uuid: "3c1bc3b2-69b6-496c-8d55-c22c0c0171b9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6577",
    name: "Portsmouth Kingston Rd Express",
    region: "England",
    country: "GB",
    uuid: "bc101305-5fc8-49e2-ac55-564ede852d7b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6579",
    name: "Bedford Brickhill Dr Express",
    region: "England",
    country: "GB",
    uuid: "9ec74db1-170f-4cab-a3b7-f200264320b6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6581",
    name: "Harrow Greenhill Way Express",
    region: "England",
    country: "GB",
    uuid: "0a82c7b1-a52c-4bd6-a8af-00be5cb6b4dc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6582",
    name: "Heston North Hyde lane Express",
    region: "England",
    country: "GB",
    uuid: "13643549-5362-4577-b855-2ac2844a65b4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6585",
    name: "South St Romford Express",
    region: "England",
    country: "GB",
    uuid: "06ce46bb-0440-4c9c-927d-cd08104ee07f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6586",
    name: "Letchworth Southfields Rd Express",
    region: "England",
    country: "GB",
    uuid: "399305f8-5267-4e06-a426-6fa5fd3cbcff",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6589",
    name: "Barnham Inn Express",
    region: "England",
    country: "GB",
    uuid: "fad8b913-2d3e-44db-b0d8-4fd037797db6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6592",
    name: "Wakefield Barnsley Rd Express",
    region: "England",
    country: "GB",
    uuid: "984c56df-32e7-44cb-bce6-48b6979fbbb5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6593",
    name: "Marsh Wall Express",
    region: "England",
    country: "GB",
    uuid: "c0ead41c-5298-4d22-9013-10eac5d66eda",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6597",
    name: "Newcastle Chapel House Express",
    region: "England",
    country: "GB",
    uuid: "1ee0984b-748e-42f5-9edf-491373684a14",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6598",
    name: "Lordswood Rd Express",
    region: "England",
    country: "GB",
    uuid: "247c2c00-07c7-4226-85d3-e00b8a512cf6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6600",
    name: "Romford Brentwood Rd Express",
    region: "England",
    country: "GB",
    uuid: "497edc70-23b3-457e-936e-a4af7fb02f6a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6601",
    name: "Whitechapel Fieldgate Express",
    region: "England",
    country: "GB",
    uuid: "c76eb0e3-8926-4742-9714-eba025f6fab5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6602",
    name: "Handsworth Oxhill Rd Express",
    region: "England",
    country: "GB",
    uuid: "f6b5f4ec-2bd0-4d37-8a8f-5c393de59ddd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6603",
    name: "Newcastle-under-lyme Express",
    region: "England",
    country: "GB",
    uuid: "c751bf8e-1db4-4248-9a03-f599c3242b31",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6605",
    name: "Mossley Rd Express",
    region: "England",
    country: "GB",
    uuid: "b8f911fa-697e-429f-9661-0aad11ce592c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6606",
    name: "Whickham Express",
    region: "England",
    country: "GB",
    uuid: "926ac0c3-9e57-4600-adca-24c275c25c02",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6607",
    name: "Gosport Forton Rd Express",
    region: "England",
    country: "GB",
    uuid: "0fcf7058-9ce5-431a-830d-7c758f0b8a3f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6608",
    name: "Saxmundham Superstore",
    region: "England",
    country: "GB",
    uuid: "eede98b8-5948-488e-9336-8f16ac86ea16",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6610",
    name: "Didsbury Wilmslow Rd Express",
    region: "England",
    country: "GB",
    uuid: "835dae6c-ed13-4dd9-96a0-6940a40df96b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6611",
    name: "Walthamstow Forest Rd Express",
    region: "England",
    country: "GB",
    uuid: "4ba96ee1-840a-4b25-a405-bf41c555ac7d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6613",
    name: "Holmefield Rd Abl Express",
    region: "England",
    country: "GB",
    uuid: "1d6a29cb-eafe-42c0-87f6-e5bee79703aa",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6614",
    name: "Greenford Lady Margaret Rd Express",
    region: "England",
    country: "GB",
    uuid: "0129a894-afa3-4399-8a6b-c87689b9b8c8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6615",
    name: "Dewsbury Leeds Rd Express",
    region: "England",
    country: "GB",
    uuid: "dc4b8701-b0a6-4244-bb26-f4c46a60b025",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6616",
    name: "West Drayton Station Rd Express",
    region: "England",
    country: "GB",
    uuid: "ae72ee75-3931-4a4f-941d-87ba14e0ad1b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6617",
    name: "Edgware Mollisonway Express",
    region: "England",
    country: "GB",
    uuid: "9dd9a10a-1d1c-4ea0-9555-2d59da7ec6e5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6624",
    name: "Priorswood Rd Express",
    region: "England",
    country: "GB",
    uuid: "5d650199-af91-4211-b225-42797376289a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6626",
    name: "Hoddesdon Burford St Express",
    region: "England",
    country: "GB",
    uuid: "becf3e24-ef08-4bc5-a261-18eed4b6855f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6629",
    name: "Chelmsford Moulsham St Express",
    region: "England",
    country: "GB",
    uuid: "cbcb9f18-25f6-4658-9086-7c1fa1cb0a05",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6630",
    name: "Chatham Lords Wood Express",
    region: "England",
    country: "GB",
    uuid: "d31d7187-1de8-44ac-ac00-fe068b552573",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6637",
    name: "Croydon South End Express",
    region: "England",
    country: "GB",
    uuid: "e7e50363-9ce7-4cfd-9e0e-0c5b72bb5b52",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6638",
    name: "Stourport Superstore",
    region: "England",
    country: "GB",
    uuid: "5e9b27bb-d5cc-4da1-b557-e49eed3f3dbd",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6639",
    name: "Stratford High St Express",
    region: "England",
    country: "GB",
    uuid: "8629276f-b168-4416-8709-0957de814cb5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6640",
    name: "Dagenham Shafter Rd Express",
    region: "England",
    country: "GB",
    uuid: "a86ff26c-3fb8-4096-b37c-a6e328130a2f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6641",
    name: "Leeds Burley Rd Express",
    region: "England",
    country: "GB",
    uuid: "da2de40c-1543-4e96-a697-27ff8babc9fc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6642",
    name: "Rugby Helvelyn Way Express",
    region: "England",
    country: "GB",
    uuid: "18e65733-ae21-461c-bac6-0b20b5247b17",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6644",
    name: "Hoyland Superstore",
    region: "England",
    country: "GB",
    uuid: "4fa752e5-be66-44be-b039-7188d8538059",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6646",
    name: "Salford Extra",
    region: "England",
    country: "GB",
    uuid: "ed98fef5-9f71-452f-adce-8fbdf556c197",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6647",
    name: "Tesco Crawley CFC",
    region: "England",
    country: "GB",
    uuid: "ecdaed35-4f4b-4cba-bd93-ae7aceb47c1d",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6650",
    name: "Ramsgate High St Express",
    region: "England",
    country: "GB",
    uuid: "56e1a599-6c92-42ab-b45d-1bd39b6ce608",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6653",
    name: "Sunderland Extra",
    region: "England",
    country: "GB",
    uuid: "029420b6-a2c5-43a3-8b1d-496f4f2a2ac3",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6654",
    name: "Churchdown Superstore",
    region: "England",
    country: "GB",
    uuid: "3158c5a6-c034-44c0-b040-32d96a8c3af2",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6656",
    name: "Grimsby Express",
    region: "England",
    country: "GB",
    uuid: "cb0a6008-4b7c-44e5-bbbb-0937dbf63d74",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6657",
    name: "Newquay East Street Express",
    region: "England",
    country: "GB",
    uuid: "675654b2-793e-4c87-9e0b-27691615cb0c",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6658",
    name: "Roseburn Express",
    region: "Scotland",
    country: "GB",
    uuid: "7dfefd9b-e141-4e66-a089-bd5366f4ce83",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6661",
    name: "Ashton Under Lyne Oldham Rd Express",
    region: "England",
    country: "GB",
    uuid: "9cd48c8f-bda7-4c44-8ca1-3ef75619f7e7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6662",
    name: "Copper Hawthorn Burton Express",
    region: "England",
    country: "GB",
    uuid: "4121c2da-ca59-413b-bc99-9c687c9cbca5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6664",
    name: "Angel Hill Express",
    region: "England",
    country: "GB",
    uuid: "65b9783c-ba85-4e56-a91d-030562510c1e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6665",
    name: "Green Gate Barking Rd Express",
    region: "England",
    country: "GB",
    uuid: "42aa7dcc-f7b8-4707-8bfa-48d76a5b8f34",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6666",
    name: "Dartford E Hill Express",
    region: "England",
    country: "GB",
    uuid: "23c9e170-8dcc-4e97-84b2-682975d216b2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6668",
    name: "New Cavendish Express",
    region: "England",
    country: "GB",
    uuid: "65407264-9067-4fa5-88a0-da246875eab6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6671",
    name: "Padiham Superstore",
    region: "England",
    country: "GB",
    uuid: "74188504-994a-41ee-89f7-3a0badf79f6d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6673",
    name: "Southfields Replingham Rd Express",
    region: "England",
    country: "GB",
    uuid: "e21a3901-18e0-48f8-874f-cf9ce613b2ea",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6675",
    name: "Bexley Blackfen Rd Express",
    region: "England",
    country: "GB",
    uuid: "3494d9f1-0f6e-401c-955c-0ea3ed6755a1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6678",
    name: "Leicester Rd Loughborough Express",
    region: "England",
    country: "GB",
    uuid: "558a94f1-b64c-4f1e-ac0a-caad1f804070",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6682",
    name: "Southampton Butts Rd Express",
    region: "England",
    country: "GB",
    uuid: "941686b2-2f90-4d37-b3a9-61b9f0f454e3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6686",
    name: "Surbiton Hook Rd Express",
    region: "England",
    country: "GB",
    uuid: "fe5f4445-b343-4462-bba0-66c06948a621",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6687",
    name: "Upper Shoreham Express",
    region: "England",
    country: "GB",
    uuid: "d2d5be0d-9ab2-4b0b-82ce-fb7abd878006",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6688",
    name: "Sheffield Church St Express",
    region: "England",
    country: "GB",
    uuid: "b1a16b21-c982-452c-8e93-6f4848cbf499",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6690",
    name: "Worcester Park Express",
    region: "England",
    country: "GB",
    uuid: "00a3634d-5178-47e1-841c-8d1359239832",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6694",
    name: "Edmonton Express",
    region: "England",
    country: "GB",
    uuid: "86a717df-0012-447d-b67a-f5614d60337d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6696",
    name: "Barry Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "e97f9a84-344f-4057-8902-2a90f0259044",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "6697",
    name: "Hounslow Hanworth Express",
    region: "England",
    country: "GB",
    uuid: "af9d8fc1-ef09-4a44-b1f1-3935210bcbf2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6698",
    name: "Sutton Lower Rd Express",
    region: "England",
    country: "GB",
    uuid: "01bf9365-9933-4b6e-8bb6-78dcdc743eda",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6699",
    name: "Northumberland Express",
    region: "England",
    country: "GB",
    uuid: "bdd29bcd-8fcb-4fd6-81c4-e19ac703d837",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6700",
    name: "Pensnett High St Express",
    region: "England",
    country: "GB",
    uuid: "bec1cdc7-898d-4e45-a97d-3aff809c9706",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6707",
    name: "Kensal Rise Chamberlayne Rd Express",
    region: "England",
    country: "GB",
    uuid: "49d420c7-4e16-41e2-ba85-175b959a24ef",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6708",
    name: "Dundee Nethergate Express",
    region: "Scotland",
    country: "GB",
    uuid: "97955fbc-a018-4d8f-a69a-45fd97667754",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6709",
    name: "Deptford Express",
    region: "England",
    country: "GB",
    uuid: "9af66d5e-e313-42f5-be15-8dd1a1555b47",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6711",
    name: "Liverpool Leathers Ln Express",
    region: "England",
    country: "GB",
    uuid: "9aa02376-89ce-4a58-92ec-155acc08de92",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6715",
    name: "Gateshead Express",
    region: "England",
    country: "GB",
    uuid: "2b4af1f3-1378-4315-ae18-e73a328f9a23",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6716",
    name: "Goose Pub Kingswin Express",
    region: "England",
    country: "GB",
    uuid: "6a127d5a-0b02-4cbf-a6f8-a98a2e6d4a38",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6719",
    name: "Sudbury Express",
    region: "England",
    country: "GB",
    uuid: "b102f237-2c18-4710-85e0-ef6807eec438",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6720",
    name: "Princess Dr Express",
    region: "England",
    country: "GB",
    uuid: "14e92f4f-ae4b-4a9c-8a91-c720c95f2dd2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6724",
    name: "Chelmsford Marsham Arms Express",
    region: "England",
    country: "GB",
    uuid: "f0304fd9-5ff7-4efe-b98a-85e705e6efa3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6727",
    name: "Bradmore Express",
    region: "England",
    country: "GB",
    uuid: "de07d9fe-8e78-4916-adf8-5f6bb7280625",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6728",
    name: "Caerphilly Brynhyfryd Rd Express",
    region: "Wales",
    country: "GB",
    uuid: "6ca768d1-f37f-4ee8-96cc-66dee6982bc6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "6731",
    name: "Hillhouse Express",
    region: "Scotland",
    country: "GB",
    uuid: "54e3d635-f1b2-411b-9a5c-191e9b6808a9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6734",
    name: "Westbury On Trym Express",
    region: "England",
    country: "GB",
    uuid: "1196b58a-e59a-470f-a2fa-fef4a6ca04e8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6737",
    name: "Halifax School Ln Express",
    region: "England",
    country: "GB",
    uuid: "ea71bffa-6327-4b9c-bcbd-0d92d0f72569",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6738",
    name: "Walton Hersham Rd Express",
    region: "England",
    country: "GB",
    uuid: "b845a6a5-618b-436d-922b-8bdef5a8af33",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6739",
    name: "Welwyn Garden City Express",
    region: "England",
    country: "GB",
    uuid: "0c2f7b73-61f5-406c-b885-12e11a4498df",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6740",
    name: "Marine Wharf Express",
    region: "England",
    country: "GB",
    uuid: "d20d766f-8ce9-4b1f-b7af-1100d01189e9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6741",
    name: "Willenhall Rd Express",
    region: "England",
    country: "GB",
    uuid: "89ba6802-fc58-4eb3-9f40-2272985406d3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6742",
    name: "Windsor Express",
    region: "England",
    country: "GB",
    uuid: "3b595093-4a09-4d34-9b82-2bc2885dbfb0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6743",
    name: "Stanningley Half Mile Ln Express",
    region: "England",
    country: "GB",
    uuid: "0fcb5bae-622c-4100-a024-17193024f4d9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6753",
    name: "WATFORD LANGLEY EXP",
    region: "England",
    country: "GB",
    uuid: "7b238edd-975b-4a60-a95a-7f337e164b6e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6754",
    name: "Cardiff Countisbury Express",
    region: "Wales",
    country: "GB",
    uuid: "88b643ee-4cff-4dcf-81ba-a0542ffc1757",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "WLS",
  },
  {
    id: "6755",
    name: "GLASGOW GT WESTRN EXP",
    region: "Scotland",
    country: "GB",
    uuid: "7cd71832-8bc0-461a-9a39-346c142e4090",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6756",
    name: "Mill Ln Express",
    region: "England",
    country: "GB",
    uuid: "eee530a1-f7d1-4730-8efc-b3b4c34912d0",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6759",
    name: "East Kilbride Express",
    region: "Scotland",
    country: "GB",
    uuid: "3f1644e9-4f45-47d1-af8b-872d6a5d36ed",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6760",
    name: "Woodside Express",
    region: "Scotland",
    country: "GB",
    uuid: "44160bab-7d06-4234-92a3-7a86f1810abe",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6761",
    name: "Shiremoor Cobalt Express",
    region: "England",
    country: "GB",
    uuid: "9d4b013a-18d8-45d2-96eb-ad879cd69f59",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6763",
    name: "TOOTING LONDON RD EXP",
    region: "England",
    country: "GB",
    uuid: "aa7da08d-07dc-48f7-944b-303b60277069",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6765",
    name: "Croydon Saffron Square Express",
    region: "England",
    country: "GB",
    uuid: "72a8fb76-d810-40cb-95cc-77aca0320f72",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6767",
    name: "Liverpool Dale St Express",
    region: "England",
    country: "GB",
    uuid: "f2eef099-f58f-40cb-a23e-8a4d2509e4d4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6772",
    name: "Fazakerley Longmoor Express",
    region: "England",
    country: "GB",
    uuid: "c5c57387-4669-440d-900f-a923d6aca387",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6774",
    name: "Ashford High St Express",
    region: "England",
    country: "GB",
    uuid: "aa6d6abd-fe95-4002-8ec7-70180d5bd7a6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6776",
    name: "Dagenham Oxlow Ln Express",
    region: "England",
    country: "GB",
    uuid: "b8616d76-58a0-46de-8cfd-a011f18a13f5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6777",
    name: "KIDDERMINSTER S R EXP",
    region: "England",
    country: "GB",
    uuid: "d05d31a6-947d-4e1b-a0d9-e9f831e301d1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6779",
    name: "Welling Upper Wickham Express",
    region: "England",
    country: "GB",
    uuid: "d367227a-d6d1-4b28-a59d-bb85a79175a6",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6781",
    name: "Corby Oakley Rd Extra",
    region: "England",
    country: "GB",
    uuid: "7cc87eb0-c678-4f76-92eb-d21a2c8cb148",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6782",
    name: "Leicester Lutterworth Express",
    region: "England",
    country: "GB",
    uuid: "a4155994-f9f0-40ad-bf96-2d7adfa75fc8",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6787",
    name: "Clerkenwell Central St Express",
    region: "England",
    country: "GB",
    uuid: "9579721a-44f0-4b4c-89b6-aeea4d3d6dfc",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6789",
    name: "Poole Ringwood Rd Express",
    region: "England",
    country: "GB",
    uuid: "962f647e-751f-4bc5-9ef6-23f99f7ec145",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6790",
    name: "Summerstown Garratt Express",
    region: "England",
    country: "GB",
    uuid: "0c3a0cf1-423d-4adb-afd3-b1f3c043510b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6792",
    name: "Gloucester Witcombe Express",
    region: "England",
    country: "GB",
    uuid: "d0209cb7-3d70-4361-850a-913998a1a780",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6795",
    name: "Eastleigh Bishopstoke Express",
    region: "England",
    country: "GB",
    uuid: "97c273f1-9888-43f8-ac10-43b40ebb557e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6797",
    name: "Prestatyn Superstore",
    region: "Wales",
    country: "GB",
    uuid: "7a976660-bce5-4fd8-b7b8-52b2d16ae930",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "6798",
    name: "Barnsley Huddersfield Rd Express",
    region: "England",
    country: "GB",
    uuid: "08fbb235-9864-4476-9e9a-2e8f376737d3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6799",
    name: "Sale Moor Norris Express",
    region: "England",
    country: "GB",
    uuid: "382c0811-227b-44e9-9c78-245b56277b5a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6803",
    name: "New North Rd Express",
    region: "England",
    country: "GB",
    uuid: "a4e56846-d822-49e2-93d4-73af2579741b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6809",
    name: "Telford Hadley Centre Express",
    region: "England",
    country: "GB",
    uuid: "fabad701-7052-4919-a55c-ae8290662298",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6810",
    name: "Gateshead Trinity Square Extra",
    region: "England",
    country: "GB",
    uuid: "ae021829-a1f5-451d-a15e-53b9dc183479",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6811",
    name: "Havers Ln Express",
    region: "England",
    country: "GB",
    uuid: "8c6663ad-d7bc-4f09-8dd1-3cca1beb659e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6813",
    name: "Southampton Witts Express",
    region: "England",
    country: "GB",
    uuid: "5d318f9d-546e-4b5f-99d7-125d4f20dd3b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6814",
    name: "Kings Lynn Extra",
    region: "England",
    country: "GB",
    uuid: "9b14dc73-ed6c-47f0-a27b-9ae88f314ed7",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6816",
    name: "Sheringham Cromer Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "2aaac42a-83e7-4e69-8a63-24c2eaf0d0cd",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6817",
    name: "High Wycombe Hatters Ln Express",
    region: "England",
    country: "GB",
    uuid: "c7647b08-d66d-4a0b-8513-625d030fbd9e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6818",
    name: "Oxford Rd Express",
    region: "England",
    country: "GB",
    uuid: "0b952b61-6148-4773-aff7-46ebd00ccf3a",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6819",
    name: "Gloucester Southgate Express",
    region: "England",
    country: "GB",
    uuid: "e551441d-266d-4cc3-96f6-238ec3642057",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6820",
    name: "ASHFORD STAINES EXP",
    region: "England",
    country: "GB",
    uuid: "4fa3ce8f-06f4-4e8f-bc22-192169addf2d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6824",
    name: "Great Northern Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "2f446e52-98f6-418a-a19e-3f24e7963b2e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6826",
    name: "Edgware Glengall Rd Express",
    region: "England",
    country: "GB",
    uuid: "1595f7db-b6cb-4233-bc00-741815e4f618",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6827",
    name: "Old Rd Express",
    region: "England",
    country: "GB",
    uuid: "d3d385d4-f0a3-4967-9535-7d800ae6bedd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6830",
    name: "Hythe Langdown Lawn Express",
    region: "England",
    country: "GB",
    uuid: "ba212f1e-d07c-4951-aa9f-1fbb0aea7874",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6832",
    name: "Luton Eaton Green Express",
    region: "England",
    country: "GB",
    uuid: "483cb6d0-07d3-4485-b721-9a2cb82f3dec",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6834",
    name: "Reading Rd Express",
    region: "England",
    country: "GB",
    uuid: "96ca1943-c799-4df8-b52c-3d5f029b7ff7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6835",
    name: "Canterbury Rd Express",
    region: "England",
    country: "GB",
    uuid: "e27594c1-75ce-4b7d-8a6d-43ca10a0b5cf",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6837",
    name: "North Kensington Express",
    region: "England",
    country: "GB",
    uuid: "7cb503d7-a099-45a7-a439-a8eb5b7744a5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6840",
    name: "Southampton Thorn Express",
    region: "England",
    country: "GB",
    uuid: "13551681-1a1d-4a89-9d37-ee969e311dc9",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6843",
    name: "Sydenham Rd Express",
    region: "England",
    country: "GB",
    uuid: "87100858-e9c3-4d57-9fa7-ec5e661e9ce1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6845",
    name: "Tottenham W Green Express",
    region: "England",
    country: "GB",
    uuid: "4b5f443f-d5e2-4cba-9b52-3e08823a06d2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6850",
    name: "Stenhouse Place Express",
    region: "Scotland",
    country: "GB",
    uuid: "bff948b8-be8c-4b58-9e09-3c50f0aa6228",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6851",
    name: "Herne Hill Express",
    region: "England",
    country: "GB",
    uuid: "e39ba2e2-1852-408c-a1dd-cdf9e612c401",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6852",
    name: "Hurst Rd Express",
    region: "England",
    country: "GB",
    uuid: "3325b1ea-e9b3-4dad-bf26-e43a964809b5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6853",
    name: "Chesterfield Whittington Express",
    region: "England",
    country: "GB",
    uuid: "376b89ce-a80d-4a55-81c9-b6bbfadfa4ad",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6854",
    name: "Dominion Express",
    region: "England",
    country: "GB",
    uuid: "cfbdfd2a-60d1-4052-a84c-c908b37fb7fb",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6856",
    name: "Marsh Bellows Rd Express",
    region: "England",
    country: "GB",
    uuid: "91c42fa9-de76-4b07-8840-7e368d96713b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6858",
    name: "Cannock Stafford Express",
    region: "England",
    country: "GB",
    uuid: "54ab3e0b-228b-4f60-80cb-c467b4f54df2",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6864",
    name: "Stoddard St Express",
    region: "England",
    country: "GB",
    uuid: "6ac464a3-222b-4c12-8c81-83af9c83f43d",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6868",
    name: "Dundalk Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "f110ec8f-8296-46af-8f63-4dc58d900ee7",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "6869",
    name: "Gorey Extra",
    region: "Irish Republic",
    country: "IE",
    uuid: "29572f9e-fc40-440b-85e4-891b4fbe27f4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "IE",
  },
  {
    id: "6871",
    name: "Edinburgh Dundas Express",
    region: "Scotland",
    country: "GB",
    uuid: "be30ddab-8acd-4113-9c05-c0be1fbe2192",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6872",
    name: "Rockbank Place Express",
    region: "Scotland",
    country: "GB",
    uuid: "b4659479-b401-42db-9ac6-80d66d10ccba",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6876",
    name: "Willenhall High Rd Express",
    region: "England",
    country: "GB",
    uuid: "3f3f10a6-c1cc-41b8-9d2b-4a9ae433c33f",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6880",
    name: "Oxford London Rd Express",
    region: "England",
    country: "GB",
    uuid: "3599bb9b-74aa-467b-adf5-514a82f1bfdd",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6893",
    name: "Rosewell Rd Express",
    region: "Scotland",
    country: "GB",
    uuid: "dfbae4aa-80a8-48e7-a34a-9f62901c62de",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "SCT",
  },
  {
    id: "6913",
    name: "CROYDON DOTCOM AREA 2",
    region: "England",
    country: "GB",
    uuid: "5ab45340-df5e-4ea4-8494-5ea97ffed4b5",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6914",
    name: "CROYDON DOTCOM AREA 3",
    region: "England",
    country: "GB",
    uuid: "7e9bb7de-cd52-4202-b753-ee42721935e3",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6915",
    name: "CROYDON DOTCOM AREA 4",
    region: "England",
    country: "GB",
    uuid: "d210f730-f721-4aca-a8b8-2637a57fd16d",
    services: {
      collect: true,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6916",
    name: "CROYDON DOTCOM AREA 5",
    region: "England",
    country: "GB",
    uuid: "9dae8440-63e7-404c-923f-ef258fcb3371",
    services: {
      collect: true,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6918",
    name: "CROYDON DOTCOM AREA 7",
    region: "England",
    country: "GB",
    uuid: "b311303c-80f6-4e9a-9f97-9211817d5ec1",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6919",
    name: "CROYDON DOTCOM AREA 8",
    region: "England",
    country: "GB",
    uuid: "8f6c4508-5e64-4251-b882-765af38fbca2",
    services: {
      collect: true,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6981",
    name: "Bromley High St Express",
    region: "England",
    country: "GB",
    uuid: "e8859f5e-e629-4119-b860-e8601e480dac",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6982",
    name: "Flamstead End Rd Express",
    region: "England",
    country: "GB",
    uuid: "eb45c24b-c900-468f-88be-7f0f90527d71",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "6997",
    name: "Tesco Erith CFC",
    region: "England",
    country: "GB",
    uuid: "17ba8767-bd3f-40c6-bb0b-edda1f1c4cf2",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6999",
    name: "Dorking Reigate Rd Express",
    region: "England",
    country: "GB",
    uuid: "09f939cb-5f9f-49a0-8db4-9b96e4307579",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "2489",
    name: "Elgin Extra",
    region: "Scotland",
    country: "GB",
    uuid: "b77d5769-f0fc-4ef2-877b-bd4eb1e9b9fb",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6254",
    name: "Buckie Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "025c76dc-5bbc-405a-8389-16b6ec1d2396",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6285",
    name: "Inverness Ness Side Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "f3e99bbd-c013-4e01-adfd-739c34f536bb",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2533",
    name: "Forfar Castle St Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "0240cbb8-0c1b-4bf7-931f-e6eeb73a1f36",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "3005",
    name: "Edinburgh Rd Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "1904644d-c051-40b0-9a59-05f1b9ec6bb7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "3004",
    name: "Penicuik Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "eb422966-b586-4e4f-b1b0-beb663944fa7",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "3214",
    name: "South Queensferry Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "468816c6-c12c-4c31-a7b4-addf72d3afa7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5466",
    name: "North Berwick Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "8f21b876-52e0-4b43-a142-ea205eb70821",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2582",
    name: "Greenock Extra",
    region: "Scotland",
    country: "GB",
    uuid: "5a01e919-ebe9-4ecd-a3cc-bc8daa3aa0bb",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "3113",
    name: "Renfrew Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "ee9090df-240a-4a67-8a66-12f3e88408c9",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "4684",
    name: "UFC Rutherglen",
    region: "Scotland",
    country: "GB",
    uuid: "e70e6469-8788-45f3-9f62-b92220920d91",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5030",
    name: "Kilbirnie Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "7c28b6e9-5616-4649-b311-e3e7afb8c007",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5968",
    name: "Kilmarnock Extra",
    region: "Scotland",
    country: "GB",
    uuid: "08231503-491b-488b-8341-85f62150aa2a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5454",
    name: "Lockerbie Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "f4c0e829-b77d-4413-b0ef-061ee7158ac4",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5969",
    name: "Dumfries Peel Centre Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "508ced84-f27e-43d0-80a3-1b0c34a0e6bd",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6003",
    name: "Bellshill Extra",
    region: "Scotland",
    country: "GB",
    uuid: "37c0b10e-fc37-4b1f-8777-497f922044a2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6284",
    name: "Lesmahagow Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "ab375cfa-b623-485d-9ddf-b9392c93b27c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2278",
    name: "Chester-le-street Superstore",
    region: "England",
    country: "GB",
    uuid: "acab33c9-039b-41c1-94c1-d6437f3de093",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4358",
    name: "Consett Genesis Extra",
    region: "England",
    country: "GB",
    uuid: "24b67450-652b-4d6f-887e-6871c4e2b125",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5108",
    name: "Redcar Superstore",
    region: "England",
    country: "GB",
    uuid: "568ccbd7-6e0f-4f52-a03a-e96c2b4d5135",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4686",
    name: "UFC Horwich",
    region: "England",
    country: "GB",
    uuid: "8a5e0061-4a50-4078-93cb-d8b8ed483582",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4687",
    name: "UFC BP",
    region: "England",
    country: "GB",
    uuid: "ab0ef13b-48f6-4ce0-88e5-49e8721ce456",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2149",
    name: "Bridlington Superstore",
    region: "England",
    country: "GB",
    uuid: "03f9948b-8565-42ae-928a-0685b8e667ed",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2593",
    name: "Goole Boothferry Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "b860338c-c831-4177-98de-5ba11de7781c",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3154",
    name: "Selby Superstore",
    region: "England",
    country: "GB",
    uuid: "fbbeaf21-48de-42e3-95a6-575dec85314c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5302",
    name: "York Market Weighton Superstore",
    region: "England",
    country: "GB",
    uuid: "c44a8efe-4db3-4371-b924-a9c219599fdf",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2418",
    name: "Doncaster Edenthorpe Superstore",
    region: "England",
    country: "GB",
    uuid: "e2d68385-4796-4c3e-aab8-3c7f0bf11d47",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3347",
    name: "Rotherham Wath-upon-dearne Extra",
    region: "England",
    country: "GB",
    uuid: "b1e87ff9-6353-41c5-8a67-9764a7720093",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4762",
    name: "Mablethorpe Superstore",
    region: "England",
    country: "GB",
    uuid: "794a0984-8303-4cd7-bbd9-478dce489841",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5106",
    name: "Sheffield Infirmary Superstore",
    region: "England",
    country: "GB",
    uuid: "9d177fda-237a-4db3-a552-a81be427905c",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2571",
    name: "Glossop Superstore",
    region: "England",
    country: "GB",
    uuid: "ebdbe996-0da5-4536-826e-5ab021cf93bf",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5892",
    name: "Greenfield Superstore",
    region: "England",
    country: "GB",
    uuid: "71a6f1c1-7df3-4e05-b29b-44fb614a81aa",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2543",
    name: "Formby Superstore",
    region: "England",
    country: "GB",
    uuid: "48cd997f-7560-4546-9e1b-f63eeb92b9ac",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2700",
    name: "Hove Superstore",
    region: "England",
    country: "GB",
    uuid: "e6429505-b945-4699-b256-1686e291ceae",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2701",
    name: "Wigan Hindley Extra",
    region: "England",
    country: "GB",
    uuid: "71319efe-b555-4a38-827e-a10c7da8b067",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2993",
    name: "Liverpool Old Swan Superstore",
    region: "England",
    country: "GB",
    uuid: "5b9d28cb-9508-46ac-9752-5323e6925fcc",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3420",
    name: "Liverpool Woolton Superstore",
    region: "England",
    country: "GB",
    uuid: "79171538-5a66-4487-9602-982c66db1680",
    services: {
      collect: true,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3422",
    name: "Woodford Green Superstore",
    region: "England",
    country: "GB",
    uuid: "e0f3c52d-d843-4fd8-8073-beac7a68d1cd",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5127",
    name: "Deysbrook Barracks Superstore",
    region: "England",
    country: "GB",
    uuid: "4db260f7-66e0-44fa-86df-d80b89125be1",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5148",
    name: "Ormskirk Burscough Bridge Superstore",
    region: "England",
    country: "GB",
    uuid: "d0f5822a-5f3c-418c-bba2-ca95c739aa20",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5301",
    name: "Litherland Superstore",
    region: "England",
    country: "GB",
    uuid: "32c34eb2-bb07-4d5c-994e-4c69c9a4a44c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5325",
    name: "Quinton Superstore",
    region: "England",
    country: "GB",
    uuid: "0a8056c5-b869-412f-be03-f54748fcb02d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2002",
    name: "Abergele Superstore",
    region: "Wales",
    country: "GB",
    uuid: "821a0368-054c-4e05-9304-d316f25fcd5e",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2261",
    name: "Chester Superstore",
    region: "England",
    country: "GB",
    uuid: "4b0be3d7-a833-4ac6-83bc-dd37353d7150",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5303",
    name: "Ruthin Superstore",
    region: "Wales",
    country: "GB",
    uuid: "199757bc-7ddc-4ef0-9898-546f2a5e354c",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "5304",
    name: "Holywell Superstore",
    region: "Wales",
    country: "GB",
    uuid: "4195cd89-5c3d-4ece-94f3-aab69c6f7fe0",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "5938",
    name: "Ellesmere Superstore",
    region: "England",
    country: "GB",
    uuid: "3a0131f5-ba86-42b6-a0b8-1a0b5a4b4aa7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6208",
    name: "Welshpool Superstore",
    region: "Wales",
    country: "GB",
    uuid: "b71ed226-b1b6-48fb-8ccf-55b59263ab8f",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2909",
    name: "Merthyr Tydfil Extra",
    region: "Wales",
    country: "GB",
    uuid: "c06e4e3e-5acc-4767-8025-cd5ca4cc817b",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3017",
    name: "Pembroke Dock Superstore",
    region: "Wales",
    country: "GB",
    uuid: "f288f281-77af-4c06-acaf-81cc82cda41a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3241",
    name: "Swansea Marina Superstore",
    region: "Wales",
    country: "GB",
    uuid: "0c441568-5bcd-4b7d-b2fb-31a6eaf3711d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "5948",
    name: "Caerphilly Crossways Superstore",
    region: "Wales",
    country: "GB",
    uuid: "105b945f-f278-4bf3-a74d-53561698229e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "6191",
    name: "Llandrindod Wells Superstore",
    region: "Wales",
    country: "GB",
    uuid: "fb544289-3257-4f7d-ac01-39ae33eaedc3",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "6460",
    name: "Pontarddulais Superstore",
    region: "Wales",
    country: "GB",
    uuid: "d40c3bfe-ccca-45fe-b70a-b632a5a9f2a5",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2006",
    name: "Abertillery Superstore",
    region: "Wales",
    country: "GB",
    uuid: "fc2bde98-73c5-4356-a45a-3a4de1da8174",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3027",
    name: "Pontypool Superstore",
    region: "Wales",
    country: "GB",
    uuid: "fbdd4af1-2999-4a17-8c89-1836e2a62f59",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3144",
    name: "St Mellons Superstore",
    region: "Wales",
    country: "GB",
    uuid: "fe24821a-e0d2-4f43-88c0-1256e451b41e",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "5421",
    name: "Culverhouse Cross Extra",
    region: "Wales",
    country: "GB",
    uuid: "56bc5ad0-84f0-4b75-9db1-bedb3a376396",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2170",
    name: "Burton Upon Trent Superstore",
    region: "England",
    country: "GB",
    uuid: "0da0b77a-2a16-44f6-8f9d-b61e49155364",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2343",
    name: "Congleton Superstore",
    region: "England",
    country: "GB",
    uuid: "81b71abc-4a99-488d-866f-fe171a8d4572",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3412",
    name: "High Peak Whaley Bridge Superstore",
    region: "England",
    country: "GB",
    uuid: "f68b5028-e04f-43c4-bd65-9f86a896b288",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5503",
    name: "Willenhall Superstore",
    region: "England",
    country: "GB",
    uuid: "175540bc-18f5-4cb0-a8e1-f03632406034",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2995",
    name: "Newark New Ollerton Superstore",
    region: "England",
    country: "GB",
    uuid: "277ba12c-770b-4e26-a316-ce31f90ce16c",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2624",
    name: "Hall Green Superstore",
    region: "England",
    country: "GB",
    uuid: "bd4386a5-5064-4c60-8022-14bfbb6b5414",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4838",
    name: "UFC WB",
    region: "England",
    country: "GB",
    uuid: "0a9e15d2-366d-4893-88e8-b896d69bd6b6",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6227",
    name: "Birmingham Springhill Superstore",
    region: "England",
    country: "GB",
    uuid: "e9a300aa-486d-471e-9d90-64b191f0f2bb",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2124",
    name: "Brackley Superstore",
    region: "England",
    country: "GB",
    uuid: "bd43d02f-f807-4a1a-aaf2-a3604289c249",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2547",
    name: "Flitwick Superstore",
    region: "England",
    country: "GB",
    uuid: "4e2fc81b-a623-4c0f-b78d-6759c0301257",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2393",
    name: "Downham Market Superstore",
    region: "England",
    country: "GB",
    uuid: "0796e7d2-fe2e-4dc7-97ff-fd8411350e2a",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2698",
    name: "Spalding Holbeach Superstore",
    region: "England",
    country: "GB",
    uuid: "eae90e79-7788-4071-af47-31e1f46ea473",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2978",
    name: "Oakham Superstore",
    region: "England",
    country: "GB",
    uuid: "85b3bf20-077e-42ce-a112-c5fd83a14558",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3164",
    name: "Sleaford Superstore",
    region: "England",
    country: "GB",
    uuid: "50529fb7-c0da-476d-b79b-1f95860f437e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4685",
    name: "UFC Bar Hill",
    region: "England",
    country: "GB",
    uuid: "8ef04a93-3f4d-4e33-aa17-0164f661186e",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5292",
    name: "Ramsey Superstore",
    region: "England",
    country: "GB",
    uuid: "6a39cd14-357e-474c-bbac-f70b529aa8e7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6796",
    name: "Sandy Superstore",
    region: "England",
    country: "GB",
    uuid: "db0ef3b8-d925-47de-8d44-9e280978fc6d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3373",
    name: "Watton Superstore",
    region: "England",
    country: "GB",
    uuid: "93084c40-8077-4f38-af96-de7eaff82f77",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4394",
    name: "Swaffham Superstore",
    region: "England",
    country: "GB",
    uuid: "ab67dfa9-31fd-4692-9257-eaaced6f1725",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5120",
    name: "Fakenham Superstore",
    region: "England",
    country: "GB",
    uuid: "39b82051-260b-41ee-8099-e8485c91ade2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5123",
    name: "Beccles Superstore",
    region: "England",
    country: "GB",
    uuid: "bfd6c7e3-2381-4a96-a004-9b1ec8fe96bf",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2167",
    name: "Bishops Cleeve Superstore",
    region: "England",
    country: "GB",
    uuid: "cee44d3f-05b9-47cf-a635-41b96cc7790e",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3200",
    name: "Stroud Superstore",
    region: "England",
    country: "GB",
    uuid: "0e18ac7f-8ee3-4bad-adaa-04d3e1777542",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3202",
    name: "Stalybridge Superstore",
    region: "England",
    country: "GB",
    uuid: "64f41d81-9139-4c61-a4b7-5051947347e8",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3279",
    name: "Tetbury Superstore",
    region: "England",
    country: "GB",
    uuid: "4710c5da-0d41-4c3d-b02b-13d92d5da1b6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5299",
    name: "Tidworth Superstore",
    region: "England",
    country: "GB",
    uuid: "ea249ac3-958a-4a61-9792-f0db30ed52d7",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2469",
    name: "Epping Superstore",
    region: "England",
    country: "GB",
    uuid: "29ed1c53-7c54-41a5-a0af-1f4347af18ad",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3107",
    name: "Romford Extra",
    region: "England",
    country: "GB",
    uuid: "ec38542d-a9a7-4da3-a119-de38fce1956b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4768",
    name: "UFC Lakeside",
    region: "England",
    country: "GB",
    uuid: "0098beea-7de3-4ebf-9f8b-9ac26806d2e3",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4852",
    name: "Clayton Square Express",
    region: "England",
    country: "GB",
    uuid: "b0e087ef-eb3d-4d74-85fb-f8653797023e",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: true,
    },
    subdivision: "ENG",
  },
  {
    id: "4858",
    name: "Spoke Borehamwood",
    region: "England",
    country: "GB",
    uuid: "41db76ca-6740-4f20-8ed4-0ca38364beb4",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2642",
    name: "Bulls Bridge Extra",
    region: "England",
    country: "GB",
    uuid: "2be5d42e-2495-4b04-bca2-514dd9eb4233",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3032",
    name: "Enfield Ponders End Extra",
    region: "England",
    country: "GB",
    uuid: "a689023c-07c8-4e7c-a7b6-c1e783e2b81c",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4882",
    name: "Spoke Bromley By Bow",
    region: "England",
    country: "GB",
    uuid: "c0629ebb-79af-45bc-a9f3-1d45a37c547b",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2143",
    name: "Brixton Superstore",
    region: "England",
    country: "GB",
    uuid: "74aea1a5-7619-48e1-b33e-b99aeec0bc91",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4756",
    name: "Kennington Superstore",
    region: "England",
    country: "GB",
    uuid: "9235a12d-e7de-4cd2-bf22-5242b44b6e09",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6163",
    name: "Yiewsley Superstore",
    region: "England",
    country: "GB",
    uuid: "5f5d81ef-d000-439b-bfb5-19a233e83ff6",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2526",
    name: "Faversham Superstore",
    region: "England",
    country: "GB",
    uuid: "6b78db6b-3f4a-4a2c-8943-678cb70a8bf4",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2855",
    name: "Lydney High St Superstore",
    region: "England",
    country: "GB",
    uuid: "ad46d9ab-9623-452a-a4d6-25e2641c6705",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2857",
    name: "Aylesford Lunsford Park Extra",
    region: "England",
    country: "GB",
    uuid: "e8360e47-0b1a-45fb-a083-44d333e52614",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2903",
    name: "Maidstone Tovil Superstore",
    region: "England",
    country: "GB",
    uuid: "59b6a2d8-6fc9-4076-8109-2b988e2dd2fc",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5337",
    name: "Hailsham Superstore",
    region: "England",
    country: "GB",
    uuid: "5047aaf7-f729-4c4e-aef3-d92667c3081b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3015",
    name: "Petersfield Superstore",
    region: "England",
    country: "GB",
    uuid: "568bf556-3756-4123-b4b0-57d97ad2f92d",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4879",
    name: "Spoke Purley",
    region: "England",
    country: "GB",
    uuid: "3eb45de2-55ed-4e3e-81ca-418133a15f66",
    services: {
      collect: false,
      delivery: false,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2695",
    name: "Hythe Superstore",
    region: "England",
    country: "GB",
    uuid: "1ccb07a7-db0a-428d-b6fc-c2cebc28fcd2",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3384",
    name: "Shaftesbury Superstore",
    region: "England",
    country: "GB",
    uuid: "34ff0dd5-bda2-4fb4-892b-aeb9348a57ee",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4691",
    name: "Freshwater Superstore",
    region: "England",
    country: "GB",
    uuid: "446a7052-18c9-4487-b271-8128f10c2617",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6295",
    name: "Portland Easton Superstore",
    region: "England",
    country: "GB",
    uuid: "2db5965e-3f5a-4050-98cc-56febde1491b",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2048",
    name: "Axminster Superstore",
    region: "England",
    country: "GB",
    uuid: "df4f7ad1-1769-4734-bf5e-e7963b78b617",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5442",
    name: "Ilminster Superstore",
    region: "England",
    country: "GB",
    uuid: "203bb696-4868-4625-9842-233eb9ce8385",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6293",
    name: "Keynsham Superstore",
    region: "England",
    country: "GB",
    uuid: "b092c396-da12-4fc8-b466-df63b9383297",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6645",
    name: "Glastonbury Superstore",
    region: "England",
    country: "GB",
    uuid: "4f7b792e-0b9f-4483-bec6-b9104db238b8",
    services: {
      collect: true,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6251",
    name: "Bideford Superstore",
    region: "England",
    country: "GB",
    uuid: "15743049-a688-4bbb-ad6d-827ef0440b75",
    services: {
      collect: true,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5999",
    name: "Tesco Croydon CFC",
    region: "England",
    country: "GB",
    uuid: "12679aec-fe4c-42cc-9532-c6be9b2f6114",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4665",
    name: "UFC Gallions Reach",
    region: "England",
    country: "GB",
    uuid: "07ebc6a0-c8af-49f4-aa0c-a3ca20eb5b42",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4731",
    name: "UFC King's Lynn",
    region: "England",
    country: "GB",
    uuid: "8af0e3ea-df06-4237-9d5b-2981f83a814d",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4732",
    name: "UFC Coventry Crosspoint",
    region: "England",
    country: "GB",
    uuid: "cfe1b5e0-4697-4c81-b03c-3af93aee4a0e",
    services: {
      collect: true,
      delivery: true,
      says: false,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2017",
    name: "Addlestone Extra",
    region: "England",
    country: "GB",
    uuid: "1645dffc-9fe4-4772-b59b-410378c6e344",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2082",
    name: "Basildon Langdon Hills Superstore",
    region: "England",
    country: "GB",
    uuid: "a0e185c8-8db9-4013-8082-fb9d51366cf1",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2134",
    name: "Braintree Town Centre Superstore",
    region: "England",
    country: "GB",
    uuid: "c64a93e3-b22d-404b-b0d1-a20d15214701",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2188",
    name: "Billingham Superstore",
    region: "England",
    country: "GB",
    uuid: "948e39ec-eaa0-4ef0-9e4f-4d5a3dabfd53",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2201",
    name: "Brigg Superstore",
    region: "England",
    country: "GB",
    uuid: "fddaeab0-21c4-481c-aeb0-601331cb0a07",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2204",
    name: "Brighouse Bradford Rd Superstore",
    region: "England",
    country: "GB",
    uuid: "e593140a-1271-47ab-99a3-6fac46f24557",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2255",
    name: "Chard Superstore",
    region: "England",
    country: "GB",
    uuid: "1aabd66c-9a28-41ec-bed3-d07c1a5f7ba0",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2270",
    name: "Caterham Superstore",
    region: "England",
    country: "GB",
    uuid: "3abec81c-76cb-45bb-b8e7-35e7a7e77d2f",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2285",
    name: "Chesterfield Clowne Superstore",
    region: "England",
    country: "GB",
    uuid: "e1558827-8744-4208-a672-a29334794c27",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2352",
    name: "Houghton Le Spring",
    region: "England",
    country: "GB",
    uuid: "13101317-cc75-4ebe-9c3e-b8b61fa72037",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2412",
    name: "Atherstone Superstore",
    region: "England",
    country: "GB",
    uuid: "38cfb44f-4e3d-42c9-8393-533742d19396",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2454",
    name: "Egham Superstore",
    region: "England",
    country: "GB",
    uuid: "4afa2ae6-5ad4-4909-9a0c-128adb077afe",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2581",
    name: "Gloucester Superstore",
    region: "England",
    country: "GB",
    uuid: "424634fd-18a3-424c-99ea-476e726b6725",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2586",
    name: "Greenford Hoover Building Superstore",
    region: "England",
    country: "GB",
    uuid: "ae5eb33d-1e26-408e-9992-b3c1c69d9bce",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2672",
    name: "Wirral Heswall Superstore",
    region: "England",
    country: "GB",
    uuid: "a75bd3f0-8483-4d3b-8a57-e75c4302d9e6",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2777",
    name: "King's Lynn Gaywood Superstore",
    region: "England",
    country: "GB",
    uuid: "6882cd4e-fe5a-4f26-b4e1-d40823899cfd",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2802",
    name: "Langport Superstore",
    region: "England",
    country: "GB",
    uuid: "5f97b94d-a453-4ba7-831e-0246543e7343",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2822",
    name: "Lewes Superstore",
    region: "England",
    country: "GB",
    uuid: "8528f82d-86d2-4f39-8535-9ce45574e8bd",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2833",
    name: "Littlehampton Superstore",
    region: "England",
    country: "GB",
    uuid: "2af2cdea-ab52-4381-8901-86aeb9021a2e",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2889",
    name: "Cambridge Milton Superstore",
    region: "England",
    country: "GB",
    uuid: "19e11167-4088-4fb6-80a0-4597a3ee7512",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2896",
    name: "Milton Keynes Wolverton Superstore",
    region: "England",
    country: "GB",
    uuid: "307a6375-a8b7-40fc-847c-1ae7321c3ae3",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2905",
    name: "Minehead Superstore",
    region: "England",
    country: "GB",
    uuid: "82b9c386-617f-4edf-b923-5cef86873be6",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2967",
    name: "Northallerton Superstore",
    region: "England",
    country: "GB",
    uuid: "95b7c4dd-0f2c-4f96-94e4-3a9f391410a0",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3000",
    name: "Padstow Superstore",
    region: "England",
    country: "GB",
    uuid: "cc519cd9-0c4d-4948-857d-62791ba2fb29",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3007",
    name: "Pembury Superstore",
    region: "England",
    country: "GB",
    uuid: "91cf79e5-6e38-49f9-9091-42e719171f32",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3021",
    name: "Pontefract Superstore",
    region: "England",
    country: "GB",
    uuid: "dbbb3e7d-72f3-483c-8637-544013829d95",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3045",
    name: "Princes Risborough Superstore",
    region: "England",
    country: "GB",
    uuid: "913c3ea7-ea00-409c-832a-efa0866f9a54",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3112",
    name: "Ramsgate Manston Superstore",
    region: "England",
    country: "GB",
    uuid: "5fac9e68-24bf-463f-a698-c308c6dd59e2",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3129",
    name: "St Ives Superstore",
    region: "England",
    country: "GB",
    uuid: "3c5523bb-0354-4c8c-b15a-422b1002b407",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3195",
    name: "Stow-on-the-wold Superstore",
    region: "England",
    country: "GB",
    uuid: "7da43b80-af6c-4aa2-99a1-498be05f631f",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3245",
    name: "Norwich Stalham Superstore",
    region: "England",
    country: "GB",
    uuid: "ae9d3d48-9dbc-40c3-b024-e6fb446dc48e",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3255",
    name: "South Shields Superstore",
    region: "England",
    country: "GB",
    uuid: "ded7071d-a0f9-49e2-b339-ba51ba64a884",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3362",
    name: "Ware Superstore",
    region: "England",
    country: "GB",
    uuid: "7462155b-04d2-463e-89eb-2bf13fe464d5",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3396",
    name: "Atherton Superstore",
    region: "England",
    country: "GB",
    uuid: "d583e112-675f-445e-82c1-d3410dbfe91b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "3437",
    name: "Whitchurch Superstore",
    region: "England",
    country: "GB",
    uuid: "5674c803-93b9-4e8d-b68a-d2ec28e84a50",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4482",
    name: "Bolton Little Lever Superstore",
    region: "England",
    country: "GB",
    uuid: "c7e26b90-b4ce-4ebb-a9ae-dc232336ee6d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4643",
    name: "Tenbury Wells Superstore",
    region: "England",
    country: "GB",
    uuid: "781d17d8-c4d6-49ad-884f-bbc18ed14e53",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "4837",
    name: "Penwortham Superstore",
    region: "England",
    country: "GB",
    uuid: "9f6ea316-388b-4c23-afc2-46f76580471d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5109",
    name: "Ingleby Barwick Superstore",
    region: "England",
    country: "GB",
    uuid: "c87f0297-ca4d-4349-b074-cecbb3a9836d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5114",
    name: "Sheldon Superstore",
    region: "England",
    country: "GB",
    uuid: "14c61e0d-640f-4d6f-b19f-18575a43f04d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5122",
    name: "Clapham Superstore",
    region: "England",
    country: "GB",
    uuid: "c8b51f38-0746-4de1-963d-cd7bb64020b3",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5198",
    name: "Frodsham Helsby Superstore",
    region: "England",
    country: "GB",
    uuid: "ec9d7a2e-557f-4767-bb09-11ce2a07896b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5210",
    name: "Diss Superstore",
    region: "England",
    country: "GB",
    uuid: "db1a9ac5-d68d-4830-8262-f0c74036f720",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5327",
    name: "Highams Park Superstore",
    region: "England",
    country: "GB",
    uuid: "55a2113e-35bb-4ebf-a750-45f8be727d71",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5362",
    name: "Cradley Heath Extra",
    region: "England",
    country: "GB",
    uuid: "70382d4a-cfe0-45bd-bbb5-cf500c4291fe",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5597",
    name: "Leeds Bramley Superstore",
    region: "England",
    country: "GB",
    uuid: "a199988a-d6ec-4c82-b042-e74eeaae03f5",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5647",
    name: "Peterborough Werrington Superstore",
    region: "England",
    country: "GB",
    uuid: "3682f586-f76f-4b3d-9949-792d4182049b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5651",
    name: "Bromley Superstore",
    region: "England",
    country: "GB",
    uuid: "fb62b767-ce7b-48e0-8e53-666adc3a3351",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "5663",
    name: "Cullompton Superstore",
    region: "England",
    country: "GB",
    uuid: "30b6e0fd-f4e5-4b06-ae8a-0ec3c688bcbe",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6110",
    name: "Penistone Superstore",
    region: "England",
    country: "GB",
    uuid: "8ef02b5d-c74d-4592-9678-5c175832ae55",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6249",
    name: "Southam Superstore",
    region: "England",
    country: "GB",
    uuid: "9415f962-f072-4e05-b4f0-278d1a13b5c8",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6255",
    name: "Fareham Superstore",
    region: "England",
    country: "GB",
    uuid: "d2c08f27-b13c-4198-827d-b8a58093ae43",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6481",
    name: "Rugeley Superstore",
    region: "England",
    country: "GB",
    uuid: "8c2586d2-2955-415a-8ca6-003f484177b2",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6634",
    name: "Norwich Drayton Superstore",
    region: "England",
    country: "GB",
    uuid: "04c81383-d2bd-47a3-a5f4-535d77af4d4e",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6672",
    name: "Hednesford Superstore",
    region: "England",
    country: "GB",
    uuid: "6f66020b-b263-4350-90ef-154d2b609da4",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2474",
    name: "Ramsey Superstore IOM",
    region: "England",
    country: "GB",
    uuid: "8c03a802-deef-481a-af82-0dddc7a28b63",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "2481",
    name: "Peel Superstore IOM",
    region: "England",
    country: "GB",
    uuid: "77e58ca5-0cee-4dc3-81e8-2b0f27638b3b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "ENG",
  },
  {
    id: "6672",
    name: "Barry Superstore",
    region: "Wales",
    country: "GB",
    uuid: "ce6e41a0-7d65-445b-b569-df89b7088a4a",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2918",
    name: "Neath Abbey Rd Superstore",
    region: "Wales",
    country: "GB",
    uuid: "6d118405-4d9e-469a-b4c7-e304912f9926",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2481",
    name: "Bridgend Brewery Ln Superstore",
    region: "Wales",
    country: "GB",
    uuid: "63282d73-57bc-4562-b46a-2b530e4d687b",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "3057",
    name: "Porthmadog Superstore",
    region: "Wales",
    country: "GB",
    uuid: "01128ce5-6c36-452d-985b-597758d81f23",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "5029",
    name: "Swansea Pontardawe Superstore",
    region: "Wales",
    country: "GB",
    uuid: "d21752f0-15cc-4bbe-968e-3174867a2b1f",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "WLS",
  },
  {
    id: "2046",
    name: "Aviemore Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "9127568f-7835-451b-afbf-5a14a0dbf07d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2235",
    name: "Campbeltown Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "4eefcec3-5248-4b49-b96e-16fd43ee47d6",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2430",
    name: "Dunblane Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "fab127e3-5c94-4732-8347-c821f74e580d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2434",
    name: "Dundee Monifieth Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "cf927b53-3ed5-4e9f-8cad-2aa37693ae9c",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2756",
    name: "Inverness Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "cd3e2f4e-569c-4388-ad4a-9f5fd59272bc",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2796",
    name: "Kirkintilloch Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "938895ad-d490-43be-ac46-aee0b2e88277",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "3208",
    name: "Stranraer Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "18adf8b9-eebb-48de-ab9f-405aad82dcb7",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "4339",
    name: "Galston Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "ec0f6223-c2f5-48d1-877c-382c2daf861d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5181",
    name: "Falkirk Redding Rd Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "8a6b37b7-c109-43a9-aef0-e076e7aa3314",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5289",
    name: "Castle Douglas Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "2a1fd993-8194-462f-8f54-d2052a04578d",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5757",
    name: "Aberdeen South Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "550e6bc8-7d85-4954-a7bc-774709529078",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "5974",
    name: "Peebles Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "e3033dec-2796-4a15-b9ae-5b488802f9eb",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6237",
    name: "Burnside Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "465487a0-4e9a-477a-a4ba-360ac2a74e50",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "6279",
    name: "Leith Superstore",
    region: "Scotland",
    country: "GB",
    uuid: "f1c12d5b-8e6d-4080-b3fc-4eecc32917b6",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "SCT",
  },
  {
    id: "2057",
    name: "Banbridge Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "9958e609-0e7b-4494-86cb-bc622dcbe3ee",
    services: {
      collect: false,
      delivery: true,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2173",
    name: "Bangor Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "d80d5df1-ff4e-4f00-8912-21fe4e0ea819",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2834",
    name: "Lisburn Rd Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "ce861356-9066-4929-a908-c2b5fb4d6861",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "2922",
    name: "Newcastle County Down Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "0a9a7bc7-738c-4afe-b254-f0ae416190c3",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "3053",
    name: "Portadown Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "df3c7abf-e36e-4162-83ef-1134cd723bfd",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "3210",
    name: "Londonderry Strand Rd Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "339d67a9-03e5-4b41-8334-743a2b480146",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "3491",
    name: "Cookstown Broadfield Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "c1334ff1-8008-4ee7-a8b3-6c9a0d97af9f",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5136",
    name: "Carnegie St Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "0e5d0b5a-ab08-48f4-85fb-4b2214a35941",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5183",
    name: "Limavady Roevalley Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "4a254746-d93c-4e99-a5e9-1c161b333099",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5334",
    name: "Portstewart Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "1d22da4c-7806-4186-b4ea-7e8b835c5f2e",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5422",
    name: "Springhill Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "a11badfb-d6a2-455b-9a3d-fa30645cbbfa",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "5522",
    name: "Ballygomartin Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "ed51382b-30d8-4a97-8896-e135cab2c173",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "6452",
    name: "Castlereagh Rd Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "7f93c60f-fe2e-4fb4-886c-3a4b5399c6e5",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
  {
    id: "6596",
    name: "Magherafelt Superstore",
    region: "Northern Ireland",
    country: "GB",
    uuid: "13935852-d297-4faf-837b-4902c6c14ee4",
    services: {
      collect: false,
      delivery: false,
      says: true,
      whoosh: false,
    },
    subdivision: "NIR",
  },
];

export default allStores;
